/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(18)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_niege__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vuer_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // out of src, out boc

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Snow: __WEBPACK_IMPORTED_MODULE_0__vue_niege__["a" /* default */], Vuer: __WEBPACK_IMPORTED_MODULE_1__Vuer_vue__["a" /* default */] },
  mounted: function mounted() {
    console.log(this.$imgVuer);
  },
  data: function data() {
    return {
      showNews: false,
      list0_5: [],
      list1: [{ src: 'img/20190929HighFallsCreek/01-HighFalls.jpg' }, { src: 'img/20190929HighFallsCreek/02-HighFalls.jpg' }, { src: 'img/20190929HighFallsCreek/03-HighFalls.jpg' }, { src: 'img/20190929HighFallsCreek/04-HighFalls.jpg' }, { src: 'img/20190929HighFallsCreek/05-HighFalls.jpg' }, { src: 'img/20190929HighFallsCreek/06-HighFalls.jpg' }, { src: 'img/20190929HighFallsCreek/07-HighFalls.jpg' }],
      list2: [{ src: 'img/20190825Galiano/01-Galiano.jpg' }, { src: 'img/20190825Galiano/02-Galiano.jpg' }, { src: 'img/20190825Galiano/03-Galiano.jpg' }, { src: 'img/20190825Galiano/04-Galiano.jpg' }, { src: 'img/20190825Galiano/05-Galiano.jpg' }, { src: 'img/20190825Galiano/06-Galiano.jpg' }, { src: 'img/20190825Galiano/07-Galiano.jpg' }],
      list2_5: [{ src: 'img/20190901GoldCreekCanyon/01-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/02-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/03-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/04-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/05-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/06-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/07-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/08-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/09-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/10-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/11-Gold-Creek-Canyon.jpg' }, { src: 'img/20190901GoldCreekCanyon/12-Gold-Creek-Canyon.jpg' }],
      list3: [{ src: 'img/20191006LakeAnn/01-LakeAnn.jpg' }, { src: 'img/20191006LakeAnn/02-LakeAnn.jpg' }, { src: 'img/20191006LakeAnn/03-LakeAnn.jpg' }, { src: 'img/20191006LakeAnn/04-LakeAnn.jpg' }, { src: 'img/20191006LakeAnn/05-LakeAnn.jpg' }, { src: 'img/20191006LakeAnn/06-LakeAnn.jpg' }, { src: 'img/20191006LakeAnn/07-LakeAnn.jpg' }],
      list3_5: [{ src: 'img/20190817PtarmiganRidge/01-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/02-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/03-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/04-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/05-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/06-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/07-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/08-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/09-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/10-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/11-Ptarmigan-Ridge.jpg' }, { src: 'img/20190817PtarmiganRidge/12-Ptarmigan-Ridge.jpg' }],
      list7: [{ src: 'img/20190728DogMnt/01-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/02-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/03-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/04-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/05-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/06-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/07-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/08-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/09-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/10-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/11-Dog-Mt--Suicided-Bluffs.jpg' }, { src: 'img/20190728DogMnt/12-Dog-Mt--Suicided-Bluffs.jpg' }],
      list5: [{ src: 'img/01-Buntzen-Lake-1.jpg' }, { src: 'img/02-Buntzen-Lake-2.jpg' }, { src: 'img/03-Buntzen-Lake-3.jpg' }, { src: 'img/04-Buntzen-Lake-4.jpg' }, { src: 'img/05-Buntzen-Lake-5.jpg' }, { src: 'img/06-Buntzen-Lake-6.jpg' }, { src: 'img/07-Buntzen-Lake-7.jpg' }, { src: 'img/08-Buntzen-Lake-8.jpg' }, { src: 'img/09-Buntzen-Lake-9.jpg' }, { src: 'img/10-Buntzen-Lake-10.jpg' }, { src: 'img/11-Buntzen-Lake-11.jpg' }, { src: 'img/12-Buntzen-Lake-12.jpg' }],
      list6: [{ src: 'img/1-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/2-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/3-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/4-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/5-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/6-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/7-Lower Seymour-Lynn-Canyon-Loop.jpg' }, { src: 'img/8-Lower Seymour-Lynn-Canyon-Loop.jpg' }],
      list8: [{ src: 'img/20191013BroCreek/01-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/02-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/03-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/04-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/05-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/06-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/07-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/08-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/09-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/10-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/11-BrothersCreek.jpg' }, { src: 'img/20191013BroCreek/12-BrothersCreek.jpg' }],
      list9: [{ src: 'img/20191027BowenIsland/01-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/02-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/03-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/04-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/05-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/06-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/07-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/08-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/09-BowenIsland.jpg' }, { src: 'img/20191027BowenIsland/10-BowenIsland.jpg' }],
      list10: [{ src: 'img/20191103BadenPowell/01-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/02-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/03-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/04-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/05-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/06-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/07-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/08-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/09-Quarry_Rock_Trail.jpg' }, { src: 'img/20191103BadenPowell/10-Quarry_Rock_Trail.jpg' }],
      list11: [{ src: 'img/20191110TwoCanyonLoop/01-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/02-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/03-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/04-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/05-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/06-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/07-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/08-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/09-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/10-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/11-Two_Canyon_Loop.jpg' }, { src: 'img/20191110TwoCanyonLoop/12-Two_Canyon_Loop.jpg' }],
      list12: [{ src: 'img/20191124SlhaneyPeak/01-Slhaney-Peak.jpg' }, { src: 'img/20191124SlhaneyPeak/02-Slhaney-Peak.jpg' }, { src: 'img/20191124SlhaneyPeak/03-Slhaney-Peak.jpg' }, { src: 'img/20191124SlhaneyPeak/04-Slhaney-Peak.jpg' }, { src: 'img/20191124SlhaneyPeak/05-Slhaney-Peak.jpg' }, { src: 'img/20191124SlhaneyPeak/06-Slhaney-Peak.jpg' }],
      list13: [{ src: 'img/20191201NorvanFalls/01-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/02-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/03-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/04-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/05-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/06-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/07-Norvan_Falls.jpg' }, { src: 'img/20191201NorvanFalls/08-Norvan_Falls.jpg' }],
      list14: [{ src: 'img/20191208CheakamusCanyon/1-P4970363.jpg' }, { src: 'img/20191208CheakamusCanyon/2-P4970364.jpg' }, { src: 'img/20191208CheakamusCanyon/3-P4970370.jpg' }, { src: 'img/20191208CheakamusCanyon/4-P4970373.jpg' }, { src: 'img/20191208CheakamusCanyon/5-P4970375.jpg' }, { src: 'img/20191208CheakamusCanyon/6-P4970377.jpg' }, { src: 'img/20191208CheakamusCanyon/7-P4970379.jpg' }],
      list15: [{ src: 'img/20191226BbyMnt/01-BurnabyMountain.jpg' }, { src: 'img/20191226BbyMnt/02-BurnabyMountain.jpg' }, { src: 'img/20191226BbyMnt/03-BurnabyMountain.jpg' }, { src: 'img/20191226BbyMnt/04-BurnabyMountain.jpg' }, { src: 'img/20191226BbyMnt/05-BurnabyMountain.jpg' }],
      list16: [{ src: 'img/2020012BuntzenLake/01-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/02-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/03-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/04-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/05-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/06-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/07-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/08-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/09-Buntzen_Lake.jpg' }, { src: 'img/2020012BuntzenLake/10-Buntzen_Lake.jpg' }],
      list17: [{ src: 'img/20200202HollyburnPeak/01-HollyburnPeak.jpg' }, { src: 'img/20200202HollyburnPeak/02-HollyburnPeak.jpg' }, { src: 'img/20200202HollyburnPeak/03-HollyburnPeak.jpg' }],
      list18: [{ src: 'img/20200209BowenLookout/01-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/02-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/03-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/04-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/05-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/06-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/07-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/08-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/09-Bowen_Lookout.jpg' }, { src: 'img/20200209BowenLookout/10-Bowen_Lookout.jpg' }],
      list19: [{ src: 'img/20200215CaulifieldLightHouse/01-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/02-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/03-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/04-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/05-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/06-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/07-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/08-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/09-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/10-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/11-Caulfeild_and_Lighthouse_Park.jpg' }, { src: 'img/20200215CaulifieldLightHouse/12-Caulfeild_and_Lighthouse_Park.jpg' }],
      list20: [{ src: 'img/20200222EagleBluffs/01-20200222EagleBluffs.jpg' }, { src: 'img/20200222EagleBluffs/02-20200222EagleBluffs.jpg' }, { src: 'img/20200222EagleBluffs/03-20200222EagleBluffs.jpg' }, { src: 'img/20200222EagleBluffs/04-20200222EagleBluffs.jpg' }, { src: 'img/20200222EagleBluffs/05-20200222EagleBluffs.jpg' }, { src: 'img/20200222EagleBluffs/06-20200222EagleBluffs.jpg' }],
      list21: [{ src: 'img/20200308BlackMnt/1-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/2-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/3-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/4-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/5-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/6-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/7-Black_Mountain.jpg' }, { src: 'img/20200308BlackMnt/8-Black_Mountain.jpg' }],
      list21_5: [{ src: 'img/20200607BrohmLake/01-BrohmLake.jpg' }, { src: 'img/20200607BrohmLake/02-BrohmLake.jpg' }, { src: 'img/20200607BrohmLake/03-BrohmLake.jpg' }],
      list22: [{ src: 'img/20200614-Petgill-Lake/01-Petgill-Lake.jpg' }, { src: 'img/20200614-Petgill-Lake/02-Petgill-Lake.jpg' }, { src: 'img/20200614-Petgill-Lake/03-Petgill-Lake.jpg' }, { src: 'img/20200614-Petgill-Lake/04-Petgill-Lake.jpg' }, { src: 'img/20200614-Petgill-Lake/05-Petgill-Lake.jpg' }, { src: 'img/20200614-Petgill-Lake/06-Petgill-Lake.jpg' }],
      list23: [{ src: 'img/20200621-Lynn-Creek-n-Seymour-River/01-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/02-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/03-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/04-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/05-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/06-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/07-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/08-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/09-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/10-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/11-Lynn_n_Seymour_Canyon_Loop.jpg' }, { src: 'img/20200621-Lynn-Creek-n-Seymour-River/12-Lynn_n_Seymour_Canyon_Loop.jpg' }],
      list24: [{ src: 'img/20200628NorvanFalls/01-NorvanFalls.jpg' }, { src: 'img/20200628NorvanFalls/02-NorvanFalls.jpg' }, { src: 'img/20200628NorvanFalls/03-NorvanFalls.jpg' }, { src: 'img/20200628NorvanFalls/04-NorvanFalls.jpg' }, { src: 'img/20200628NorvanFalls/05-NorvanFalls.jpg' }, { src: 'img/20200628NorvanFalls/06-NorvanFalls.jpg' }, { src: 'img/20200628NorvanFalls/07-NorvanFalls.jpg' }],
      list25: [{ src: 'img/20200705SmokeBluffsNMamquamRiver/01-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/02-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/03-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/04-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/05-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/06-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/07-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/08-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/09-Smoke.jpg' }, { src: 'img/20200705SmokeBluffsNMamquamRiver/10-Smoke.jpg' }],
      list26: [{ src: 'img/20200712BrothersCreek/01-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/02-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/03-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/04-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/05-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/06-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/07-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/08-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/09-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/10-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/11-Brothers_Creek.jpg' }, { src: 'img/20200712BrothersCreek/12-Brothers_Creek.jpg' }],
      list27: [{ src: 'img/20200802WhyteLake/01-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/02-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/03-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/04-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/05-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/06-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/07-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/08-Whyte_Lake.jpg' }, { src: 'img/20200802WhyteLake/09-Whyte_Lake.jpg' }],
      list28: [{ src: 'img/20200809MinnekhadaRP/01-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/02-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/03-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/04-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/05-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/06-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/07-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/08-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/09-Minnekhada.jpg' }, { src: 'img/20200809MinnekhadaRP/10-Minnekhada.jpg' }],
      list29: [{ src: 'img/20200816TyneheadRP/01-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/02-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/03-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/04-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/05-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/06-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/07-IMG_Tynehead.jpg' }, { src: 'img/20200816TyneheadRP/08-IMG_Tynehead.jpg' }],
      list30: [{ src: 'img/20200823CheakamusCanyon/01-Cheakamus.jpg' }, { src: 'img/20200823CheakamusCanyon/02-Cheakamus.jpg' }, { src: 'img/20200823CheakamusCanyon/03-Cheakamus.jpg' }, { src: 'img/20200823CheakamusCanyon/04-Cheakamus.jpg' }, { src: 'img/20200823CheakamusCanyon/05-Cheakamus.jpg' }, { src: 'img/20200823CheakamusCanyon/06-Cheakamus.jpg' }],
      list32: [{ src: 'img/20200830Greendrop/01-Greendrop.jpg' }, { src: 'img/20200830Greendrop/02-Greendrop.jpg' }, { src: 'img/20200830Greendrop/03-Greendrop.jpg' }, { src: 'img/20200830Greendrop/04-Greendrop.jpg' }, { src: 'img/20200830Greendrop/05-Greendrop.jpg' }],
      list31: [{ src: 'img/20200906HistoricMushroom/1-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/2-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/3-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/4-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/5-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/6-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/7-Historic_Mushroom.jpg' }, { src: 'img/20200906HistoricMushroom/8-Historic_Mushroom.jpg' }],
      list33: [{ src: 'img/20200920Sumas/01-Sumas-bike.jpg' }, { src: 'img/20200920Sumas/02-Sumas-bike.jpg' }, { src: 'img/20200920Sumas/03-Sumas-bike.jpg' }, { src: 'img/20200920Sumas/04-Sumas-bike.jpg' }, { src: 'img/20200920Sumas/05-Sumas-bike.jpg' }, { src: 'img/20200920Sumas/06-Sumas-bike.jpg' }, { src: 'img/20200920Sumas/07-Sumas-bike.jpg' }],
      list34: [{ src: 'img/20200927BuntzenToSasamatLake/01-Buntzen.jpg' }, { src: 'img/20200927BuntzenToSasamatLake/02-Buntzen.jpg' }, { src: 'img/20200927BuntzenToSasamatLake/03-Buntzen.jpg' }, { src: 'img/20200927BuntzenToSasamatLake/04-Buntzen.jpg' }, { src: 'img/20200927BuntzenToSasamatLake/05-Buntzen.jpg' }, { src: 'img/20200927BuntzenToSasamatLake/06-Buntzen.jpg' }],
      list35: [{ src: 'img/20201004UBCRForest/01-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/02-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/03-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/04-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/05-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/06-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/07-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/08-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/09-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/10-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/11-M_Knapp_Research_Forest.jpg' }, { src: 'img/20201004UBCRForest/12-M_Knapp_Research_Forest.jpg' }],
      list36: [{ src: 'img/20201018CampbellValley/00-CampbellValley.jpg' }, { src: 'img/20201018CampbellValley/01-CampbellValley.jpg' }, { src: 'img/20201018CampbellValley/02-CampbellValley.jpg' }, { src: 'img/20201018CampbellValley/03-CampbellValley.jpg' }],
      list37: [{ src: 'img/20201025GoldCreekCanyon/01-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/02-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/03-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/04-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/05-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/06-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/07-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/08-GoldCreekCanyon.jpg' }, { src: 'img/20201025GoldCreekCanyon/09-GoldCreekCanyon.jpg' }],
      list38: [{ src: 'img/20201101FishermansTrail/01-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/02-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/03-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/04-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/05-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/06-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/07-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/08-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/09-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/10-FishermansTrail.jpg' }, { src: 'img/20201101FishermansTrail/11-FishermansTrail.jpg' }],
      list39: [{ src: 'img/20201108HaywardLake/01-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/02-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/03-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/04-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/05-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/06-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/07-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/08-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/09-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/10-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/11-Hayward_Lake_Reservoir.jpg' }, { src: 'img/20201108HaywardLake/12-Hayward_Lake_Reservoir.jpg' }],
      list40: [{ src: 'img/20210314Buntzen/1-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/2-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/3-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/4-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/5-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/6-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/7-Buntzen_Lake.jpg' }, { src: 'img/20210314Buntzen/8-Buntzen_Lake.jpg' }],
      list41: [{ src: 'img/20210325BrohmLake/01-BrohmLake.jpg' }, { src: 'img/20210325BrohmLake/02-BrohmLake.jpg' }, { src: 'img/20210325BrohmLake/03-BrohmLake.jpg' }, { src: 'img/20210325BrohmLake/04-BrohmLake.jpg' }],
      list42: [{ src: 'img/20210404TransCanadaTrail/01-IMG_7648.jpg' }, { src: 'img/20210404TransCanadaTrail/02-IMG_7649.jpg' }, { src: 'img/20210404TransCanadaTrail/03-IMG_7650.jpg' }, { src: 'img/20210404TransCanadaTrail/04-IMG_7651.jpg' }, { src: 'img/20210404TransCanadaTrail/05-IMG_7652.jpg' }, { src: 'img/20210404TransCanadaTrail/06-IMG_7654.jpg' }, { src: 'img/20210404TransCanadaTrail/07-IMG_7655.jpg' }, { src: 'img/20210404TransCanadaTrail/08-IMG_7656.jpg' }, { src: 'img/20210404TransCanadaTrail/09-IMG_7658.jpg' }],
      list43: [{ src: 'img/20210411Fisherman/01-Fisherman.jpg' }, { src: 'img/20210411Fisherman/02-Fisherman.jpg' }, { src: 'img/20210411Fisherman/03-Fisherman.jpg' }, { src: 'img/20210411Fisherman/04-Fisherman.jpg' }, { src: 'img/20210411Fisherman/05-Fisherman.jpg' }, { src: 'img/20210411Fisherman/06-Fisherman.jpg' }, { src: 'img/20210411Fisherman/07-Fisherman.jpg' }],
      list44: [{ src: 'img/20210418ChadseyLake/01-Chadsey-Lake.jpg' }, { src: 'img/20210418ChadseyLake/02-Chadsey-Lake.jpg' }, { src: 'img/20210418ChadseyLake/03-Chadsey-Lake.jpg' }, { src: 'img/20210418ChadseyLake/04-Chadsey-Lake.jpg' }, { src: 'img/20210418ChadseyLake/05-Chadsey-Lake.jpg' }, { src: 'img/20210418ChadseyLake/06-Chadsey-Lake.jpg' }, { src: 'img/20210418ChadseyLake/07-Chadsey-Lake.jpg' }],
      list45: [{ src: 'img/20210508Minnekhada/01-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/02-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/03-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/04-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/05-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/06-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/07-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/08-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/09-Minnekhada.jpg' }, { src: 'img/20210508Minnekhada/10-Minnekhada.jpg' }],
      list46: [{ src: 'img/20210523WhiteLake/1-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/2-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/3-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/4-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/5-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/6-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/7-Whyte_Lake.jpg' }, { src: 'img/20210523WhiteLake/8-Whyte_Lake.jpg' }],
      list47: [{ src: 'img/20213005Shoreline/01-Shoreline.jpg' }, { src: 'img/20213005Shoreline/02-Shoreline.jpg' }, { src: 'img/20213005Shoreline/03-Shoreline.jpg' }, { src: 'img/20213005Shoreline/04-Shoreline.jpg' }, { src: 'img/20213005Shoreline/05-Shoreline.jpg' }, { src: 'img/20213005Shoreline/06-Shoreline.jpg' }, { src: 'img/20213005Shoreline/07-Shoreline.jpg' }, { src: 'img/20213005Shoreline/08-Shoreline.jpg' }],
      list48: [{ src: 'img/20210606Poco/01-Poco.jpg' }, { src: 'img/20210606Poco/02-Poco.jpg' }, { src: 'img/20210606Poco/03-Poco.jpg' }, { src: 'img/20210606Poco/04-Poco.jpg' }, { src: 'img/20210606Poco/05-Poco.jpg' }, { src: 'img/20210606Poco/06-Poco.jpg' }, { src: 'img/20210606Poco/07-Poco.jpg' }, { src: 'img/20210606Poco/08-Poco.jpg' }],
      list49: [{ src: 'img/20210701CrescentBeach/01-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/02-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/03-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/04-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/05-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/06-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/07-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/08-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/09-Crescent.jpg' }, { src: 'img/20210701CrescentBeach/10-Crescent.jpg' }],
      list50: [{ src: 'img/20210705BuntzenLake/01-Buntzen.jpg' }, { src: 'img/20210705BuntzenLake/02-Buntzen.jpg' }, { src: 'img/20210705BuntzenLake/03-Buntzen.jpg' }, { src: 'img/20210705BuntzenLake/04-Buntzen.jpg' }, { src: 'img/20210705BuntzenLake/05-Buntzen.jpg' }, { src: 'img/20210705BuntzenLake/06-Buntzen.jpg' }, { src: 'img/20210705BuntzenLake/07-Buntzen.jpg' }],
      list51: [{ src: 'img/20210711YewBlackMnt/1-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/2-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/3-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/4-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/5-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/6-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/7-Black_Mountain.jpg' }, { src: 'img/20210711YewBlackMnt/8-Black_Mountain.jpg' }],
      list52: [{ src: 'img/20210725MamquamRiver/1-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/2-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/3-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/4-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/5-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/6-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/7-Mamquam.jpg' }, { src: 'img/20210725MamquamRiver/8-Mamquam.jpg' }],
      list53: [{ src: 'img/20210802SeymourRiverLynnCanyonLoop/1-SeymourLynn.jpg' }, { src: 'img/20210802SeymourRiverLynnCanyonLoop/2-SeymourLynn.jpg' }, { src: 'img/20210802SeymourRiverLynnCanyonLoop/3-SeymourLynn.jpg' }, { src: 'img/20210802SeymourRiverLynnCanyonLoop/4-SeymourLynn.jpg' }, { src: 'img/20210802SeymourRiverLynnCanyonLoop/5-SeymourLynn.jpg' }, { src: 'img/20210802SeymourRiverLynnCanyonLoop/6-SeymourLynn.jpg' }],
      list54: [{ src: 'img/20210808StMarksSummit/1-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/2-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/3-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/4-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/5-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/6-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/7-St_Marks_hike.jpg' }, { src: 'img/20210808StMarksSummit/8-St_Marks_hike.jpg' }],
      list55: [{ src: 'img/20210822CypressFallToWhyteLake/01-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/02-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/03-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/04-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/05-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/06-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/07-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/08-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/09-Cypress_Falls_To_Whyte_Lake.jpg' }, { src: 'img/20210822CypressFallToWhyteLake/10-Cypress_Falls_To_Whyte_Lake.jpg' }],
      list56: [{ src: 'img/20210831ElfinLakes/01-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/02-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/03-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/04-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/05-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/06-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/07-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/08-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/09-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/10-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/11-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/12-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/13-Elfin_Lake.jpg' }, { src: 'img/20210831ElfinLakes/14-Elfin_Lake.jpg' }],
      list57: [{ src: 'img/20210912BuntzenToSasamat/01-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/02-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/03-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/04-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/05-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/06-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/07-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/08-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/09-Buntzen_to_Sasamat_Lakes.jpg' }, { src: 'img/20210912BuntzenToSasamat/10-Buntzen_to_Sasamat_Lakes.jpg' }],
      list58: [{ src: 'img/20211003HollyburnPeak/01-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/02-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/03-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/04-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/05-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/06-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/07-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/08-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/09-Hollyburn_Peak.jpg' }, { src: 'img/20211003HollyburnPeak/10-Hollyburn_Peak.jpg' }],
      list59: [{ src: 'img/20211011ElginHeritage/01-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/02-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/03-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/04-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/05-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/06-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/07-ElginHeritage.jpg' }, { src: 'img/20211011ElginHeritage/08-ElginHeritage.jpg' }],
      list60: [{ src: 'img/20211026HistoricMushroom/1-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/2-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/3-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/4-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/5-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/6-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/7-Historic_Mushroom.jpg' }, { src: 'img/20211026HistoricMushroom/8-Historic_Mushroom.jpg' }],
      list61: [{ src: 'img/20211031KLDPBowen/1-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/2-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/3-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/4-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/5-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/6-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/7-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/8-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/9-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/10-KLDPBowen.jpg' }, { src: 'img/20211031KLDPBowen/11-KLDPBowen.jpg' }],
      list62: [{ src: 'img/20211121SasamtDiezVista/01-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/02-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/03-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/04-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/05-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/06-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/07-SasamatToDV.jpg' }, { src: 'img/20211121SasamtDiezVista/08-SasamatToDV.jpg' }],
      list63: [{ src: 'img/20211205LynnSeymour/01-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/02-Two_Canyon_Loop-Lynn_Cteek.jpg' }, { src: 'img/20211205LynnSeymour/03-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/04-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/05-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/06-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/07-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/08-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/09-Two_Canyon_Loop-Lynn_Creek.jpg' }, { src: 'img/20211205LynnSeymour/10-Two_Canyon_Loop-Lynn_Creek.jpg' }],
      list64: [{ src: 'img/20211219SeaWall/01-SeaWall.jpg' }, { src: 'img/20211219SeaWall/02-SeaWall.jpg' }, { src: 'img/20211219SeaWall/03-SeaWall.jpg' }, { src: 'img/20211219SeaWall/04-SeaWall.jpg' }, { src: 'img/20211219SeaWall/05-SeaWall.jpg' }, { src: 'img/20211219SeaWall/06-SeaWall.jpg' }, { src: 'img/20211219SeaWall/07-SeaWall.jpg' }, { src: 'img/20211219SeaWall/08-SeaWall.jpg' }, { src: 'img/20211219SeaWall/09-SeaWall.jpg' }, { src: 'img/20211219SeaWall/10-SeaWall.jpg' }, { src: 'img/20211219SeaWall/11-SeaWall.jpg' }, { src: 'img/20211219SeaWall/12-SeaWall.jpg' }],
      list65: [{ src: 'img/20220109SeaWall/01-SeaWall.jpg' }, { src: 'img/20220109SeaWall/02-SeaWall.jpg' }, { src: 'img/20220109SeaWall/03-SeaWall.jpg' }, { src: 'img/20220109SeaWall/04-SeaWall.jpg' }, { src: 'img/20220109SeaWall/05-SeaWall.jpg' }, { src: 'img/20220109SeaWall/06-SeaWall.jpg' }, { src: 'img/20220109SeaWall/07-SeaWall.jpg' }, { src: 'img/20220109SeaWall/08-SeaWall.jpg' }, { src: 'img/20220109SeaWall/09-SeaWall.jpg' }, { src: 'img/20220109SeaWall/10-SeaWall.jpg' }, { src: 'img/20220109SeaWall/11-SeaWall.jpg' }, { src: 'img/20220109SeaWall/12-SeaWall.jpg' }, { src: 'img/20220109SeaWall/13-SeaWall.jpg' }],
      list66: [{ src: 'img/20220116Bowen/01-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/02-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/03-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/04-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/05-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/06-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/07-Bowen_Lookout.jpg' }, { src: 'img/20220116Bowen/08-Bowen_Lookout.jpg' }],
      list67: [{ src: 'img/20220129LynnLoop/01-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/02-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/03-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/04-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/05-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/06-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/07-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/08-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/09-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/10-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/11-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/12-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/13-LynnLoop.jpg' }, { src: 'img/20220129LynnLoop/14-LynnLoop.jpg' }],
      list68: [{ src: 'img/20220201PolarBearLunar/01-Polar.jpg' }, { src: 'img/20220201PolarBearLunar/02-Polar.jpg' }, { src: 'img/20220201PolarBearLunar/03-Polar.jpg' }, { src: 'img/20220201PolarBearLunar/04-Polar.jpg' }, { src: 'img/20220201PolarBearLunar/05-Polar.jpg' }],
      list69: [{ src: 'img/20220206BlackMnt/01-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/02-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/03-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/04-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/05-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/06-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/07-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/08-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/09-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/10-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/11-Black_Mountain.jpg' }, { src: 'img/20220206BlackMnt/12-Black_Mountain.jpg' }],
      list70: [{ src: 'img/20220212NewWest/01-NewWest.jpg' }, { src: 'img/20220212NewWest/02-NewWest.jpg' }, { src: 'img/20220212NewWest/03-NewWest.jpg' }, { src: 'img/20220212NewWest/04-NewWest.jpg' }, { src: 'img/20220212NewWest/05-NewWest.jpg' }, { src: 'img/20220212NewWest/06-NewWest.jpg' }, { src: 'img/20220212NewWest/07-NewWest.jpg' }, { src: 'img/20220212NewWest/08-NewWest.jpg' }, { src: 'img/20220212NewWest/09-NewWest.jpg' }, { src: 'img/20220212NewWest/10-NewWest.jpg' }],
      list71: [{ src: 'img/20220221IndianArm/01-IndianArm.jpg' }, { src: 'img/20220221IndianArm/02-IndianArm.jpg' }, { src: 'img/20220221IndianArm/03-IndianArm.jpg' }, { src: 'img/20220221IndianArm/04-IndianArm.jpg' }, { src: 'img/20220221IndianArm/05-IndianArm.jpg' }, { src: 'img/20220221IndianArm/06-IndianArm.jpg' }, { src: 'img/20220221IndianArm/07-IndianArm.jpg' }, { src: 'img/20220221IndianArm/08-IndianArm.jpg' }, { src: 'img/20220221IndianArm/09-IndianArm.jpg' }, { src: 'img/20220221IndianArm/10-IndianArm.jpg' }],
      list72: [{ src: 'img/20220306MntSeymour/01-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/02-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/03-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/04-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/05-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/06-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/07-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/08-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/09-Mount_Seymour.jpg' }, { src: 'img/20220306MntSeymour/10-Mount_Seymour.jpg' }],
      list73: [{ src: 'img/20220313BbyMnt/01-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/02-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/03-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/04-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/05-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/06-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/07-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/08-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/09-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/10-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/11-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/12-BbyMnt.jpg' }, { src: 'img/20220313BbyMnt/13-BbyMnt.jpg' }],
      list74: [{ src: 'img/20220320Woodhaven/01-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/02-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/03-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/04-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/05-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/06-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/07-Woodhaven_Swamp-Sasamt_Lake.jpg' }, { src: 'img/20220320Woodhaven/08-Woodhaven_Swamp-Sasamt_Lake.jpg' }],
      list75: [{ src: 'img/20020403Coquitlam/01-Crunch.jpg' }, { src: 'img/20020403Coquitlam/02-Crunch.jpg' }, { src: 'img/20020403Coquitlam/03-Crunch.jpg' }, { src: 'img/20020403Coquitlam/04-Crunch.jpg' }, { src: 'img/20020403Coquitlam/05-Crunch.jpg' }, { src: 'img/20020403Coquitlam/06-Crunch.jpg' }],
      list76: [{ src: 'img/20220410HywardLake/01-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/02-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/03-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/04-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/05-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/06-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/07-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/08-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/09-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/10-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/11-Hayward_Lake.jpg' }, { src: 'img/20220410HywardLake/12-Hayward_Lake.jpg' }],
      list77: [{ src: 'img/20220422CypressFallWhyteLake/01-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/02-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/03-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/04-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/05-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/06-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/07-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/08-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/09-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/10-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/11-Cypress_Falls-Whyte_Lake.jpg' }, { src: 'img/20220422CypressFallWhyteLake/12-Cypress_Falls-Whyte_Lake.jpg' }],
      list78: [{ src: 'img/20220501CrescentBeach/01-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/02-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/03-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/04-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/05-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/06-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/07-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/08-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/09-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/10-Crescent.jpg' }, { src: 'img/20220501CrescentBeach/11-Crescent.jpg' }],
      list79: [{ src: 'img/20220415BuntzenSasamat/01-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/02-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/03-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/04-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/05-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/06-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/07-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/08-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/09-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/10-Buntzen.jpg' }, { src: 'img/20220415BuntzenSasamat/11-Buntzen.jpg' }],
      list80: [{ src: 'img/20220508Hill/01-Hill.jpg' }, { src: 'img/20220508Hill/02-Hill.jpg' }, { src: 'img/20220508Hill/03-Hill.jpg' }, { src: 'img/20220508Hill/04-Hill.jpg' }, { src: 'img/20220508Hill/05-Hill.jpg' }, { src: 'img/20220508Hill/06-Hill.jpg' }, { src: 'img/20220508Hill/07-Hill.jpg' }, { src: 'img/20220508Hill/08-Hill.jpg' }, { src: 'img/20220508Hill/09-Hill.jpg' }, { src: 'img/20220508Hill/10-Hill.jpg' }, { src: 'img/20220508Hill/11-Hill.jpg' }, { src: 'img/20220508Hill/12-Hill.jpg' }, { src: 'img/20220508Hill/13-Hill.jpg' }, { src: 'img/20220508Hill/14-Hill.jpg' }, { src: 'img/20220508Hill/15-Hill.jpg' }, { src: 'img/20220508Hill/16-Hill.jpg' }, { src: 'img/20220508Hill/17-Hill.jpg' }, { src: 'img/20220508Hill/18-Hill.jpg' }, { src: 'img/20220508Hill/19-Hill.jpg' }, { src: 'img/20220508Hill/20-Hill.jpg' }, { src: 'img/20220508Hill/21-Hill.jpg' }, { src: 'img/20220508Hill/22-Hill.jpg' }, { src: 'img/20220508Hill/23-Hill.jpg' }, { src: 'img/20220508Hill/24-Hill.jpg' }],
      list81: [{ src: 'img/20220522NorVan/01-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/02-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/03-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/04-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/05-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/06-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/07-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/08-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/09-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/10-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/11-Norvan_Falls.jpg' }, { src: 'img/20220522NorVan/12-Norvan_Falls.jpg' }],
      list82: [{ src: 'img/20220529Whistler/01-Whistler.jpg' }, { src: 'img/20220529Whistler/02-Whistler.jpg' }, { src: 'img/20220529Whistler/03-Whistler.jpg' }, { src: 'img/20220529Whistler/04-Whistler.jpg' }, { src: 'img/20220529Whistler/05-Whistler.jpg' }, { src: 'img/20220529Whistler/06-Whistler.jpg' }, { src: 'img/20220529Whistler/07-Whistler.jpg' }, { src: 'img/20220529Whistler/08-Whistler.jpg' }, { src: 'img/20220529Whistler/09-Whistler.jpg' }, { src: 'img/20220529Whistler/10-Whistler.jpg' }, { src: 'img/20220529Whistler/11-Whistler.jpg' }, { src: 'img/20220529Whistler/12-Whistler.jpg' }, { src: 'img/20220529Whistler/13-Whistler.jpg' }, { src: 'img/20220529Whistler/14-Whistler.jpg' }],
      list83: [{ src: 'img/20220604Lynn/01-Lynn.jpg' }, { src: 'img/20220604Lynn/02-Lynn.jpg' }, { src: 'img/20220604Lynn/03-Lynn.jpg' }, { src: 'img/20220604Lynn/04-Lynn.jpg' }, { src: 'img/20220604Lynn/05-Lynn.jpg' }, { src: 'img/20220604Lynn/06-Lynn.jpg' }, { src: 'img/20220604Lynn/07-Lynn.jpg' }, { src: 'img/20220604Lynn/08-Lynn.jpg' }, { src: 'img/20220604Lynn/09-Lynn.jpg' }, { src: 'img/20220604Lynn/10-Lynn.jpg' }, { src: 'img/20220604Lynn/11-Lynn.jpg' }, { src: 'img/20220604Lynn/12-Lynn.jpg' }, { src: 'img/20220604Lynn/13-Lynn.jpg' }, { src: 'img/20220604Lynn/14-Lynn.jpg' }],
      list84: [{ src: 'img/20220612GoldenEars/01-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/02-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/03-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/04-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/05-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/06-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/07-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/08-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/09-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/10-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/11-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/12-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/13-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/14-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/15-Golden_Ears_Gold_Creek.jpg' }, { src: 'img/20220612GoldenEars/16-Golden_Ears_Gold_Creek.jpg' }],
      list85: [{ src: 'img/20220619Dyke/01-Dyke.jpg' }, { src: 'img/20220619Dyke/02-Dyke.jpg' }, { src: 'img/20220619Dyke/03-Dyke.jpg' }, { src: 'img/20220619Dyke/04-Dyke.jpg' }, { src: 'img/20220619Dyke/05-Dyke.jpg' }, { src: 'img/20220619Dyke/06-Dyke.jpg' }, { src: 'img/20220619Dyke/07-Dyke.jpg' }, { src: 'img/20220619Dyke/08-Dyke.jpg' }, { src: 'img/20220619Dyke/09-Dyke.jpg' }, { src: 'img/20220619Dyke/10-Dyke.jpg' }, { src: 'img/20220619Dyke/11-Dyke.jpg' }],
      list86: [{ src: 'img/20220626Brohm/01-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/02-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/03-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/04-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/05-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/06-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/07-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/08-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/09-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/10-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/11-Brohm_Lake.jpg' }, { src: 'img/20220626Brohm/12-Brohm_Lake.jpg' }],
      list87: [{ src: 'img/20220701ElkMnt/01-ElkMnt.jpeg' }, { src: 'img/20220701ElkMnt/02-ElkMnt.jpeg' }, { src: 'img/20220701ElkMnt/03-ElkMnt.jpeg' }, { src: 'img/20220701ElkMnt/04-ElkMnt.jpeg' }, { src: 'img/20220701ElkMnt/05-ElkMnt.jpeg' }, { src: 'img/20220701ElkMnt/06-ElkMnt.jpeg' }],
      list88: [{ src: 'img/20220710FourLakes/01-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/02-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/03-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/04-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/05-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/06-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/07-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/08-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/09-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/10-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/11-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/12-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/13-Hollyburn_4_Lakes.jpg' }, { src: 'img/20220710FourLakes/14-Hollyburn_4_Lakes.jpg' }],
      list89: [{ src: 'img/20220717EagleBluffs/01-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/02-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/03-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/04-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/05-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/06-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/07-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/08-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/09-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/10-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/11-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/12-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/13-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/14-Eagle.jpg' }, { src: 'img/20220717EagleBluffs/15-Eagle.jpg' }],
      list90: [{ src: 'img/20220731MntGardner/01-MntGardner.jpg' }, { src: 'img/20220731MntGardner/02-MntGardner.jpg' }, { src: 'img/20220731MntGardner/03-MntGardner.jpg' }, { src: 'img/20220731MntGardner/04-MntGardner.jpg' }, { src: 'img/20220731MntGardner/05-MntGardner.jpg' }, { src: 'img/20220731MntGardner/06-MntGardner.jpg' }, { src: 'img/20220731MntGardner/07-MntGardner.jpg' }, { src: 'img/20220731MntGardner/08-MntGardner.jpg' }, { src: 'img/20220731MntGardner/09-MntGardner.jpg' }, { src: 'img/20220731MntGardner/10-MntGardner.jpg' }, { src: 'img/20220731MntGardner/11-MntGardner.jpg' }, { src: 'img/20220731MntGardner/12-MntGardner.jpg' }],
      list91: [{ src: 'img/20220809Elfin/00-image.jpg' }, { src: 'img/20220809Elfin/01-image.jpg' }, { src: 'img/20220809Elfin/02-image.jpg' }, { src: 'img/20220809Elfin/03-image.jpg' }, { src: 'img/20220809Elfin/04-image.jpg' }, { src: 'img/20220809Elfin/05-image.jpg' }, { src: 'img/20220809Elfin/06-image.jpg' }, { src: 'img/20220809Elfin/07-image.jpg' }, { src: 'img/20220809Elfin/08-image.jpg' }, { src: 'img/20220809Elfin/09-image.jpg' }, { src: 'img/20220809Elfin/10-image.jpg' }, { src: 'img/20220809Elfin/11-image.jpg' }, { src: 'img/20220809Elfin/12-image.jpg' }],
      list92: [{ src: 'img/20220814Tynehead/01-Tynehead.jpg' }, { src: 'img/20220814Tynehead/02-Tynehead.jpg' }, { src: 'img/20220814Tynehead/03-Tynehead.jpg' }, { src: 'img/20220814Tynehead/04-Tynehead.jpg' }, { src: 'img/20220814Tynehead/05-Tynehead.jpg' }, { src: 'img/20220814Tynehead/06-Tynehead.jpg' }, { src: 'img/20220814Tynehead/07-Tynehead.jpg' }, { src: 'img/20220814Tynehead/08-Tynehead.jpg' }],
      list93: [{ src: 'img/20220822Dog/01-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/02-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/03-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/04-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/05-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/06-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/07-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/08-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/09-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/10-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/11-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/12-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/13-Dog_Mt_and_Suicide_Bluffs.jpg' }, { src: 'img/20220822Dog/14-Dog_Mt_and_Suicide_Bluffs.jpg' }],
      list94: [{ src: 'img/20220827StMark/01-StMark.jpg' }, { src: 'img/20220827StMark/02-StMark.jpg' }, { src: 'img/20220827StMark/03-StMark.jpg' }, { src: 'img/20220827StMark/04-StMark.jpg' }, { src: 'img/20220827StMark/05-StMark.jpg' }, { src: 'img/20220827StMark/06-StMark.jpg' }, { src: 'img/20220827StMark/07-StMark.jpg' }, { src: 'img/20220827StMark/08-StMark.jpg' }, { src: 'img/20220827StMark/09-StMark.jpg' }],
      list95: [{ src: 'img/20220904Mistery/01-Mystery.jpg' }, { src: 'img/20220904Mistery/02-Mystery.jpg' }, { src: 'img/20220904Mistery/03-Mystery.jpg' }, { src: 'img/20220904Mistery/04-Mystery.jpg' }, { src: 'img/20220904Mistery/05-Mystery.jpg' }, { src: 'img/20220904Mistery/06-Mystery.jpg' }, { src: 'img/20220904Mistery/07-Mystery.jpg' }, { src: 'img/20220904Mistery/08-Mystery.jpg' }, { src: 'img/20220904Mistery/09-Mystery.jpg' }, { src: 'img/20220904Mistery/10-Mystery.jpg' }, { src: 'img/20220904Mistery/11-Mystery.jpg' }, { src: 'img/20220904Mistery/12-Mystery.jpg' }],
      list96: [{ src: 'img/20220917BOC30thAnniversary/01-BOC30thAnniversary.jpg' }, { src: 'img/20220917BOC30thAnniversary/02-BOC30thAnniversary.jpg' }, { src: 'img/20220917BOC30thAnniversary/03-BOC30thAnniversary.jpg' }, { src: 'img/20220917BOC30thAnniversary/04-BOC30thAnniversary.jpg' }, { src: 'img/20220917BOC30thAnniversary/05-BOC30thAnniversary.jpg' }, { src: 'img/20220917BOC30thAnniversary/06-BOC30thAnniversary.jpg' }],
      list97: [{ src: 'img/20220925Peaks/01-Peaks.jpg' }, { src: 'img/20220925Peaks/02-Peaks.jpg' }, { src: 'img/20220925Peaks/03-Peaks.jpg' }, { src: 'img/20220925Peaks/04-Peaks.jpg' }, { src: 'img/20220925Peaks/05-Peaks.jpg' }, { src: 'img/20220925Peaks/06-Peaks.jpg' }, { src: 'img/20220925Peaks/07-Peaks.jpg' }, { src: 'img/20220925Peaks/08-Peaks.jpg' }, { src: 'img/20220925Peaks/09-Peaks.jpg' }, { src: 'img/20220925Peaks/10-Peaks.jpg' }, { src: 'img/20220925Peaks/11-Peaks.jpg' }, { src: 'img/20220925Peaks/12-Peaks.jpg' }],
      list98: [{ src: 'img/20221001Holly/01-Holly.jpg' }, { src: 'img/20221001Holly/02-Holly.jpg' }, { src: 'img/20221001Holly/03-Holly.jpg' }, { src: 'img/20221001Holly/04-Holly.jpg' }, { src: 'img/20221001Holly/05-Holly.jpg' }, { src: 'img/20221001Holly/06-Holly.jpg' }],
      list99: [{ src: 'img/20221010Jug/01-jug.jpg' }, { src: 'img/20221010Jug/02-jug.jpg' }, { src: 'img/20221010Jug/03-jug.jpg' }, { src: 'img/20221010Jug/04-jug.jpg' }, { src: 'img/20221010Jug/05-jug.jpg' }, { src: 'img/20221010Jug/06-jug.jpg' }, { src: 'img/20221010Jug/07-jug.jpg' }, { src: 'img/20221010Jug/08-jug.jpg' }, { src: 'img/20221010Jug/09-jug.jpg' }, { src: 'img/20221010Jug/10-jug.jpg' }, { src: 'img/20221010Jug/11-jug.jpg' }],
      list100: [{ src: 'img/20221015Caul/01-Caul.jpg' }, { src: 'img/20221015Caul/02-Caul.jpg' }, { src: 'img/20221015Caul/03-Caul.jpg' }, { src: 'img/20221015Caul/04-Caul.jpg' }, { src: 'img/20221015Caul/05-Caul.jpg' }, { src: 'img/20221015Caul/06-Caul.jpg' }, { src: 'img/20221015Caul/07-Caul.jpg' }, { src: 'img/20221015Caul/08-Caul.jpg' }, { src: 'img/20221015Caul/09-Caul.jpg' }, { src: 'img/20221015Caul/10-Caul.jpg' }],
      list101: [{ src: 'img/20221022Dorman/01-Dorman.jpg' }, { src: 'img/20221022Dorman/02-Dorman.jpg' }, { src: 'img/20221022Dorman/03-Dorman.jpg' }, { src: 'img/20221022Dorman/04-Dorman.jpg' }, { src: 'img/20221022Dorman/05-Dorman.jpg' }, { src: 'img/20221022Dorman/06-Dorman.jpg' }, { src: 'img/20221022Dorman/07-Dorman.jpg' }, { src: 'img/20221022Dorman/08-Dorman.jpg' }, { src: 'img/20221022Dorman/09-Dorman.jpg' }, { src: 'img/20221022Dorman/10-Dorman.jpg' }, { src: 'img/20221022Dorman/11-Dorman.jpg' }, { src: 'img/20221022Dorman/12-Dorman.jpg' }, { src: 'img/20221022Dorman/13-Dorman.jpg' }, { src: 'img/20221022Dorman/14-Dorman.jpg' }, { src: 'img/20221022Dorman/15-Dorman.jpg' }],
      list102: [{ src: 'img/20221105Norvan/01-Lynn.jpg' }, { src: 'img/20221105Norvan/02-Lynn.jpg' }, { src: 'img/20221105Norvan/03-Lynn.jpg' }, { src: 'img/20221105Norvan/04-Lynn.jpg' }, { src: 'img/20221105Norvan/05-Lynn.jpg' }, { src: 'img/20221105Norvan/06-Lynn.jpg' }, { src: 'img/20221105Norvan/07-Lynn.jpg' }, { src: 'img/20221105Norvan/08-Lynn.jpg' }, { src: 'img/20221105Norvan/09-Lynn.jpg' }, { src: 'img/20221105Norvan/10-Lynn.jpg' }, { src: 'img/20221105Norvan/11-Lynn.jpg' }, { src: 'img/20221105Norvan/12-Lynn.jpg' }],
      list103: [{ src: 'img/20221111BbyMnt/01-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/02-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/03-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/04-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/05-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/06-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/07-BbyMnt.jpg' }, { src: 'img/20221111BbyMnt/08-BbyMnt.jpg' }],
      list104: [{ src: 'img/20221113Wood/01-Wood.jpg' }, { src: 'img/20221113Wood/02-Wood.jpg' }, { src: 'img/20221113Wood/03-Wood.jpg' }, { src: 'img/20221113Wood/04-Wood.jpg' }, { src: 'img/20221113Wood/05-Wood.jpg' }, { src: 'img/20221113Wood/06-Wood.jpg' }, { src: 'img/20221113Wood/07-Wood.jpg' }, { src: 'img/20221113Wood/08-Wood.jpg' }, { src: 'img/20221113Wood/09-Wood.jpg' }, { src: 'img/20221113Wood/10-Wood.jpg' }, { src: 'img/20221113Wood/11-Wood.jpg' }, { src: 'img/20221113Wood/12-Wood.jpg' }],
      list105: [{ src: 'img/20221120Knoll/01-Knoll.jpg' }, { src: 'img/20221120Knoll/02-Knoll.jpg' }, { src: 'img/20221120Knoll/03-Knoll.jpg' }, { src: 'img/20221120Knoll/04-Knoll.jpg' }, { src: 'img/20221120Knoll/05-Knoll.jpg' }, { src: 'img/20221120Knoll/06-Knoll.jpg' }, { src: 'img/20221120Knoll/07-Knoll.jpg' }],
      list106: [{ src: 'img/20221127Lynn/01-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/02-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/03-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/04-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/05-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/06-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/07-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/08-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/09-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/10-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/11-Lynn_Creek-and-Seymour_River.jpg' }, { src: 'img/20221127Lynn/12-Lynn_Creek-and-Seymour_River.jpg' }],
      list107: [{ src: 'img/202212033BbyLake/01-IMG.jpg' }, { src: 'img/202212033BbyLake/02-IMG.jpg' }, { src: 'img/202212033BbyLake/03-IMG.jpg' }, { src: 'img/202212033BbyLake/04-IMG.jpg' }, { src: 'img/202212033BbyLake/05-IMG.jpg' }, { src: 'img/202212033BbyLake/06-IMG.jpg' }, { src: 'img/202212033BbyLake/07-IMG.jpg' }, { src: 'img/202212033BbyLake/08-IMG.jpg' }, { src: 'img/202212033BbyLake/09-IMG.jpg' }],
      list108: [{ src: 'img/20221226bbymnt/01-bbymnt.jpg' }, { src: 'img/20221226bbymnt/02-bbymnt.jpg' }, { src: 'img/20221226bbymnt/03-bbymnt.jpg' }, { src: 'img/20221226bbymnt/04-bbymnt.jpg' }],
      list109: [{ src: 'img/20230101Barnet/01-Barnet.jpg' }, { src: 'img/20230101Barnet/02-Barnet.jpg' }, { src: 'img/20230101Barnet/03-Barnet.jpg' }, { src: 'img/20230101Barnet/04-Barnet.jpg' }, { src: 'img/20230101Barnet/05-Barnet.jpg' }, { src: 'img/20230101Barnet/06-Barnet.jpg' }, { src: 'img/20230101Barnet/07-Barnet.jpg' }, { src: 'img/20230101Barnet/08-Barnet.jpg' }, { src: 'img/20230101Barnet/09-Barnet.jpg' }],
      list110: [{ src: 'img/20230107Poco/01-Poco.jpg' }, { src: 'img/20230107Poco/02-Poco.jpg' }, { src: 'img/20230107Poco/03-Poco.jpg' }, { src: 'img/20230107Poco/04-Poco.jpg' }, { src: 'img/20230107Poco/05-Poco.jpg' }, { src: 'img/20230107Poco/06-Poco.jpg' }],
      list111: [{ src: 'img/20230115Bowen/01-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/02-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/03-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/04-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/05-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/06-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/07-Bowen_Lookout.jpg' }, { src: 'img/20230115Bowen/08-Bowen_Lookout.jpg' }],
      list112: [{ src: 'img/20230121Buntzen/21-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/22-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/23-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/24-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/25-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/26-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/27-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/28-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/29-Buntzen_Lake.jpg' }, { src: 'img/20230121Buntzen/30-Buntzen_Lake.jpg' }],
      list113: [{ src: 'img/20230122Campbell/01-Campbell.jpg' }, { src: 'img/20230122Campbell/02-Campbell.jpg' }, { src: 'img/20230122Campbell/03-Campbell.jpg' }],
      list114: [{ src: 'img/20230129Seawall/00-image.jpeg' }, { src: 'img/20230129Seawall/01-image.jpeg' }, { src: 'img/20230129Seawall/02-image.jpeg' }, { src: 'img/20230129Seawall/03-image.jpeg' }, { src: 'img/20230129Seawall/04-image.jpeg' }, { src: 'img/20230129Seawall/05-image.jpeg' }, { src: 'img/20230129Seawall/06-image.jpeg' }, { src: 'img/20230129Seawall/07-image.jpeg' }, { src: 'img/20230129Seawall/08-image.jpeg' }, { src: 'img/20230129Seawall/09-image.jpeg' }, { src: 'img/20230129Seawall/10-image.jpeg' }],
      list115: [{ src: 'img/20230205Mosquito/1-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/2-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/3-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/4-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/5-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/6-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/7-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/8-Mosquito_Creek.jpg' }, { src: 'img/20230205Mosquito/9-Mosquito_Creek.jpg' }],
      list116: [{ src: 'img/20230212Dinkey/01-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/02-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/03-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/04-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/05-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/06-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/07-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/08-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/09-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/10-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/11-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/12-Dinkey_Peak_First_Lake.jpg' }, { src: 'img/20230212Dinkey/13-Dinkey_Peak_First_Lake.jpg' }],
      list117: [{ src: 'img/20230218Lynn/01-Lynn.jpg' }, { src: 'img/20230218Lynn/02-Lynn.jpg' }, { src: 'img/20230218Lynn/03-Lynn.jpg' }, { src: 'img/20230218Lynn/04-Lynn.jpg' }, { src: 'img/20230218Lynn/05-Lynn.jpg' }, { src: 'img/20230218Lynn/06-Lynn.jpg' }, { src: 'img/20230218Lynn/07-Lynn.jpg' }, { src: 'img/20230218Lynn/08-Lynn.jpg' }, { src: 'img/20230218Lynn/09-Lynn.jpg' }, { src: 'img/20230218Lynn/10-Lynn.jpg' }, { src: 'img/20230218Lynn/11-Lynn.jpg' }, { src: 'img/20230218Lynn/12-Lynn.jpg' }],
      list118: [{ src: 'img/20230304Black/1-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/2-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/3-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/4-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/5-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/6-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/7-Black_Mountain-Cypress.jpg' }, { src: 'img/20230304Black/8-Black_Mountain-Cypress.jpg' }],
      list119: [{ src: 'img/20230312BbyMnt/01-IMG.jpg' }, { src: 'img/20230312BbyMnt/02-IMG.jpg' }, { src: 'img/20230312BbyMnt/03-IMG.jpg' }, { src: 'img/20230312BbyMnt/04-IMG.jpg' }, { src: 'img/20230312BbyMnt/05-IMG.jpg' }, { src: 'img/20230312BbyMnt/06-IMG.jpg' }],
      list120: [{ src: 'img/20230318Reifel/01-Reifel.jpg' }, { src: 'img/20230318Reifel/02-Reifel.jpg' }, { src: 'img/20230318Reifel/03-Reifel.jpg' }, { src: 'img/20230318Reifel/04-Reifel.jpg' }, { src: 'img/20230318Reifel/05-Reifel.jpg' }, { src: 'img/20230318Reifel/06-Reifel.jpg' }, { src: 'img/20230318Reifel/07-Reifel.jpg' }, { src: 'img/20230318Reifel/08-Reifel.jpg' }],
      list121: [{ src: 'img/20230326IndArm/01-indarm.jpg' }, { src: 'img/20230326IndArm/02-indarm.jpg' }, { src: 'img/20230326IndArm/03-indarm.jpg' }, { src: 'img/20230326IndArm/04-indarm.jpg' }, { src: 'img/20230326IndArm/05-indarm.jpg' }, { src: 'img/20230326IndArm/06-indarm.jpg' }, { src: 'img/20230326IndArm/07-indarm.jpg' }, { src: 'img/20230326IndArm/08-indarm.jpg' }, { src: 'img/20230326IndArm/09-indarm.jpg' }],
      list122: [{ src: 'img/20230407Coq/01.jpg' }, { src: 'img/20230407Coq/02.jpg' }, { src: 'img/20230407Coq/03.jpg' }, { src: 'img/20230407Coq/04.jpg' }, { src: 'img/20230407Coq/05.jpg' }, { src: 'img/20230407Coq/06.jpg' }, { src: 'img/20230407Coq/07.jpg' }, { src: 'img/20230407Coq/08.jpg' }, { src: 'img/20230407Coq/09.jpg' }, { src: 'img/20230407Coq/10.jpg' }, { src: 'img/20230407Coq/11.jpg' }, { src: 'img/20230407Coq/12.jpg' }, { src: 'img/20230407Coq/13.jpg' }, { src: 'img/20230407Coq/14.jpg' }],
      list123: [{ src: 'img/20230415Buntzen/01-Bun.jpg' }, { src: 'img/20230415Buntzen/02-Bun.jpg' }, { src: 'img/20230415Buntzen/03-Bun.jpg' }, { src: 'img/20230415Buntzen/04-Bun.jpg' }, { src: 'img/20230415Buntzen/05-Bun.jpg' }, { src: 'img/20230415Buntzen/06-Bun.jpg' }, { src: 'img/20230415Buntzen/07-Bun.jpg' }, { src: 'img/20230415Buntzen/08-Bun.jpg' }, { src: 'img/20230415Buntzen/09-Bun.jpg' }, { src: 'img/20230415Buntzen/10-Bun.jpg' }, { src: 'img/20230415Buntzen/11-Bun.jpg' }],
      list124: [{ src: 'img/20230423Ald/01-Ald.jpg' }, { src: 'img/20230423Ald/02-Ald.jpg' }, { src: 'img/20230423Ald/03-Ald.jpg' }, { src: 'img/20230423Ald/04-Ald.jpg' }, { src: 'img/20230423Ald/05-Ald.jpg' }, { src: 'img/20230423Ald/06-Ald.jpg' }, { src: 'img/20230423Ald/07-Ald.jpg' }, { src: 'img/20230423Ald/08-Ald.jpg' }, { src: 'img/20230423Ald/09-Ald.jpg' }],
      list125: [{ src: 'img/20230429NVFalls/01.jpg' }, { src: 'img/20230429NVFalls/02.jpg' }, { src: 'img/20230429NVFalls/03.jpg' }, { src: 'img/20230429NVFalls/04.jpg' }, { src: 'img/20230429NVFalls/05.jpg' }, { src: 'img/20230429NVFalls/06.jpg' }, { src: 'img/20230429NVFalls/07.jpg' }, { src: 'img/20230429NVFalls/08.jpg' }, { src: 'img/20230429NVFalls/09.jpg' }, { src: 'img/20230429NVFalls/10.jpg' }],
      list126: [{ src: 'img/20230507SC/01-SC.jpg' }, { src: 'img/20230507SC/02-SC.jpg' }, { src: 'img/20230507SC/03-SC.jpg' }, { src: 'img/20230507SC/04-SC.jpg' }, { src: 'img/20230507SC/05-SC.jpg' }, { src: 'img/20230507SC/06-SC.jpg' }, { src: 'img/20230507SC/07-SC.jpg' }, { src: 'img/20230507SC/08-SC.jpg' }, { src: 'img/20230507SC/09-SC.jpg' }],
      list127: [{ src: 'img/20230506SL/01.jpg' }, { src: 'img/20230506SL/02.jpg' }, { src: 'img/20230506SL/03.jpg' }, { src: 'img/20230506SL/04.jpg' }, { src: 'img/20230506SL/05.jpg' }, { src: 'img/20230506SL/06.jpg' }, { src: 'img/20230506SL/07.jpg' }, { src: 'img/20230506SL/08.jpg' }, { src: 'img/20230506SL/09.jpg' }, { src: 'img/20230506SL/10.jpg' }, { src: 'img/20230506SL/11.jpg' }, { src: 'img/20230506SL/12.jpg' }, { src: 'img/20230506SL/13.jpg' }],
      list128: [{ src: 'img/20230513Hayward/11-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/12-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/13-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/14-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/15-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/16-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/17-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/18-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/19-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/20-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/21-Hayward_Lake.jpg' }, { src: 'img/20230513Hayward/22-Hayward_Lake.jpg' }],
      list129: [{ src: 'img/20230521Poco/01-IMG.jpg' }, { src: 'img/20230521Poco/02-IMG.jpg' }, { src: 'img/20230521Poco/03-IMG.jpg' }, { src: 'img/20230521Poco/04-IMG.jpg' }, { src: 'img/20230521Poco/05-IMG.jpg' }, { src: 'img/20230521Poco/06-IMG.jpg' }, { src: 'img/20230521Poco/07-IMG.jpg' }, { src: 'img/20230521Poco/08-IMG.jpg' }],
      list130: [{ src: 'img/20230528Conf/01-Conf.jpg' }, { src: 'img/20230528Conf/02-Conf.jpg' }, { src: 'img/20230528Conf/03-Conf.jpg' }, { src: 'img/20230528Conf/04-Conf.jpg' }, { src: 'img/20230528Conf/05-Conf.jpg' }, { src: 'img/20230528Conf/06-Conf.jpg' }, { src: 'img/20230528Conf/07-Conf.jpg' }, { src: 'img/20230528Conf/08-Conf.jpg' }, { src: 'img/20230528Conf/09-Conf.jpg' }, { src: 'img/20230528Conf/10-Conf.jpg' }, { src: 'img/20230528Conf/11-Conf.jpg' }, { src: 'img/20230528Conf/12-Conf.jpg' }, { src: 'img/20230528Conf/13-Conf.jpg' }, { src: 'img/20230528Conf/14-Conf.jpg' }, { src: 'img/20230528Conf/15-Conf.jpg' }],
      list131: [{ src: 'img/20230602Alberta/01-Alberta.jpg' }, { src: 'img/20230602Alberta/02-Alberta.jpg' }, { src: 'img/20230602Alberta/03-Alberta.jpg' }, { src: 'img/20230602Alberta/04-Alberta.jpg' }, { src: 'img/20230602Alberta/05-Alberta.jpg' }],
      list132: [{ src: 'img/20230604Cheak/21-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/22-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/23-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/24-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/25-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/26-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/27-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/28-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/29-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/30-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/31-Cheakamus_Canyon.jpg' }, { src: 'img/20230604Cheak/32-Cheakamus_Canyon.jpg' }],
      list133: [{ src: 'img/20230624Bowen/1.jpg' }, { src: 'img/20230624Bowen/2.jpg' }, { src: 'img/20230624Bowen/3.jpg' }, { src: 'img/20230624Bowen/4.jpg' }, { src: 'img/20230624Bowen/5.jpg' }, { src: 'img/20230624Bowen/6.jpg' }, { src: 'img/20230624Bowen/7.jpg' }, { src: 'img/20230624Bowen/8.jpg' }, { src: 'img/20230624Bowen/9.jpg' }, { src: 'img/20230624Bowen/10.jpg' }, { src: 'img/20230624Bowen/11.jpg' }, { src: 'img/20230624Bowen/12.jpg' }],
      list134: [{ src: 'img/20230701Elk/07-elk.jpeg' }, { src: 'img/20230701Elk/08-elk.jpeg' }, { src: 'img/20230701Elk/09-elk.jpeg' }, { src: 'img/20230701Elk/10-elk.jpeg' }, { src: 'img/20230701Elk/11-elk.jpeg' }, { src: 'img/20230701Elk/12-elk.jpeg' }, { src: 'img/20230701Elk/13-elk.jpeg' }, { src: 'img/20230701Elk/14-elk.jpeg' }, { src: 'img/20230701Elk/15-elk.jpeg' }, { src: 'img/20230701Elk/16-elk.jpeg' }, { src: 'img/20230701Elk/17-elk.jpeg' }, { src: 'img/20230701Elk/18-elk.jpeg' }, { src: 'img/20230701Elk/19-elk.jpeg' }, { src: 'img/20230701Elk/20-elk.jpeg' }],
      list135: [{ src: 'img/20230709BbyMnt/01-bbymnt.jpg' }, { src: 'img/20230709BbyMnt/02-bbymnt.jpg' }, { src: 'img/20230709BbyMnt/03-bbymnt.jpg' }, { src: 'img/20230709BbyMnt/04-bbymnt.jpg' }, { src: 'img/20230709BbyMnt/05-bbymnt.jpg' }],
      list136: [{ src: 'img/20230716Pet/01-Pet.jpg' }, { src: 'img/20230716Pet/02-Pet.jpg' }, { src: 'img/20230716Pet/03-Pet.jpg' }, { src: 'img/20230716Pet/04-Pet.jpg' }, { src: 'img/20230716Pet/05-Pet.jpg' }, { src: 'img/20230716Pet/06-Pet.jpg' }, { src: 'img/20230716Pet/07-Pet.jpg' }, { src: 'img/20230716Pet/08-Pet.jpg' }, { src: 'img/20230716Pet/09-Pet.jpg' }, { src: 'img/20230716Pet/10-Pet.jpg' }, { src: 'img/20230716Pet/11-Pet.jpg' }, { src: 'img/20230716Pet/12-Pet.jpg' }, { src: 'img/20230716Pet/13-Pet.jpg' }, { src: 'img/20230716Pet/14-Pet.jpg' }],
      list137: [{ src: 'img/20230722Alice/01-Alice.jpg' }, { src: 'img/20230722Alice/02-Alice.jpg' }, { src: 'img/20230722Alice/03-Alice.jpg' }, { src: 'img/20230722Alice/04-Alice.jpg' }, { src: 'img/20230722Alice/05-Alice.jpg' }, { src: 'img/20230722Alice/06-Alice.jpg' }, { src: 'img/20230722Alice/07-Alice.jpg' }, { src: 'img/20230722Alice/08-Alice.jpg' }, { src: 'img/20230722Alice/09-Alice.jpg' }, { src: 'img/20230722Alice/10-Alice.jpg' }, { src: 'img/20230722Alice/11-Alice.jpg' }],
      list138: [{ src: 'img/20230730BlackMnt/01-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/02-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/03-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/04-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/05-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/06-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/07-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/08-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/09-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/10-BlackMnt.jpg' }, { src: 'img/20230730BlackMnt/11-BlackMnt.jpg' }],
      list139: [{ src: 'img/20230804Garib/01-Garib.jpg' }, { src: 'img/20230804Garib/02-Garib.jpg' }, { src: 'img/20230804Garib/03-Garib.jpg' }, { src: 'img/20230804Garib/04-Garib.jpg' }, { src: 'img/20230804Garib/05-Garib.jpg' }, { src: 'img/20230804Garib/06-Garib.jpg' }, { src: 'img/20230804Garib/07-Garib.jpg' }, { src: 'img/20230804Garib/08-Garib.jpg' }, { src: 'img/20230804Garib/09-Garib.jpg' }, { src: 'img/20230804Garib/10-Garib.jpg' }, { src: 'img/20230804Garib/11-Garib.jpg' }],
      list140: [{ src: 'img/20230812StMark/21-St_Marks.jpg' }, { src: 'img/20230812StMark/22-St_Marks.jpg' }, { src: 'img/20230812StMark/23-St_Marks.jpg' }, { src: 'img/20230812StMark/24-St_Marks.jpg' }, { src: 'img/20230812StMark/25-St_Marks.jpg' }, { src: 'img/20230812StMark/26-St_Marks.jpg' }, { src: 'img/20230812StMark/27-St_Marks.jpg' }, { src: 'img/20230812StMark/28-St_Marks.jpg' }, { src: 'img/20230812StMark/29-St_Marks.jpg' }, { src: 'img/20230812StMark/30-St_Marks.jpg' }, { src: 'img/20230812StMark/31-St_Marks.jpg' }, { src: 'img/20230812StMark/32-St_Marks.jpg' }, { src: 'img/20230812StMark/33-St_Marks.jpg' }, { src: 'img/20230812StMark/34-St_Marks.jpg' }],
      list141: [{ src: 'img/20230813PG/01-PG.jpg' }, { src: 'img/20230813PG/02-PG.jpg' }, { src: 'img/20230813PG/03-PG.jpg' }, { src: 'img/20230813PG/04-PG.jpg' }, { src: 'img/20230813PG/05-PG.jpg' }, { src: 'img/20230813PG/06-PG.jpg' }, { src: 'img/20230813PG/07-PG.jpg' }],
      list142: [],
      list143: [{ src: 'img/20230902BbyMnt/01-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/02-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/03-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/04-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/05-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/06-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/07-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/08-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/09-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/10-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/11-Burnaby_Mountain Loop.jpg' }, { src: 'img/20230902BbyMnt/12-Burnaby_Mountain Loop.jpg' }],
      list144: [{ src: 'img/20230908TH/01-TH.jpg' }, { src: 'img/20230908TH/02-TH.jpg' }, { src: 'img/20230908TH/03-TH.jpg' }],
      list145: [{ src: 'img/20230912AlHabrich/11-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/12-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/13-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/14-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/15-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/16-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/17-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/18-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/19-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/20-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/21-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/22-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/23-Al_Habrich_Ridge.jpg' }, { src: 'img/20230912AlHabrich/24-Al_Habrich_Ridge.jpg' }],
      list146: [{ src: 'img/20230916Ptrarmigan/01-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/02-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/03-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/04-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/05-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/06-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/07-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/08-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/09-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/10-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/11-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/12-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/13-Ptarmigan_Ridge_Mt_BAker.jpg' }, { src: 'img/20230916Ptrarmigan/14-Ptarmigan_Ridge_Mt_BAker.jpg' }],
      list147: [{ src: 'img/20230930DV/01-dv.jpg' }, { src: 'img/20230930DV/02-dv.jpg' }, { src: 'img/20230930DV/03-dv.jpg' }, { src: 'img/20230930DV/04-dv.jpg' }, { src: 'img/20230930DV/05-dv.jpg' }, { src: 'img/20230930DV/06-dv.jpg' }, { src: 'img/20230930DV/07-dv.jpg' }, { src: 'img/20230930DV/08-dv.jpg' }, { src: 'img/20230930DV/09-dv.jpg' }, { src: 'img/20230930DV/10-dv.jpg' }, { src: 'img/20230930DV/11-dv.jpg' }, { src: 'img/20230930DV/12-dv.jpg' }],
      list148: [{ src: 'img/20231001VLoop/01-VLoop.jpg' }, { src: 'img/20231001VLoop/02-VLoop.jpg' }, { src: 'img/20231001VLoop/03-VLoop.jpg' }, { src: 'img/20231001VLoop/05-VLoop.jpg' }, { src: 'img/20231001VLoop/06-VLoop.jpg' }, { src: 'img/20231001VLoop/07-VLoop.jpg' }, { src: 'img/20231001VLoop/08-VLoop.jpg' }, { src: 'img/20231001VLoop/09-VLoop.jpg' }, { src: 'img/20231001VLoop/10-VLoop.jpg' }, { src: 'img/20231001VLoop/11-VLoop.jpg' }, { src: 'img/20231001VLoop/12-VLoop.jpg' }, { src: 'img/20231001VLoop/13-VLoop.jpg' }],
      list149: [{ src: 'img/20231008CW/11-Cypress_Falls.jpg' }, { src: 'img/20231008CW/12-Cypress_Falls.jpg' }, { src: 'img/20231008CW/13-Cypress_Falls.jpg' }, { src: 'img/20231008CW/14-Cypress_Falls.jpg' }, { src: 'img/20231008CW/15-Cypress_Falls.jpg' }, { src: 'img/20231008CW/16-Cypress_Falls.jpg' }, { src: 'img/20231008CW/17-Cypress_Falls.jpg' }, { src: 'img/20231008CW/18-Cypress_Falls.jpg' }, { src: 'img/20231008CW/19-Cypress_Falls.jpg' }, { src: 'img/20231008CW/20-Cypress_Falls.jpg' }, { src: 'img/20231008CW/21-Cypress_Falls.jpg' }, { src: 'img/20231008CW/22-Cypress_Falls.jpg' }],
      list150: [{ src: 'img/20231015MHFarm/01-mhfarm.jpg' }, { src: 'img/20231015MHFarm/02-mhfarm.jpg' }, { src: 'img/20231015MHFarm/03-mhfarm.jpg' }, { src: 'img/20231015MHFarm/04-mhfarm.jpg' }, { src: 'img/20231015MHFarm/05-mhfarm.jpg' }, { src: 'img/20231015MHFarm/06-mhfarm.jpg' }, { src: 'img/20231015MHFarm/07-mhfarm.jpg' }],
      list151: [{ src: 'img/20231018Hollyburn/01-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/02-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/03-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/04-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/05-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/06-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/07-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/08-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/09-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/10-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/11-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/12-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/13-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/14-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/15-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/16-Hollyburn.jpg' }, { src: 'img/20231018Hollyburn/17-Hollyburn.jpg' }],
      list152: [{ src: 'img/20231022LHPark/01-lhpark.jpg' }, { src: 'img/20231022LHPark/02-lhpark.jpg' }, { src: 'img/20231022LHPark/03-lhpark.jpg' }, { src: 'img/20231022LHPark/04-lhpark.jpg' }, { src: 'img/20231022LHPark/05-lhpark.jpg' }, { src: 'img/20231022LHPark/06-lhpark.jpg' }, { src: 'img/20231022LHPark/07-lhpark.jpg' }, { src: 'img/20231022LHPark/09-lhpark.jpg' }, { src: 'img/20231022LHPark/10-lhpark.jpg' }, { src: 'img/20231022LHPark/11-lhpark.jpg' }],
      list153: [{ src: 'img/20231028Belcarra/21-Belcarra.jpg' }, { src: 'img/20231028Belcarra/22-Belcarra.jpg' }, { src: 'img/20231028Belcarra/23-Belcarra.jpg' }, { src: 'img/20231028Belcarra/24-Belcarra.jpg' }, { src: 'img/20231028Belcarra/25-Belcarra.jpg' }, { src: 'img/20231028Belcarra/26-Belcarra.jpg' }, { src: 'img/20231028Belcarra/27-Belcarra.jpg' }, { src: 'img/20231028Belcarra/28-Belcarra.jpg' }, { src: 'img/20231028Belcarra/29-Belcarra.jpg' }, { src: 'img/20231028Belcarra/30-Belcarra.jpg' }, { src: 'img/20231028Belcarra/31-Belcarra.jpg' }, { src: 'img/20231028Belcarra/32-Belcarra.jpg' }],
      list154: [{ src: 'img/20231112BL/01-BL.jpg' }, { src: 'img/20231112BL/02-BL.jpg' }, { src: 'img/20231112BL/03-BL.jpg' }, { src: 'img/20231112BL/04-BL.jpg' }, { src: 'img/20231112BL/05-BL.jpg' }, { src: 'img/20231112BL/06-BL.jpg' }, { src: 'img/20231112BL/07-BL.jpg' }, { src: 'img/20231112BL/08-BL.jpg' }],
      list155: [{ src: 'img/20231118HM/01-HM.jpg' }, { src: 'img/20231118HM/02-HM.jpg' }, { src: 'img/20231118HM/03-HM.jpg' }, { src: 'img/20231118HM/04-HM.jpg' }, { src: 'img/20231118HM/05-HM.jpg' }, { src: 'img/20231118HM/06-HM.jpg' }, { src: 'img/20231118HM/07-HM.jpg' }, { src: 'img/20231118HM/08-HM.jpg' }, { src: 'img/20231118HM/09-HM.jpg' }, { src: 'img/20231118HM/10-HM.jpg' }, { src: 'img/20231118HM/11-HM.jpg' }, { src: 'img/20231118HM/12-HM.jpg' }],
      list156: [{ src: 'img/20231125Xmas/0-IMG_0140.jpg' }, { src: 'img/20231125Xmas/1-IMG_0143.jpg' }, { src: 'img/20231125Xmas/2-IMG_0144.jpg' }, { src: 'img/20231125Xmas/3-IMG_0145.jpg' }],
      list157: [{ src: 'img/20231122BbyLake/00-BbyLake.jpg' }, { src: 'img/20231122BbyLake/01-BbyLake.jpg' }, { src: 'img/20231122BbyLake/02-BbyLake.jpg' }, { src: 'img/20231122BbyLake/03-BbyLake.jpg' }, { src: 'img/20231122BbyLake/04-BbyLake.jpg' }],
      list158: [{ src: 'img/20231209Minn/21-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/22-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/23-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/24-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/25-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/26-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/27-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/28-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/29-Minnekhada_Park.jpg' }, { src: 'img/20231209Minn/30-Minnekhada_Park.jpg' }],
      list159: [{ src: 'img/20231217Lynn/21-Lunn.jpg' }, { src: 'img/20231217Lynn/22-Lunn.jpg' }, { src: 'img/20231217Lynn/23-Lunn.jpg' }, { src: 'img/20231217Lynn/24-Lunn.jpg' }, { src: 'img/20231217Lynn/25-Lunn.jpg' }, { src: 'img/20231217Lynn/26-Lunn.jpg' }, { src: 'img/20231217Lynn/27-Lunn.jpg' }, { src: 'img/20231217Lynn/28-Lunn.jpg' }, { src: 'img/20231217Lynn/29-Lunn.jpg' }, { src: 'img/20231217Lynn/30-Lunn.jpg' }, { src: 'img/20231217Lynn/31-Lunn.jpg' }, { src: 'img/20231217Lynn/32-Lunn.jpg' }],
      list160: [{ src: 'img/20231226Baden/01-bp.jpg' }, { src: 'img/20231226Baden/02-bp.jpg' }, { src: 'img/20231226Baden/03-bp.jpg' }, { src: 'img/20231226Baden/04-bp.jpg' }, { src: 'img/20231226Baden/05-bp.jpg' }, { src: 'img/20231226Baden/06-bp.jpg' }, { src: 'img/20231226Baden/07-bp.jpg' }, { src: 'img/20231226Baden/08-bp.jpg' }, { src: 'img/20231226Baden/09-bp.jpg' }, { src: 'img/20231226Baden/10-bp.jpg' }],
      list161: [{ src: 'img/20231230Grouse/01-grouse.jpg' }, { src: 'img/20231230Grouse/02-grouse.jpg' }, { src: 'img/20231230Grouse/03-grouse.jpg' }, { src: 'img/20231230Grouse/04-grouse.jpg' }, { src: 'img/20231230Grouse/05-grouse.jpg' }, { src: 'img/20231230Grouse/06-grouse.jpg' }],
      list162: [{ src: 'img/20240101PolarBear/1.jpg' }, { src: 'img/20240101PolarBear/2.jpg' }, { src: 'img/20240101PolarBear/3.jpg' }, { src: 'img/20240101PolarBear/4.jpg' }, { src: 'img/20240101PolarBear/5.jpg' }],
      list163: [{ src: 'img/20240106iarm/01-iarm.jpg' }, { src: 'img/20240106iarm/02-iarm.jpg' }, { src: 'img/20240106iarm/03-iarm.jpg' }, { src: 'img/20240106iarm/04-iarm.jpg' }, { src: 'img/20240106iarm/05-iarm.jpg' }, { src: 'img/20240106iarm/06-iarm.jpg' }, { src: 'img/20240106iarm/07-iarm.jpg' }, { src: 'img/20240106iarm/08-iarm.jpg' }, { src: 'img/20240106iarm/09-iarm.jpg' }, { src: 'img/20240106iarm/10-iarm.jpg' }, { src: 'img/20240106iarm/11-iarm.jpg' }, { src: 'img/20240106iarm/12-iarm.jpg' }, { src: 'img/20240106iarm/13-iarm.jpg' }],
      list164: [{ src: 'img/20240203HiannisHead/01-hh.jpg' }, { src: 'img/20240203HiannisHead/02-hh.jpg' }, { src: 'img/20240203HiannisHead/03-hh.jpg' }, { src: 'img/20240203HiannisHead/04-hh.jpg' }, { src: 'img/20240203HiannisHead/05-hh.jpg' }, { src: 'img/20240203HiannisHead/06-hh.jpg' }, { src: 'img/20240203HiannisHead/07-hh.jpg' }, { src: 'img/20240203HiannisHead/08-hh.jpg' }, { src: 'img/20240203HiannisHead/09-hh.jpg' }, { src: 'img/20240203HiannisHead/10-hh.jpg' }, { src: 'img/20240203HiannisHead/11-hh.jpg' }, { src: 'img/20240203HiannisHead/12-hh.jpg' }],
      list165: [{ src: 'img/20240218Mahon/01-Mahon.jpg' }, { src: 'img/20240218Mahon/02-Mahon.jpg' }, { src: 'img/20240218Mahon/03-Mahon.jpg' }, { src: 'img/20240218Mahon/04-Mahon.jpg' }, { src: 'img/20240218Mahon/05-Mahon.jpg' }, { src: 'img/20240218Mahon/06-Mahon.jpg' }, { src: 'img/20240218Mahon/07-Mahon.jpg' }, { src: 'img/20240218Mahon/08-Mahon.jpg' }],
      list166: [{ src: 'img/20240225Conserv/01-Conserv.jpg' }, { src: 'img/20240225Conserv/02-Conserv.jpg' }, { src: 'img/20240225Conserv/03-Conserv.jpg' }, { src: 'img/20240225Conserv/04-Conserv.jpg' }, { src: 'img/20240225Conserv/05-Conserv.jpg' }, { src: 'img/20240225Conserv/06-Conserv.jpg' }, { src: 'img/20240225Conserv/07-Conserv.jpg' }, { src: 'img/20240225Conserv/08-Conserv.jpg' }],
      list167: [{ src: 'img/20240224Rice/01-Rice_Lake.jpg' }, { src: 'img/20240224Rice/02-Rice_Lake.jpg' }, { src: 'img/20240224Rice/03-Rice_Lake.jpg' }, { src: 'img/20240224Rice/04-Rice_Lake.jpg' }, { src: 'img/20240224Rice/05-Rice_Lake.jpg' }, { src: 'img/20240224Rice/06-Rice_Lake.jpg' }, { src: 'img/20240224Rice/07-Rice_Lake.jpg' }, { src: 'img/20240224Rice/08-Rice_Lake.jpg' }, { src: 'img/20240224Rice/09-Rice_Lake.jpg' }, { src: 'img/20240224Rice/10-Rice_Lake.jpg' }, { src: 'img/20240224Rice/11-Rice_Lake.jpg' }, { src: 'img/20240224Rice/12-Rice_Lake.jpg' }],
      list168: [{ src: 'img/20240303Iona/01-Iona.jpg' }, { src: 'img/20240303Iona/02-Iona.jpg' }, { src: 'img/20240303Iona/03-Iona.jpg' }, { src: 'img/20240303Iona/04-Iona.jpg' }, { src: 'img/20240303Iona/05-Iona.jpg' }, { src: 'img/20240303Iona/06-Iona.jpg' }, { src: 'img/20240303Iona/07-Iona.jpg' }, { src: 'img/20240303Iona/08-Iona.jpg' }, { src: 'img/20240303Iona/09-Iona.jpg' }, { src: 'img/20240303Iona/10-Iona.jpg' }],
      list169: [{ src: 'img/202410310Fort/01-Fort.jpg' }, { src: 'img/202410310Fort/02-Fort.jpg' }, { src: 'img/202410310Fort/03-Fort.jpg' }, { src: 'img/202410310Fort/04-Fort.jpg' }, { src: 'img/202410310Fort/05-Fort.jpg' }, { src: 'img/202410310Fort/06-Fort.jpg' }, { src: 'img/202410310Fort/07-Fort.jpg' }, { src: 'img/202410310Fort/08-Fort.jpg' }, { src: 'img/202410310Fort/08-Fort.jpg' }],
      list170: [{ src: 'img/202340309BS/11-BS.jpg' }, { src: 'img/202340309BS/12-BS.jpg' }, { src: 'img/202340309BS/13-BS.jpg' }, { src: 'img/202340309BS/14-BS.jpg' }, { src: 'img/202340309BS/15-BS.jpg' }, { src: 'img/202340309BS/16-BS.jpg' }, { src: 'img/202340309BS/17-BS.jpg' }, { src: 'img/202340309BS/18-BS.jpg' }],
      list171: [{ src: 'img/20240322LHtoMC/01-bp.jpg' }, { src: 'img/20240322LHtoMC/02-bp.jpg' }, { src: 'img/20240322LHtoMC/03-bp.jpg' }, { src: 'img/20240322LHtoMC/04-bp.jpg' }, { src: 'img/20240322LHtoMC/05-bp.jpg' }, { src: 'img/20240322LHtoMC/06-bp.jpg' }, { src: 'img/20240322LHtoMC/07-bp.jpg' }, { src: 'img/20240322LHtoMC/08-bp.jpg' }, { src: 'img/20240322LHtoMC/09-bp.jpg' }, { src: 'img/20240322LHtoMC/10-bp.jpg' }, { src: 'img/20240322LHtoMC/11-bp.jpg' }, { src: 'img/20240322LHtoMC/12-bp.jpg' }],
      list172: [{ src: 'img/20240331br/01-br.jpg' }, { src: 'img/20240331br/02-br.jpg' }, { src: 'img/20240331br/03-br.jpg' }, { src: 'img/20240331br/04-br.jpg' }, { src: 'img/20240331br/05-br.jpg' }, { src: 'img/20240331br/06-br.jpg' }],
      list173: [{ src: 'img/20240401MCtoGM/01-bp.jpg' }, { src: 'img/20240401MCtoGM/02-bp.jpg' }, { src: 'img/20240401MCtoGM/03-bp.jpg' }, { src: 'img/20240401MCtoGM/04-bp.jpg' }, { src: 'img/20240401MCtoGM/05-bp.jpg' }, { src: 'img/20240401MCtoGM/06-bp.jpg' }, { src: 'img/20240401MCtoGM/07-bp.jpg' }, { src: 'img/20240401MCtoGM/08-bp.jpg' }, { src: 'img/20240401MCtoGM/09-bp.jpg' }, { src: 'img/20240401MCtoGM/10-bp.jpg' }],
      list174: [{ src: 'img/20240406Reifel/01-Reifel.jpg' }, { src: 'img/20240406Reifel/02-Reifel.jpg' }, { src: 'img/20240406Reifel/03-Reifel.jpg' }, { src: 'img/20240406Reifel/04-Reifel.jpg' }, { src: 'img/20240406Reifel/05-Reifel.jpg' }, { src: 'img/20240406Reifel/06-Reifel.jpg' }, { src: 'img/20240406Reifel/07-Reifel.jpg' }, { src: 'img/20240406Reifel/08-Reifel.jpg' }, { src: 'img/20240406Reifel/09-Reifel.jpg' }, { src: 'img/20240406Reifel/10-Reifel.jpg' }, { src: 'img/20240406Reifel/11-Reifel.jpg' }, { src: 'img/20240406Reifel/12-Reifel.jpg' }, { src: 'img/20240406Reifel/13-Reifel.jpg' }, { src: 'img/20240406Reifel/14-Reifel.jpg' }, { src: 'img/20240406Reifel/15-Reifel.jpg' }, { src: 'img/20240406Reifel/16-Reifel.jpg' }, { src: 'img/20240406Reifel/17-Reifel.jpg' }, { src: 'img/20240406Reifel/18-Reifel.jpg' }, { src: 'img/20240406Reifel/19-Reifel.jpg' }],
      list175: [{ src: 'img/20240407bml/01-bml.jpg' }, { src: 'img/20240407bml/02-bml.jpg' }, { src: 'img/20240407bml/03-bml.jpg' }, { src: 'img/20240407bml/04-bml.jpg' }, { src: 'img/20240407bml/05-bml.jpg' }, { src: 'img/20240407bml/06-bml.jpg' }, { src: 'img/20240407bml/07-bml.jpg' }, { src: 'img/20240407bml/08-bml.jpg' }, { src: 'img/20240407bml/09-bml.jpg' }],
      list176: [{ src: 'img/20240414cvg/01-cvg.jpg' }, { src: 'img/20240414cvg/02-cvg.jpg' }, { src: 'img/20240414cvg/03-cvg.jpg' }, { src: 'img/20240414cvg/04-cvg.jpg' }, { src: 'img/20240414cvg/05-cvg.jpg' }, { src: 'img/20240414cvg/06-cvg.jpg' }, { src: 'img/20240414cvg/07-cvg.jpg' }, { src: 'img/20240414cvg/08-cvg.jpg' }],
      list177: [{ src: 'img/20240428NFalls/01-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/02-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/03-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/04-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/05-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/06-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/07-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/08-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/09-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/10-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/11-Norvan_Falls.jpg' }, { src: 'img/20240428NFalls/12-Norvan_Falls.jpg' }],
      list178: [{ src: 'img/20240504Kayak/01-Kayak.jpg' }, { src: 'img/20240504Kayak/02-Kayak.jpg' }, { src: 'img/20240504Kayak/03-Kayak.jpg' }, { src: 'img/20240504Kayak/04-Kayak.jpg' }, { src: 'img/20240504Kayak/05-Kayak.jpg' }, { src: 'img/20240504Kayak/06-Kayak.jpg' }, { src: 'img/20240504Kayak/07-Kayak.jpg' }, { src: 'img/20240504Kayak/08-Kayak.jpg' }],
      list179: [{ src: 'img/20240504Haywart/01-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/02-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/03-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/04-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/05-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/06-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/07-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/08-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/09-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/10-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/11-Haywart_Lake.jpg' }, { src: 'img/20240504Haywart/12-Haywart_Lake.jpg' }],
      list180: [{ src: 'img/20240505BBRPD/01-bbrpd.jpg' }, { src: 'img/20240505BBRPD/02-bbrpd.jpg' }, { src: 'img/20240505BBRPD/03-bbrpd.jpg' }, { src: 'img/20240505BBRPD/04-bbrpd.jpg' }, { src: 'img/20240505BBRPD/05-bbrpd.jpg' }],
      list181: [{ src: 'img/20240511MtGardner/01-Bowen.jpg' }, { src: 'img/20240511MtGardner/02-Bowen.jpg' }, { src: 'img/20240511MtGardner/03-Bowen.jpg' }, { src: 'img/20240511MtGardner/04-Bowen.jpg' }, { src: 'img/20240511MtGardner/05-Bowen.jpg' }, { src: 'img/20240511MtGardner/06-Bowen.jpg' }, { src: 'img/20240511MtGardner/07-Bowen.jpg' }, { src: 'img/20240511MtGardner/08-Bowen.jpg' }, { src: 'img/20240511MtGardner/09-Bowen.jpg' }, { src: 'img/20240511MtGardner/10-Bowen.jpg' }, { src: 'img/20240511MtGardner/11-Bowen.jpg' }, { src: 'img/20240511MtGardner/12-Bowen.jpg' }, { src: 'img/20240511MtGardner/13-Bowen.jpg' }],
      list182: [{ src: 'img/20240608Confed/01-conf.jpg' }, { src: 'img/20240608Confed/02-conf.jpg' }, { src: 'img/20240608Confed/03-conf.jpg' }, { src: 'img/20240608Confed/04-conf.jpg' }, { src: 'img/20240608Confed/05-conf.jpg' }, { src: 'img/20240608Confed/06-conf.jpg' }, { src: 'img/20240608Confed/07-conf.jpg' }, { src: 'img/20240608Confed/08-conf.jpg' }, { src: 'img/20240608Confed/09-conf.jpg' }, { src: 'img/20240608Confed/10-conf.jpg' }, { src: 'img/20240608Confed/11-conf.jpg' }, { src: 'img/20240608Confed/12-conf.jpg' }, { src: 'img/20240608Confed/13-conf.jpg' }],
      list183: [{ src: 'img/20240616ubcrf/11-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/12-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/13-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/14-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/15-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/16-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/17-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/18-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/19-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/20-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/21-UBC_RF.jpg' }, { src: 'img/20240616ubcrf/22-UBC_RF.jpg' }],
      list184: [{ src: 'img/20240620BP5/01-bp5.jpg' }, { src: 'img/20240620BP5/02-bp5.jpg' }, { src: 'img/20240620BP5/03-bp5.jpg' }, { src: 'img/20240620BP5/04-bp5.jpg' }, { src: 'img/20240620BP5/05-bp5.jpg' }, { src: 'img/20240620BP5/06-bp5.jpg' }, { src: 'img/20240620BP5/07-bp5.jpg' }, { src: 'img/20240620BP5/08-bp5.jpg' }],
      list185: [{ src: 'img/20240623BrandyWine/01-BW.jpg' }, { src: 'img/20240623BrandyWine/02-BW.jpg' }, { src: 'img/20240623BrandyWine/03-BW.jpg' }, { src: 'img/20240623BrandyWine/04-BW.jpg' }, { src: 'img/20240623BrandyWine/05-BW.jpg' }, { src: 'img/20240623BrandyWine/06-BW.jpg' }, { src: 'img/20240623BrandyWine/07-BW.jpg' }, { src: 'img/20240623BrandyWine/08-BW.jpg' }, { src: 'img/20240623BrandyWine/09-BW.jpg' }],
      list186: [{ src: 'img/20240701ElkT/01-elk.jpg' }, { src: 'img/20240701ElkT/02-elk.jpg' }, { src: 'img/20240701ElkT/03-elk.jpg' }, { src: 'img/20240701ElkT/04-elk.jpg' }, { src: 'img/20240701ElkT/05-elk.jpg' }, { src: 'img/20240701ElkT/06-elk.jpg' }, { src: 'img/20240701ElkT/07-elk.jpg' }, { src: 'img/20240701ElkT/08-elk.jpg' }, { src: 'img/20240701ElkT/09-elk.jpg' }, { src: 'img/20240701ElkT/10-elk.jpg' }],
      list187: [{ src: 'img/20240708EBluffs/21-Eglea_Bluffs.jpg' }, { src: 'img/20240708EBluffs/22-Eglea_Bluffs.jpg' }, { src: 'img/20240708EBluffs/23-Eglea_Bluffs.jpg' }, { src: 'img/20240708EBluffs/24-Eglea_Bluffs.jpg' }, { src: 'img/20240708EBluffs/25-Eglea_Bluffs.jpg' }, { src: 'img/20240708EBluffs/26-Eglea_Bluffs.jpg' }],
      list188: [{ src: 'img/20240711BPbctoyew/01-BPbctoyew.jpg' }, { src: 'img/20240711BPbctoyew/02-BPbctoyew.jpg' }, { src: 'img/20240711BPbctoyew/03-BPbctoyew.jpg' }],
      list189: [{ src: 'img/20240714Strachan/01-str.jpg' }, { src: 'img/20240714Strachan/02-str.jpg' }, { src: 'img/20240714Strachan/03-str.jpg' }, { src: 'img/20240714Strachan/04-str.jpg' }, { src: 'img/20240714Strachan/05-str.jpg' }, { src: 'img/20240714Strachan/06-str.jpg' }, { src: 'img/20240714Strachan/07-str.jpg' }, { src: 'img/20240714Strachan/08-str.jpg' }, { src: 'img/20240714Strachan/09-str.jpg' }, { src: 'img/20240714Strachan/10-str.jpg' }, { src: 'img/20240714Strachan/11-str.jpg' }, { src: 'img/20240714Strachan/12-str.jpg' }],
      list190: [{ src: 'img/20240721LoHolly/01-loholly.jpg' }, { src: 'img/20240721LoHolly/02-loholly.jpg' }, { src: 'img/20240721LoHolly/03-loholly.jpg' }, { src: 'img/20240721LoHolly/04-loholly.jpg' }, { src: 'img/20240721LoHolly/05-loholly.jpg' }, { src: 'img/20240721LoHolly/06-loholly.jpg' }],
      list191: [{ src: 'img/20240805LakeAnn/01-lakeann.jpg' }, { src: 'img/20240805LakeAnn/02-lakeann.jpg' }, { src: 'img/20240805LakeAnn/03-lakeann.jpg' }, { src: 'img/20240805LakeAnn/04-lakeann.jpg' }, { src: 'img/20240805LakeAnn/05-lakeann.jpg' }, { src: 'img/20240805LakeAnn/06-lakeann.jpg' }, { src: 'img/20240805LakeAnn/07-lakeann.jpg' }, { src: 'img/20240805LakeAnn/08-lakeann.jpg' }, { src: 'img/20240805LakeAnn/09-lakeann.jpg' }, { src: 'img/20240805LakeAnn/10-lakeann.jpg' }, { src: 'img/20240805LakeAnn/11-lakeann.jpg' }, { src: 'img/20240805LakeAnn/12-lakeann.jpg' }],
      list192: [{ src: 'img/20240811Pacific/01-pacific.jpg' }, { src: 'img/20240811Pacific/02-pacific.jpg' }, { src: 'img/20240811Pacific/03-pacific.jpg' }, { src: 'img/20240811Pacific/04-pacific.jpg' }],
      list193: [{ src: 'img/20240901RcmdDykes/01-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/02-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/03-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/04-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/05-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/06-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/07-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/08-Dykes.jpg' }, { src: 'img/20240901RcmdDykes/09-Dykes.jpg' }],
      list194: [{ src: 'img/20240831Dog/01-Dog.jpg' }, { src: 'img/20240831Dog/02-Dog.jpg' }, { src: 'img/20240831Dog/03-Dog.jpg' }, { src: 'img/20240831Dog/04-Dog.jpg' }, { src: 'img/20240831Dog/05-Dog.jpg' }, { src: 'img/20240831Dog/06-Dog.jpg' }, { src: 'img/20240831Dog/07-Dog.jpg' }, { src: 'img/20240831Dog/08-Dog.jpg' }, { src: 'img/20240831Dog/09-Dog.jpg' }, { src: 'img/20240831Dog/10-Dog.jpg' }],
      list195: [{ src: 'img/20240908Aldergrove/01-alder.jpg' }, { src: 'img/20240908Aldergrove/02-alder.jpg' }, { src: 'img/20240908Aldergrove/03-alder.jpg' }, { src: 'img/20240908Aldergrove/04-alder.jpg' }, { src: 'img/20240908Aldergrove/05-alder.jpg' }, { src: 'img/20240908Aldergrove/06-alder.jpg' }, { src: 'img/20240908Aldergrove/07-alder.jpg' }, { src: 'img/20240908Aldergrove/08-alder.jpg' }, { src: 'img/20240908Aldergrove/09-alder.jpg' }, { src: 'img/20240908Aldergrove/10-alder.jpg' }, { src: 'img/20240908Aldergrove/11-alder.jpg' }, { src: 'img/20240908Aldergrove/12-alder.jpg' }],
      list196: [{ src: 'img/20240914Sawblade/01-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/02-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/03-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/04-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/05-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/06-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/07-Sawblade_Falls.jpg' }, { src: 'img/20240914Sawblade/08-Sawblade_Falls.jpg' }],
      list197: [{ src: 'img/20240921Chain/01-Chain.jpg' }, { src: 'img/20240921Chain/02-Chain.jpg' }, { src: 'img/20240921Chain/03-Chain.jpg' }, { src: 'img/20240921Chain/04-Chain.jpg' }, { src: 'img/20240921Chain/05-Chain.jpg' }, { src: 'img/20240921Chain/06-Chain.jpg' }, { src: 'img/20240921Chain/07-Chain.jpg' }, { src: 'img/20240921Chain/08-Chain.jpg' }],
      list198: [{ src: 'img/20240929Chil/01-20240929_Chil.jpg' }, { src: 'img/20240929Chil/02-20240929_Chil.jpg' }, { src: 'img/20240929Chil/03-20240929_Chil.jpg' }, { src: 'img/20240929Chil/04-20240929_Chil.jpg' }, { src: 'img/20240929Chil/05-20240929_Chil.jpg' }, { src: 'img/20240929Chil/06-20240929_Chil.jpg' }, { src: 'img/20240929Chil/07-20240929_Chil.jpg' }],
      list199: [{ src: 'img/20241004BPcbToEb/01-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/02-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/03-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/04-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/05-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/06-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/07-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/08-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/09-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/10-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/11-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/12-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/13-bpcbtoeb.jpg' }, { src: 'img/20241004BPcbToEb/14-bpcbtoeb.jpg' }],
      list200: [{ src: 'img/20241010Petgill/01-pet.jpg' }, { src: 'img/20241010Petgill/02-pet.jpg' }, { src: 'img/20241010Petgill/03-pet.jpg' }, { src: 'img/20241010Petgill/04-pet.jpg' }, { src: 'img/20241010Petgill/05-pet.jpg' }, { src: 'img/20241010Petgill/06-pet.jpg' }, { src: 'img/20241010Petgill/07-pet.jpg' }, { src: 'img/20241010Petgill/08-pet.jpg' }, { src: 'img/20241010Petgill/09-pet.jpg' }, { src: 'img/20241010Petgill/10-pet.jpg' }, { src: 'img/20241010Petgill/11-pet.jpg' }, { src: 'img/20241010Petgill/12-pet.jpg' }, { src: 'img/20241010Petgill/13-pet.jpg' }],
      list201: [{ src: 'img/202241027Campbell/1.jpg' }, { src: 'img/202241027Campbell/2.jpg' }, { src: 'img/202241027Campbell/3.jpg' }, { src: 'img/202241027Campbell/4.jpg' }, { src: 'img/202241027Campbell/5.jpg' }, { src: 'img/202241027Campbell/6.jpg' }, { src: 'img/202241027Campbell/7.jpg' }, { src: 'img/202241027Campbell/8.jpg' }, { src: 'img/202241027Campbell/9.jpg' }, { src: 'img/202241027Campbell/10.jpg' }, { src: 'img/202241027Campbell/11.jpg' }, { src: 'img/202241027Campbell/12.jpg' }],
      list202: [{ src: 'img/20241102NorVan/01-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/02-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/03-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/04-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/05-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/06-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/07-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/08-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/09-Norvan_Falls.jpg' }, { src: 'img/20241102NorVan/10-Norvan_Falls.jpg' }],
      list203: [{ src: 'img/20241107Minnekhada/01-Min.jpg' }, { src: 'img/20241107Minnekhada/02-Min.jpg' }, { src: 'img/20241107Minnekhada/03-Min.jpg' }, { src: 'img/20241107Minnekhada/04-Min.jpg' }],
      list204: [{ src: 'img/20241117Buntzen/01-Buntz.jpg' }, { src: 'img/20241117Buntzen/02-Buntz.jpg' }, { src: 'img/20241117Buntzen/03-Buntz.jpg' }, { src: 'img/20241117Buntzen/04-Buntz.jpg' }, { src: 'img/20241117Buntzen/05-Buntz.jpg' }, { src: 'img/20241117Buntzen/06-Buntz.jpg' }, { src: 'img/20241117Buntzen/07-Buntz.jpg' }, { src: 'img/20241117Buntzen/08-Buntz.jpg' }, { src: 'img/20241117Buntzen/09-Buntz.jpg' }, { src: 'img/20241117Buntzen/10-Buntz.jpg' }],
      list205: [{ src: 'img/20241201Poco/01-Poco.jpg' }, { src: 'img/20241201Poco/02-Poco.jpg' }, { src: 'img/20241201Poco/03-Poco.jpg' }, { src: 'img/20241201Poco/04-Poco.jpg' }, { src: 'img/20241201Poco/05-Poco.jpg' }, { src: 'img/20241201Poco/06-Poco.jpg' }, { src: 'img/20241201Poco/07-Poco.jpg' }, { src: 'img/20241201Poco/08-Poco.jpg' }, { src: 'img/20241201Poco/09-Poco.jpg' }, { src: 'img/20241201Poco/10-Poco.jpg' }, { src: 'img/20241201Poco/11-Poco.jpg' }, { src: 'img/20241201Poco/12-Poco.jpg' }],
      list206: [{ src: 'img/20241219OldBuck/01-oldbuck.jpg' }, { src: 'img/20241219OldBuck/02-oldbuck.jpg' }, { src: 'img/20241219OldBuck/03-oldbuck.jpg' }, { src: 'img/20241219OldBuck/04-oldbuck.jpg' }, { src: 'img/20241219OldBuck/05-oldbuck.jpg' }, { src: 'img/20241219OldBuck/06-oldbuck.jpg' }],
      list207: [{ src: 'img/20250101PolarBear/01-polarbear.jpg' }, { src: 'img/20250101PolarBear/02-polarbear.jpg' }],
      list208: [{ src: 'img/20250125Jug/01-jug.jpg' }, { src: 'img/20250125Jug/02-jug.jpg' }, { src: 'img/20250125Jug/03-jug.jpg' }, { src: 'img/20250125Jug/04-jug.jpg' }, { src: 'img/20250125Jug/05-jug.jpg' }, { src: 'img/20250125Jug/06-jug.jpg' }, { src: 'img/20250125Jug/07-jug.jpg' }, { src: 'img/20250125Jug/08-jug.jpg' }, { src: 'img/20250125Jug/09-jug.jpg' }, { src: 'img/20250125Jug/10-jug.jpg' }, { src: 'img/20250125Jug/11-jug.jpg' }, { src: 'img/20250125Jug/12-jug.jpg' }, { src: 'img/20250125Jug/13-jug.jpg' }],
      list209: [{ src: 'img/20250126SDyke/01-SDyke.jpg' }, { src: 'img/20250126SDyke/02-SDyke.jpg' }, { src: 'img/20250126SDyke/03-SDyke.jpg' }, { src: 'img/20250126SDyke/04-SDyke.jpg' }, { src: 'img/20250126SDyke/05-SDyke.jpg' }, { src: 'img/20250126SDyke/06-SDyke.jpg' }, { src: 'img/20250126SDyke/07-SDyke.jpg' }, { src: 'img/20250126SDyke/08-SDyke.jpg' }, { src: 'img/20250126SDyke/09-SDyke.jpg' }, { src: 'img/20250126SDyke/10-SDyke.jpg' }, { src: 'img/20250126SDyke/11-SDyke.jpg' }, { src: 'img/20250126SDyke/12-SDyke.jpg' }],
      list210: [{ src: 'img/20250209Bowe/21-Bowe.jpg' }, { src: 'img/20250209Bowe/22-Bowe.jpg' }, { src: 'img/20250209Bowe/23-Bowe.jpg' }, { src: 'img/20250209Bowe/24-Bowe.jpg' }, { src: 'img/20250209Bowe/25-Bowe.jpg' }, { src: 'img/20250209Bowe/26-Bowe.jpg' }, { src: 'img/20250209Bowe/27-Bowe.jpg' }, { src: 'img/20250209Bowe/28-Bowe.jpg' }],
      list211: [{ src: 'img/20250223Derby/01-der.jpg' }, { src: 'img/20250223Derby/02-der.jpg' }, { src: 'img/20250223Derby/03-der.jpg' }, { src: 'img/20250223Derby/04-der.jpg' }, { src: 'img/20250223Derby/05-der.jpg' }, { src: 'img/20250223Derby/06-der.jpg' }, { src: 'img/20250223Derby/07-der.jpg' }, { src: 'img/20250223Derby/08-der.jpg' }, { src: 'img/20250223Derby/09-der.jpg' }, { src: 'img/20250223Derby/10-der.jpg' }, { src: 'img/20250223Derby/11-der.jpg' }, { src: 'img/20250223Derby/12-der.jpg' }],
      list212: [{ src: 'img/20250301Rice/01-Rice.jpg' }, { src: 'img/20250301Rice/02-Rice.jpg' }, { src: 'img/20250301Rice/03-Rice.jpg' }, { src: 'img/20250301Rice/04-Rice.jpg' }, { src: 'img/20250301Rice/05-Rice.jpg' }, { src: 'img/20250301Rice/06-Rice.jpg' }, { src: 'img/20250301Rice/07-Rice.jpg' }, { src: 'img/20250301Rice/08-Rice.jpg' }, { src: 'img/20250301Rice/09-Rice.jpg' }, { src: 'img/20250301Rice/10-Rice.jpg' }],
      list213: [{ src: 'img/20250316bbay/01-bbay.jpg' }, { src: 'img/20250316bbay/02-bbay.jpg' }, { src: 'img/20250316bbay/03-bbay.jpg' }, { src: 'img/20250316bbay/04-bbay.jpg' }, { src: 'img/20250316bbay/05-bbay.jpg' }, { src: 'img/20250316bbay/06-bbay.jpg' }, { src: 'img/20250316bbay/07-bbay.jpg' }, { src: 'img/20250316bbay/08-bbay.jpg' }, { src: 'img/20250316bbay/09-bbay.jpg' }, { src: 'img/20250316bbay/10-bbay.jpg' }],
      list214: [{ src: 'img/20250330FraserRiver/01-FR.jpg' }, { src: 'img/20250330FraserRiver/02-FR.jpg' }, { src: 'img/20250330FraserRiver/03-FR.jpg' }, { src: 'img/20250330FraserRiver/04-FR.jpg' }, { src: 'img/20250330FraserRiver/05-FR.jpg' }, { src: 'img/20250330FraserRiver/06-FR.jpg' }, { src: 'img/20250330FraserRiver/07-FR.jpg' }, { src: 'img/20250330FraserRiver/08-FR.jpg' }, { src: 'img/20250330FraserRiver/09-FR.jpg' }, { src: 'img/20250330FraserRiver/10-FR.jpg' }, { src: 'img/20250330FraserRiver/11-FR.jpg' }],
      list215: [{ src: 'img/20250412NorvanFalls/11-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/12-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/13-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/14-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/15-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/16-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/17-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/18-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/19-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/20-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/21-Norvan_Falls.jpg' }, { src: 'img/20250412NorvanFalls/22-Norvan_Falls.jpg' }],
      list216: [{ src: 'img/20250419GardnerMnt/01-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/02-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/03-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/04-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/05-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/06-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/07-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/08-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/09-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/10-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/11-mntgard.jpg' }, { src: 'img/20250419GardnerMnt/12-mntgard.jpg' }],
      list217: [{ src: 'img/20250427Chief/01-chief.jpg' }, { src: 'img/20250427Chief/02-chief.jpg' }, { src: 'img/20250427Chief/03-chief.jpg' }, { src: 'img/20250427Chief/04-chief.jpg' }, { src: 'img/20250427Chief/05-chief.jpg' }, { src: 'img/20250427Chief/06-chief.jpg' }],
      list218: [{ src: 'img/20250601Bros/01-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/02-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/03-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/04-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/05-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/06-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/07-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/08-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/09-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/10-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/11-Brothers_Creek.jpg' }, { src: 'img/20250601Bros/12-Brothers_Creek.jpg' }],
      list0: [{ src: 'img/BOC-Newsletter.jpg' }]
    };
  },

  methods: {
    toBocHome: function toBocHome() {
      location.href = 'http://www.burnabyoutdoor.com';
    },
    beforeEnter: function beforeEnter(el) {
      console.log('beforeEnter');
      this.elementWidth = 400;
      el.style.width = this.elementWidth + 'px';
    },
    enter: function enter(el, done) {
      var _this = this;

      console.log('enter');
      var round = 1;
      var interval = setInterval(function () {
        el.style.width = _this.elementWidth + round * 10 + 'px';
        round++;
        if (round > 20) {
          clearInterval(interval);
          done();
        }
      }, 20);
    },
    afterEnter: function afterEnter(el) {
      console.log('afterEnter');
    },
    enterCancelled: function enterCancelled(el) {
      console.log('enterCancelled');
    },
    beforeLeave: function beforeLeave(el) {
      console.log('beforeLeave');
      this.elementWidth = 400;
      el.style.width = this.elementWidth + 'px';
    },
    leave: function leave(el, done) {
      var _this2 = this;

      console.log('leave');
      var round = 1;
      var interval = setInterval(function () {
        el.style.width = _this2.elementWidth - round * 10 + 'px';
        round++;
        if (round > 20) {
          clearInterval(interval);
          done();
        }
      }, 20);
    },
    afterLeave: function afterLeave(el) {
      console.log('afterLeave');
    },
    leaveCancelled: function leaveCancelled(el) {
      console.log('leaveCancelled');
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vuer_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5137d006_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vuer_vue__ = __webpack_require__(30);
function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5137d006"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vuer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5137d006_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vuer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuerSingle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__to_js__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VuerSingle: __WEBPACK_IMPORTED_MODULE_0__VuerSingle__["a" /* default */] },
  data: function data() {
    return {
      backgroundColor: '#111',
      imgList: [],
      isSingle: false,
      isShow: false,
      isIndexShow: true,
      useCloseButton: false,
      preload: true,
      allowSwipe: false,
      currentIndex: 0,
      /**
       * 从允许swipe开始纪录swipe位移
       * handleTouchEnd时位移小于100（意味着无法触发swipe），清零
       * 大于100必定触发handleSwipe，
       * 修改currentIndex后清零
       */
      swipeDelta: 0,
      swipeThreshold: 100
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 路由跳转时关闭图片预览
    vm.isShow = false;
    next();
  },

  computed: {
    maxIndex: function maxIndex() {
      return this.imgList.length - 1;
    }
  },
  watch: {
    isShow: function isShow(val) {
      if (val) {
        // 使用 history 处理安卓物理返回键关闭图片
        if (/android/i.test(navigator.userAgent)) {
          history.pushState(null, null, location.href);
          window.addEventListener('popstate', this.closeGallery);
        }
        document.querySelector('.prevent-pass-through').className = 'prevent-pass-through prevent-pass-through-show';
        document.querySelector('.slider').className = 'slider open';
      } else {
        window.removeEventListener('popstate', this.closeGallery);
        setTimeout(function () {
          return document.querySelector('.prevent-pass-through').className = 'prevent-pass-through';
        }, 400);
        document.querySelector('.slider').className = 'slider close';
      }
    },
    currentIndex: function currentIndex() {
      var _this = this;

      // 图片未加载成功时无宽度 ，加载完成后先显示第一张后跳到当前
      var el = document.querySelector('.item-wrapper');
      el.translateX = -this.currentIndex * el.getBoundingClientRect().width;
      if (!this.preload) {
        this.$nextTick(function () {
          _this.$refs.img[_this.currentIndex].imgInit();
        });
      }
    },
    imgList: function imgList() {
      var _this2 = this;

      var el = document.querySelector('.item-wrapper');
      el.translateX = -this.currentIndex * el.getBoundingClientRect().width;
      if (!this.preload) {
        this.$nextTick(function () {
          _this2.$refs.img[_this2.currentIndex].imgInit();
        });
      }
    }
  },
  methods: {
    handleTapClose: function handleTapClose(e, el, fromCloseButton) {
      if (this.useCloseButton && !fromCloseButton) return;
      if (/android/i.test(navigator.userAgent)) {
        history.back();
      }
      this.closeGallery();
    },
    closeGallery: function closeGallery() {
      this.isShow = false;
      this.$refs.img[this.currentIndex].reset();
    },
    handlePressMove: function handlePressMove(e, el) {
      e.preventDefault();
      if (this.allowSwipe === false || this.isSingle) return;
      el.translateX += e.deltaX;
      this.swipeDelta += e.deltaX;
    },
    handleTouchStart: function handleTouchStart() {
      __WEBPACK_IMPORTED_MODULE_1__to_js__["a" /* default */].stopAll();
    },
    handleTouchEnd: function handleTouchEnd(e, el) {
      // touchmove太短无法触发swipe时用于复位
      if (Math.abs(this.swipeDelta) < this.swipeThreshold) {
        this.swipeDelta = 0;
        var width = el.getBoundingClientRect().width;
        new __WEBPACK_IMPORTED_MODULE_1__to_js__["a" /* default */](el, 'translateX', -this.currentIndex * width, 200, this.ease);
      }
    },
    handleSwipe: function handleSwipe(evt, el) {
      // swipeDelta小于swipeThreshold不触发翻页
      if (Math.abs(this.swipeDelta) < this.swipeThreshold) {
        // 借 handleTouchEnd 复位
        return;
      }
      var width = el.getBoundingClientRect().width;
      if (evt.direction === 'Left' && this.currentIndex < this.maxIndex) {
        this.$refs.img[this.currentIndex].reset();
        this.currentIndex += 1;
      } else if (evt.direction === 'Right' && this.currentIndex > 0) {
        this.$refs.img[this.currentIndex].reset();
        this.currentIndex -= 1;
      }
      new __WEBPACK_IMPORTED_MODULE_1__to_js__["a" /* default */](el, 'translateX', -this.currentIndex * width, 200, this.ease);
      this.swipeDelta = 0;
    },
    next: function next() {
      var el = document.querySelector('.item-wrapper');
      var width = el.getBoundingClientRect().width;
      this.currentIndex += 1;
      new __WEBPACK_IMPORTED_MODULE_1__to_js__["a" /* default */](el, 'translateX', -this.currentIndex * width, 200, this.ease);
    },
    prev: function prev() {
      var el = document.querySelector('.item-wrapper');
      var width = el.getBoundingClientRect().width;
      this.currentIndex -= 1;
      new __WEBPACK_IMPORTED_MODULE_1__to_js__["a" /* default */](el, 'translateX', -this.currentIndex * width, 200, this.ease);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader_DoubleBounce__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['src'],
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__loader_DoubleBounce__["a" /* default */] },
  data: function data() {
    return {
      imgEl: null,
      loading: true,
      initialScale: 1,
      currentScale: 1,
      isSmall: false,
      srcDelay: '',
      isInited: false
    };
  },
  mounted: function mounted() {
    if (!this.src) return false;
    this.$emit('disableSwipe');
    if (this.$root.preload) {
      this.imgInit();
    }
  },

  methods: {
    imgInit: function imgInit(onload) {
      if (this.isInited && this.srcDelay === this.src) return;
      console.log('preload', this.$root.preload);
      console.log('load img', this.src);

      var vm = this;
      vm.srcDelay = vm.src;
      vm.isInited = true;

      var img = new Image();
      var imgEl = this.$el.lastChild.firstChild;
      img.onload = function () {
        var h = this.height;
        var w = this.width;
        vm.imgEl = imgEl;
        vm.imgHeight = h;
        vm.imgWidth = w;
        imgEl.style.left = (window.innerWidth - w) / 2 + 'px';
        imgEl.style.top = (window.innerHeight - h) / 2 + 'px';
        imgEl.parentNode.style.display = 'block';
        if (w < window.innerWidth && h < window.innerHeight) {
          vm.isSmall = true;
        } else if (window.innerWidth / window.innerHeight < w / h) {
          vm.initialScale = window.innerWidth / w;
          imgEl.scaleX = imgEl.scaleY = vm.initialScale;
        } else {
          vm.initialScale = window.innerHeight / h;
          imgEl.scaleX = imgEl.scaleY = vm.initialScale;
        }
        vm.loading = false;

        img.onload = null;
        img = null;
      };
      img.src = this.src;
    },
    getCriticalX: function getCriticalX(scale) {
      // 获取横向临界值
      return (this.imgWidth * scale - window.innerWidth) / 2;
    },
    getCriticalY: function getCriticalY(scale) {
      // 获取纵向临界值
      return (this.imgHeight * scale - window.innerHeight) / 2;
    },
    handleMultipointStart: function handleMultipointStart(e) {
      this.currentScale = this.imgEl.scaleX;
    },
    handlePressMove: function handlePressMove(e) {
      var el = this.imgEl;
      e.preventDefault();
      if (this.isSmall) {
        el.translateX += e.deltaX / 3;
        el.translateY += e.deltaY / 3;
        this.$emit('enableSwipe');
        return;
      }

      if (el.scaleX / this.initialScale < 1.2 && el.scaleX / this.initialScale > 0.8) {
        this.$emit('enableSwipe');
        el.translateX += e.deltaX / 3;
        return;
      }

      var criticalX = this.getCriticalX(el.scaleX);
      var criticalY = this.getCriticalY(el.scaleY);

      // 实现超过临界值移动速度减缓
      var slowX = el.translateX > criticalX || el.translateX < -criticalX;
      var slowY = el.translateY > criticalY || el.translateY < -criticalY;

      this.$emit('disableSwipe');
      if (slowX) {
        el.translateX += e.deltaX / 3;
        this.$emit('enableSwipe');
      } else el.translateX += e.deltaX;
      if (slowY) {
        el.translateY += e.deltaY / 3;
      } else el.translateY += e.deltaY;
    },
    handleTouchEnd: function handleTouchEnd(e) {
      var el = this.imgEl;
      if (this.isSmall || el.scaleX / this.initialScale < 1) {
        this.reset();
        return;
      }

      if (el.scaleX / this.initialScale > 6) {
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'scaleX', this.initialScale * 6, 500, this.ease);
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'scaleY', this.initialScale * 6, 500, this.ease);
      }
      var criticalX = this.getCriticalX(el.scaleX);
      var criticalY = this.getCriticalY(el.scaleY);

      if (window.innerHeight >= this.imgHeight * el.scaleX) {
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateY', 0, 500, this.ease);
      } else {
        if (el.translateY > criticalY) {
          new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateY', criticalY, 500, this.ease);
        } else if (el.translateY < -criticalY) {
          new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateY', -criticalY, 500, this.ease);
        }
      }

      if (window.innerWidth >= this.imgWidth * el.scaleY) {
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateX', 0, 500, this.ease);
      } else {
        if (el.translateX > criticalX) {
          new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateX', criticalX, 500, this.ease);
        } else if (el.translateX < -criticalX) {
          new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateX', -criticalX, 500, this.ease);
        }
      }
    },
    handleDoubleTap: function handleDoubleTap(e) {
      var el = this.imgEl;
      if (this.isSmall) return;

      this.$emit('disableSwipe');
      if (this.imgEl.scaleX !== this.initialScale) {
        this.reset();
      } else {
        var box = el.getBoundingClientRect();
        var y = window.innerHeight / 2 - e.changedTouches[0].pageY;
        var x = window.innerWidth / 2 - e.changedTouches[0].pageX;
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'scaleX', this.initialScale * 2, 500, this.ease);
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'scaleY', this.initialScale * 2, 500, this.ease);
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateX', x, 500, this.ease);
        new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](el, 'translateY', y, 500, this.ease);
        console.dir(el);
      }
    },
    handlePinch: function handlePinch(e, el) {
      this.$emit('disableSwipe');
      this.imgEl.scaleX = this.imgEl.scaleY = this.currentScale * e.zoom;
    },
    reset: function reset() {
      if (!this.imgEl) return;
      new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](this.imgEl, 'scaleX', this.initialScale, 500, this.ease);
      new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](this.imgEl, 'scaleY', this.initialScale, 500, this.ease);
      new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](this.imgEl, 'translateX', 0, 500, this.ease);
      new __WEBPACK_IMPORTED_MODULE_0__to_js__["a" /* default */](this.imgEl, 'translateY', 0, 500, this.ease);
    },
    ease: function ease(x) {
      return Math.sqrt(1 - Math.pow(x - 1, 2));
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// alloy 的补间函数
var To = function To(el, property, value, time, ease, onEnd, onChange) {
  var current = el[property];
  var dv = value - current;
  var beginTime = new Date();
  var self = this;
  var currentEase = ease || function (a) {
    return a;
  };
  this.tickID = null;
  var toTick = function toTick() {
    var dt = new Date() - beginTime;
    if (dt >= time) {
      el[property] = value;
      onChange && onChange(value);
      onEnd && onEnd(value);
      cancelAnimationFrame(self.tickID);
      self.toTick = null;
      return;
    }
    el[property] = dv * currentEase(dt / time) + current;
    self.tickID = requestAnimationFrame(toTick);
    onChange && onChange(el[property]);
  };
  toTick();
  To.List.push(this);
};

To.List = [];

To.stopAll = function () {
  for (var i = 0, len = To.List.length; i < len; i++) {
    cancelAnimationFrame(To.List[i].tickID);
  }
  To.List.length = 0;
};

To.stop = function (to) {
  cancelAnimationFrame(to.tickID);
};

/* harmony default export */ __webpack_exports__["a"] = (To);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // from http://tobiasahlin.com/spinkit/
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gallery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scroller__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scroller__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_scroller___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2__gallery__["a" /* default */], {
  swipeThreshold: 100,
  isIndexShow: true,
  useCloseButton: true,
  preload: false
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

// demo 实例创建

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */

/*  */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(12).setImmediate))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(13);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(14)))

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16af47fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(31);
function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16af47fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16af47fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(17);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d7bc9690", content, true, {});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".thumbnail[data-v-16af47fe]{display:block;float:left;margin:3px;height:100px;width:100px;object-fit:cover}pre[data-v-16af47fe]{font-family:Monaco;color:#fff;padding:.5rem}p[data-v-16af47fe]{background:#4d4d4d}header[data-v-16af47fe]{font-size:2rem;color:#fff}footer[data-v-16af47fe]{font-size:1rem;color:#fff}.descript[data-v-16af47fe]{font-size:1.3rem;color:#9a9a9a;margin-bottom:2rem}.subtitle[data-v-16af47fe]{font-size:1.2rem;color:#a7a8aa;margin-bottom:1rem}.vue-green[data-v-16af47fe]{color:#4fc08d}.iconfont[data-v-16af47fe]{font-size:1.5rem;margin:.3rem}.gray[data-v-16af47fe]{color:#ccc}.card[data-v-16af47fe]{position:relative;background-color:#fffaf0;//background-color:#90ee90;width:26em;height:9em;margin:.5em;padding:.2em;font-family:sans-serif;box-shadow:0 0 10px 2px rgba(0,0,0,.3)}puf[data-v-16af47fe]{float:left;padding:5px}.v-enter[data-v-16af47fe]{opacity:0}.v-enter-active[data-v-16af47fe]{transition:opacity 2s}", ""]);

// exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {function snow(props) {

  var speed = props.speed;
  var color = props.color;
  var zIndex = props.zIndex;
  var wind = props.wind;
  var swing = props.swing;

  var canvas = getCanvas(zIndex);
  window.onresize = function () {
    canvas = canvasResize(canvas);
  };
  //let it snow, let it snow, ...
  var itSnow = snowflakes(color, wind, swing);
  setInterval(function () {
    return itSnow(canvas);
  }, speed);
}

function getCanvas(zIndex) {
  var canvas = document.getElementById('vue-niege-canvas');
  canvas.style.pointerEvents = "none";
  canvas.style.position = "fixed";
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.width = "100vw";
  canvas.style.height = "100vh";
  canvas.style.zIndex = zIndex;
  canvas.style.userSelect = "none";
  return canvasResize(canvas);
}

function canvasResize(currentCanvas) {
  currentCanvas.height = currentCanvas.offsetHeight;
  currentCanvas.width = currentCanvas.offsetWidth;
  return currentCanvas;
}

//KUDOS to Pimp Trizkit, https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
function shadeBlend(p, c0, c1) {
  var n = p < 0 ? p * -1 : p,
      u = Math.round,
      w = parseInt;
  var f = w(c0.slice(1), 16),
      t = w((c1 ? c1 : p < 0 ? "#000000" : "#FFFFFF").slice(1), 16),
      R1 = f >> 16,
      G1 = f >> 8 & 0x00FF,
      B1 = f & 0x0000FF;

  if (R1 > 255 || G1 > 255 || B1 > 255) {
    return '#FFFFFF';
  }

  return "#" + (0x1000000 + (u(((t >> 16) - R1) * n) + R1) * 0x10000 + (u(((t >> 8 & 0x00FF) - G1) * n) + G1) * 0x100 + (u(((t & 0x0000FF) - B1) * n) + B1)).toString(16).slice(1);
}

function getColorsArray(selectedColor) {
  if (selectedColor === "#FFFFFF") {
    return [selectedColor, '#F2FFFF', '#D8FFFF', '#BEFFFF'];
  } else {
    var shadedcolor1 = shadeBlend(.7, selectedColor);
    var shadedcolor2 = shadeBlend(.6, selectedColor);
    var shadedcolor3 = shadeBlend(.5, selectedColor);
    return [selectedColor, shadedcolor1, shadedcolor2, shadedcolor3];
  }
}

function snowflakeColor(snowflakeColors) {
  return snowflakeColors[Math.floor(Math.random() * snowflakeColors.length) - 1];
}

function snowflakes(color, wind, swing) {

  var flakes = [];
  var selectedColors = getColorsArray(color);

  var swingFlake = function (flakeSwing, velX) {
    if (swing === 0) {
      return velX;
    } else {
      return 0.4 * Math.cos(flakeSwing += 0.03) * swing + velX;
    }
  };

  return function (canvas) {
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    var random = Math.random();
    var distance = .05 + .95 * random;
    var flake = {};
    flake.x = 1.5 * canvas.width * Math.random() - .5 * canvas.width;
    flake.y = -5 + Math.random();
    var flakeFallingSpeed = 2 * distance * (Math.random() / 2);
    flake.velX = Math.abs(flakeFallingSpeed) < Math.abs(wind) ? flakeFallingSpeed + wind / 20 : wind;
    flake.velY = (4 + 2 * Math.random()) * distance;
    flake.radius = Math.pow(3 * random, 2) / 3;
    flake.color = "" + snowflakeColor(selectedColors);
    flake.swing = Math.random() * 2 * Math.PI;
    flake.update = function () {
      var t = this;
      t.x += swingFlake(t.swing, t.velX);
      t.y += t.velY;
      ctx.beginPath();
      ctx.arc(t.x, t.y, t.radius, 0, 2 * Math.PI, !1);
      ctx.fillStyle = t.color;
      ctx.fill();
    };

    flakes.push(flake);
    flakes.forEach(function (elem, i) {
      elem.y > canvas.height ? flakes.splice(i, 1) : elem.update();
    });
  };
}

//

var script = {
  name: "Snow",
  mounted: function () {
    this.launchSnowing();
  },

  updated: function () {
    this.launchSnowing();
  },

  methods: {
    launchSnowing: function () {
      if (this.active === true) {
        snow({
          speed: this.fallingSpeed(),
          color: this.color,
          zIndex: this.zIndex,
          wind: this.wind,
          swing: this.swing
        });
      }
    },

    fallingSpeed: function () {
      switch (this.speed) {
        case 'l':
          return 60;
        case 'h':
          return 5;
        default:
          return 20;
      }
    }
  },

  props: {
    color: {
      type: String,
      validator: function (value) {
        return value.length === 7;
      },
      default: "#00FFFF"
    },
    speed: {
      type: String,
      validator: function (value) {
        return value === 'h' || value === 'm' || value === 'l';
      },
      default: 'm'
    },
    zIndex: {
      type: String
    },
    active: {
      type: Boolean,
      default: true
    },
    wind: {
      type: Number,
      default: 1
    },
    swing: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showSnow: function () {
      return this.active === true;
    }
  }
};

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showSnow ? _c("canvas", { attrs: { id: "vue-niege-canvas" } }) : _vm._e();
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

/* style */
var __vue_inject_styles__ = function (inject) {
  if (!inject) {
    return;
  }
  inject("data-v-f767568c_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: { "version": 3, "sources": [], "names": [], "mappings": "", "file": "Snow.vue" }, media: undefined });
};
/* scoped */
var __vue_scope_id__ = undefined;
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* component normalizer */
function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

  // For security concerns, we use only base name in production mode.
  component.__file = "C:\\SRC\\React\\vue-niege\\src\\Snow.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;

    if (functional) {
      component.functional = true;
    }
  }

  component._scopeId = scope;

  {
    var hook;
    if (style) {
      hook = function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;
        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */
function __vue_create_injector__() {
  var head = document.head || document.getElementsByTagName('head')[0];
  var styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
  var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

  return function addStyle(id, css) {
    if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) {
      return;
    } // SSR styles are present.

    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

    if (!style.ids.includes(id)) {
      var code = css.source;
      var index = style.ids.length;

      style.ids.push(id);

      if (isOldIE) {
        style.element = style.element || document.querySelector('style[data-group=' + group + ']');
      }

      if (!style.element) {
        var el = style.element = document.createElement('style');
        el.type = 'text/css';

        if (css.media) {
          el.setAttribute('media', css.media);
        }
        if (isOldIE) {
          el.setAttribute('data-group', group);
          el.setAttribute('data-next-index', '0');
        }

        head.appendChild(el);
      }

      if (isOldIE) {
        index = parseInt(style.element.getAttribute('data-next-index'));
        style.element.setAttribute('data-next-index', index + 1);
      }

      if (style.element.styleSheet) {
        style.parts.push(code);
        style.element.styleSheet.cssText = style.parts.filter(Boolean).join('\n');
      } else {
        var textNode = document.createTextNode(code);
        var nodes = style.element.childNodes;
        if (nodes[index]) {
          style.element.removeChild(nodes[index]);
        }
        if (nodes.length) {
          style.element.insertBefore(textNode, nodes[index]);
        } else {
          style.element.appendChild(textNode);
        }
      }
    }
  };
}
/* style inject SSR */

var component = __vue_normalize__({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, __vue_create_injector__, undefined);

// Import vue component

// install function executed by Vue.use()
function install(Vue) {
  if (install.installed) {
    return;
  }
  install.installed = true;
  Vue.component('Snow', component);
}

// Create module definition for Vue.use()
var plugin = {
  install: install
};

// To auto-install when vue is found
/* global window global */
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

/* harmony default export */ __webpack_exports__["a"] = (component);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(21);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6210cb00", content, true, {});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".prevent-pass-through[data-v-5137d006]{position:fixed;height:100%;width:100%;z-index:9;display:none}.prevent-pass-through-show[data-v-5137d006]{display:block}.words[data-v-5137d006]{position:absolute;text-align:center;color:#f0f8ff;text-shadow:-1px -1px 0 #111,1px -1px 0 #111,-1px 1px 0 #111,1px 1px 0 #111}.index[data-v-5137d006]{bottom:20px;width:100%}.close-btn[data-v-5137d006]{top:5px;right:5px;padding:5px;font-size:1.2rem}.slider[data-v-5137d006]{position:fixed;top:100%;width:100%;left:0;height:100%;overflow:hidden;z-index:1000;opacity:0;-webkit-touch-callout:none;user-select:none}.item-wrapper[data-v-5137d006]{display:flex;justify-content:flex-start;height:100%}.item[data-v-5137d006]{height:100%;flex-basis:100%;flex-shrink:0}.z1[data-v-5137d006]{z-index:1}.open[data-v-5137d006]{animation:open-data-v-5137d006 .3s;animation-fill-mode:forwards}@keyframes open-data-v-5137d006{0%{opacity:0;transform:translateY(0)}to{opacity:1;transform:translateY(-100%)}}.close[data-v-5137d006]{animation:close-data-v-5137d006 .3s;animation-fill-mode:forwards}@keyframes close-data-v-5137d006{0%{opacity:1;transform:translateY(-100%)}to{opacity:0;transform:translateY(0)}}", ""]);

// exports


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuerSingle_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71bc12ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuerSingle_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71bc12ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuerSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71bc12ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuerSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(24);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4e8a3b4a", content, true, {});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".img-vuer[data-v-71bc12ee]{position:relative;width:100%;height:100%;display:none}", ""]);

// exports


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubleBounce_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cfa1aea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubleBounce_vue__ = __webpack_require__(28);
function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cfa1aea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubleBounce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cfa1aea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubleBounce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(27);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("50367857", content, true, {});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".spinner[data-v-1cfa1aea]{width:40px;height:40px;margin:calc(50vh - 20px) auto;position:relative}.double-bounce1[data-v-1cfa1aea],.double-bounce2[data-v-1cfa1aea]{width:100%;height:100%;border-radius:50%;background-color:#ccc;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:sk-bounce-data-v-1cfa1aea 2s infinite ease-in-out;animation:sk-bounce-data-v-1cfa1aea 2s infinite ease-in-out}.double-bounce2[data-v-1cfa1aea]{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-bounce-data-v-1cfa1aea{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce-data-v-1cfa1aea{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);

// exports


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"double-bounce2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transform",rawName:"v-transform"},{name:"finger",rawName:"v-finger:pinch",value:(_vm.handlePinch),expression:"handlePinch",arg:"pinch"},{name:"finger",rawName:"v-finger:doubleTap",value:(_vm.handleDoubleTap),expression:"handleDoubleTap",arg:"doubleTap"},{name:"finger",rawName:"v-finger:multipointStart",value:(_vm.handleMultipointStart),expression:"handleMultipointStart",arg:"multipointStart"},{name:"finger",rawName:"v-finger:pressMove",value:(_vm.handlePressMove),expression:"handlePressMove",arg:"pressMove"},{name:"finger",rawName:"v-finger:touchEnd",value:(_vm.handleTouchEnd),expression:"handleTouchEnd",arg:"touchEnd"}],staticClass:"img-vuer"},[_c('img',{directives:[{name:"transform",rawName:"v-transform"}],staticStyle:{"position":"absolute"},attrs:{"src":_vm.srcDelay}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"prevent-pass-through"}),_vm._v(" "),_c('div',{directives:[{name:"finger",rawName:"v-finger:singleTap",value:(_vm.handleTapClose),expression:"handleTapClose",arg:"singleTap"}],staticClass:"slider",style:({'background-color':_vm.backgroundColor})},[_c('div',{directives:[{name:"transform",rawName:"v-transform"},{name:"finger",rawName:"v-finger:pressMove",value:(_vm.handlePressMove),expression:"handlePressMove",arg:"pressMove"},{name:"finger",rawName:"v-finger:touchStart",value:(_vm.handleTouchStart),expression:"handleTouchStart",arg:"touchStart"},{name:"finger",rawName:"v-finger:touchEnd",value:(_vm.handleTouchEnd),expression:"handleTouchEnd",arg:"touchEnd"},{name:"finger",rawName:"v-finger:swipe",value:(_vm.handleSwipe),expression:"handleSwipe",arg:"swipe"}],staticClass:"item-wrapper"},_vm._l((_vm.imgList),function(src,index){return _c('VuerSingle',{key:src + index,ref:"img",refInFor:true,staticClass:"item",class:{z1:_vm.currentIndex===index},attrs:{"src":src},on:{"disableSwipe":function($event){_vm.allowSwipe = false},"enableSwipe":function($event){_vm.allowSwipe = true}}})}),1),_vm._v(" "),(_vm.useCloseButton)?_c('div',{staticClass:"words close-btn",on:{"click":function($event){return _vm.handleTapClose(null,null,true)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.isIndexShow)?_c('div',{staticClass:"words index"},[_vm._v(_vm._s(_vm.currentIndex + 1 + '/' + _vm.imgList.length))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroller',[_c('div',{staticStyle:{"padding":"20px"}},[_c('header',[_c('i',{staticClass:"iconfont icon-image"}),_vm._v("img\n      "),_c('span',{staticClass:"vue-green"},[_vm._v("Vue")]),_vm._v("r of Trips with "),_c('span',{staticClass:"vue-green"},[_vm._v("Burnabyoutdoor.com")])]),_vm._v(" "),_c('div',{staticClass:"descript"},[_vm._v("\n      Burnabyoutdoor Club for Nature Lovers, Burnaby, BC, Canada\n    ")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Check the latest monthly newsletter\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"http://www.burnabyoutdoor.com/pdfs/BOC%20Newsletter.pdf","title":"BOC Newsletter"}},[_vm._v("BOC Newsletter")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.showNews = !_vm.showNews}}},[_c('span',{staticClass:"vue-green"},[_vm._v("Breaking News")])]),_vm._v(" "),_c('transition',{attrs:{"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"enter-cancelled":_vm.enterCancelled,"before-leave":_vm.beforeLeave,"leave":_vm.leave,"after-leave":_vm.afterLeave,"leave-cancelled":_vm.leaveCancelled}},[(_vm.showNews)?_c('div',{staticStyle:{"width":"400px","height":"100px","background-color":"FloralWhite"}},[_c('puff',[_c('article',[_c('h3',[_c('span',{staticClass:"vue-green"},[_vm._v("\n                            Breaking news\n                            ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"vue-green"},[_vm._v("\n                            BOC is operating in groups of six following Health Canada restrictions. Larger number of participants are allowed. Stay tuned!\n                            Take a leap of faith and begin this wondrous New year 2023 by believing!\n                            ")])])])])],1):_vm._e()])],1),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list0),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group0",arg:"group0"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list0_5),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery",value:('group0_5'),expression:"'group0_5'"}],key:img.src + index,staticClass:"thumbnail",attrs:{"data-index":index,"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Brothers Creek, June 1, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250601Bros\\20250601Bros.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list218),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group218",arg:"group218"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Stawamus Chief, 2nd Peak, April 27th, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250427Chief\\20250427ChiefTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list217),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group217",arg:"group217"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Mt Gardner Hike, April 19th, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250419GardnerMnt\\20250419mntGardTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list216),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group216",arg:"group216"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Norvan Falls Hike, April 12, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250412NorvanFalls\\20250412NorvanFallsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list215),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group215",arg:"group215"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Fraser River Walk, March 30th 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250330FraserRiver\\20250330frTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list214),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group214",arg:"group214"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Boundary Bay Regional Park, March 16, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250316bbay\\20250316bbayTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list213),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group213",arg:"group213"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Lynn Loop and Headwaters, Rice Lake Hike, March 1, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250301Rice\\20250301RiceTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list212),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group212",arg:"group212"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Derby Reach Regional Park, February 23, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250223Derby\\20250223DerbyTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list211),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group211",arg:"group211"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Bowe Lookout, February 09, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250209Bowe\\20250209BoweTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list210),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group210",arg:"group210"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  South Dyke Trail, Richmond, January 26, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250126SDyke\\20250126SDykeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list209),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group209",arg:"group209"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Belcarra Park - Jug Island, January 25, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250125Jug\\20250125JugTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list208),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group208",arg:"group208"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Polar Bear Event, Barnet Marine Park, January 1, 2025\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20250101PolarBear\\20250101PolarBearTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list207),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group207",arg:"group207"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Old Buck Trail to Quarry Rock, December 19, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241219OldBuck\\20241219OldBuckTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list206),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group206",arg:"group206"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Poco Trail Cycle Trip, December 1. 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241201Poco\\20241201PocoTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list205),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group205",arg:"group205"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Buntzen Lakeview Hike, Nov 17, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241117Buntzen\\20241117BuntzenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list204),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group204",arg:"group204"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Minnekhada Regional Park, Nov 07, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241107Minnekhada\\20241107MinnekhadaTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list203),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group203",arg:"group203"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Norvan Falls, Nov 02, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241102NorVan\\20241102NorVanTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list202),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group202",arg:"group202"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Campbell Valley Regional Park, October 27, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\202241027Campbell\\20241027CampbellTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list201),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group201",arg:"group201"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Petgill Lake Hike, Oct 10, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241010Petgill\\20241010PetgillTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list200),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group200",arg:"group200"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Baden Powell Trail, Cypress Bowl to Eagle Bluff, October 4, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20241004BPcbToEb\\20241004BPcbToEbTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list199),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group199",arg:"group199"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Chilliwack: Vedder Loop, September 29, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240929Chil\\20240929ChilRT.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list198),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group198",arg:"group198"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Chain Lakes hike, Mt Baker, September 21, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240921Chain\\20240921ChainTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list197),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group197",arg:"group197"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Sawblade Falls Hike, September 14, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240914Sawblade\\20240914SawbaldeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list196),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group196",arg:"group196"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Aldergrove Regional Park, September 8, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240908Aldergrove\\20240908AldergroveTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list195),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group195",arg:"group195"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Dog Mt & Suicide Bluffs Hike, Aug 31, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240831Dog\\20240831DogTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list194),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group194",arg:"group194"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Richmond Dykes Bike Ride, Sep 1, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240901RcmdDykes\\20240901RcmdDykesTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list193),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group193",arg:"group193"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Pacific Spirit Park and Beach, Aug 11, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240811Pacific\\20240811PacificTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list192),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group192",arg:"group192"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Lake Ann Trail, Mt. Baker, Aug 5th, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240805LakeAnn\\20240805LakeAnnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list191),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group191",arg:"group191"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Lower Hollyburn, July 21st, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240721LoHolly\\20240721LoHollyTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list190),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group190",arg:"group190"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Mount Strachan, July 14th, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240714Strachan\\20240714StrTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list189),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group189",arg:"group189"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Baden Powell Trail, Brothers Creek to Cypress Bowl Yew Lake, July 11th, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240711BPbctoyew\\20240711BPbctoyewTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list188),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group188",arg:"group188"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Black Mountain and Eagle Bluffs Hike, July 6th, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240708EBluffs\\20240706EBluffsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list187),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group187",arg:"group187"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Elk Thruston Trail, July 1st, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240701ElkT\\20240710ElkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list186),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group186",arg:"group186"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Brandywine Falls Loop, June 23, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240623BrandyWine\\20240623BrandyWineTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list185),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group185",arg:"group185"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Baden-Powell Trail Part 5, Cleveland Dam to Brothers Creek, June 20, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240620BP5\\20240620bpTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list184),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group184",arg:"group184"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  UBC Malcolm Knapp Research Forest Hike, June 16, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240616ubcrf\\20240616ubcrfTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list183),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group183",arg:"group183"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Confed, McGill, New Brighton Parks Hike, June 08, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240608Confed\\20240608ConfedTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list182),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group182",arg:"group182"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Mt Gardner Bowen Island, May 11, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240511MtGardner\\20240511MtGardnerTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list181),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group181",arg:"group181"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Boundary Bay Regional Park & Dyke: May 05, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240505BBRPD\\20240405bbrpdTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list180),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group180",arg:"group180"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Hayward Lake Hike, May 04, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240504Haywart\\20240504HaywardTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list179),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group179",arg:"group179"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Kayaking @ Barnet Marine Park, May 04, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240504Kayak\\20240504KayakTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list178),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group178",arg:"group178"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Norvan Falls Hike, April 28, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240428NFalls\\20240428NFallsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list177),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group177",arg:"group177"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Central Valley Greenway Bike Ride, April 14, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240414cvg\\20240414cvgTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list176),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group176",arg:"group176"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Burnaby Mountain Loop Trail, April 7th, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240407bml\\20240407bmlTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list175),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group175",arg:"group175"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Reifel Bird Sanctuary and Richmond W. Dyke, April 6, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240406Reifel\\20240406ReifelTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list174),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group174",arg:"group174"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Baden Powell Trail Part 4: Mosquito Creek to the Base of Grouse Mountain, Apil 01, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240401MCtoGM\\20240401MCtoGMtr.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list173),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group173",arg:"group173"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Surrey Greenways bike ride, March 31, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240331br\\20240331brTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list172),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group172",arg:"group172"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Baden Powell Trail Part 3: Lynn Headwater to Mosquito Creek, March 22, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240322LHtoMC\\20240322LHtoMCtr.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list171),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group171",arg:"group171"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Buntzen Lake to Sasamat Lake, March 09, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\202340309BS\\20240309bsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list170),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group170",arg:"group170"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Fort-to-Fort Trail, March 10, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\202410310Fort\\20240310FortTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list169),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group169",arg:"group169"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Iona Beach hike, March 03, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240303Iona\\20240303IonaTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list168),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group168",arg:"group168"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Rice Lake and Fisherman’s Trail loop, February 24, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240224Rice\\20240224RiceTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list167),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group167",arg:"group167"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("  Lower Seymour Conservation Reserve, February 24, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240225Conserv\\20240225ConservTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list166),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group166",arg:"group166"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Mosquito & Mahon Creeks, February 18, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240218Mahon\\MahonTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list165),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group165",arg:"group165"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Baden-Powell Trail (Hyannis Point to Lynn Headwaters), Feb 3, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240203HiannisHead\\20240203HainnisHeadTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list164),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group164",arg:"group164"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Indian Arm Parks, North Van, January 6, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240106iarm\\20240106iarmTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list163),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group163",arg:"group163"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Polar Bear Event, January 01, 2024\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20240101PolarBear\\20240101PolarBearTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list162),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group162",arg:"group162"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Grouse Mountain, December 30, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20231230Grouse\\20231230GrouseTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list161),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group161",arg:"group161"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Baden-Powell Trail (Hyannis Point to Quarry Rock), December 26, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20231226Baden\\20231226bpTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list160),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group160",arg:"group160"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Lynn Creek and Seymour River hike, December 17, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20231217Lynn\\20231217LynnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list159),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group159",arg:"group159"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Minnekhada hike, December 09, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img\\20231209Minn\\20231209MinnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list158),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group158",arg:"group158"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" BOC's Year End Party, November 25, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231125Xmas/20231125XmasTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list156),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group156",arg:"group156"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Burnaby Lake Walk, November 22, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231122BbyLake/20231122BbyLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list157),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group157",arg:"group157"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Historic Mushroom hike, November 18, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231118HM/20231118hmTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list155),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group155",arg:"group155"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Buntzen Lakeview Trail, November 12, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231112BL/20231112blTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list154),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group154",arg:"group154"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Belcarra Park, October 28, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231028Belcarra/20231028BelcarraTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list153),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group153",arg:"group153"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Lighthouse Park, October 22, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231022LHPark/202310LHParkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list152),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group152",arg:"group152"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Hollyburn Peak hike, Oct 14, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231018Hollyburn/20231014HollyburnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list151),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group151",arg:"group151"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Mary Hill, Colony Farm Oct 15, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231015MHFarm/20231015MHFarmTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list150),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group150",arg:"group150"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Cypress Falls and Whyte Lake Hike, Oct 8, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231008CW/20231008cwTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list149),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group149",arg:"group149"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Vedder Loop Hike, Oct 1, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20231001VLoop/20231001VLoopTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list148),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group148",arg:"group148"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Diez Vistas Hike, Sep 30, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230930DV/20230930dvTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list147),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group147",arg:"group147"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Ptarmigan Ridge Trail, Sep 16, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230916Ptrarmigan/20230916PtarmiganTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list146),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group146",arg:"group146"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Al's Habrich Ridge Trail, Sep 10, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230912AlHabrich/20230910AlHabrichTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list145),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group145",arg:"group145"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Tynehead-Green Timbers Parks Bike Ride, Sep 09, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230908TH/20230909thTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list144),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group144",arg:"group144"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Burnaby Mt Loop Hike, Sep 02, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230902BbyMnt/20230902BbyMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list143),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group143",arg:"group143"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" August 20, 2023, Happy 80th Birthday Gerard!\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"https://photos.app.goo.gl/sBhx3aaH9ZL27HsH6","title":"t"}},[_vm._v("Photos")]),_vm._v(" "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230820Gerard/GerardBdayR.pdf","title":"Report"}},[_vm._v("Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list142),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group142",arg:"group142"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Point Grey Tour, Aug 13, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230813PG/20230813PGTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list141),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group141",arg:"group141"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" St Mark's Summit Hike, Aug 12, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230812StMark/20230812StMarkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list140),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group140",arg:"group140"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Garibaldi Lake Hike, Aug 4, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230804Garib/20230804GaribTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list139),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group139",arg:"group139"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Black Mountain, July 30, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230730BlackMnt/20230730BlackMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list138),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group138",arg:"group138"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Four Lakes Trail & Alice Lake Potluck, July 22, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230722Alice/20230722AliceTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list137),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group137",arg:"group137"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Petgill Lake, July 16, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230716Pet/20230716PetTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list136),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group136",arg:"group136"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Burnaby Mountain, July 9, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230709BbyMnt/20230709BbyMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list135),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group135",arg:"group135"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" ELK Mountain Hike, July 1, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230701Elk/20230701ElkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list134),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group134",arg:"group134"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Mt. Gardener, Bowen Island, June 24th, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230624Bowen/20230524BowenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list133),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group133",arg:"group133"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" Cheakamus Canyon Hike, June 04, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230604Cheak/20230504CheakTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list132),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group132",arg:"group132"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Barbara Waldern's Alberta Walks, June 02, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230602Alberta/20230602AlbertaTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list131),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group131",arg:"group131"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Confederation Trail, Sunday May 28, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230528Conf/20230528ConfTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list130),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group130",arg:"group130"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Poco Trail Bike Trip, Sunday May 21, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230521Poco/20230521PocoTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list129),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group129",arg:"group129"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hayward Lake Hike, May 13, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230513Hayward/20230513HaywardTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list128),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group128",arg:"group128"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Seymour Canyon and Lynn Canyon Loop, May 6, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230506SL/20230506slTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list127),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group127",arg:"group127"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Sunshine Coast -- Soames Hill & Gibsons, May 7, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230507SC/20230507SCTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list126),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group126",arg:"group126"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Norvan Falls, April 29th, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230429NVFalls/20230429NVFallsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list125),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group125",arg:"group125"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Aldergrove Regional Park & Serpentine Fen, April 23, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230423Ald/20230423AldTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list124),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group124",arg:"group124"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen Lake to Sasamat Lake, April 15th, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230415Buntzen/20230415BunTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list123),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group123",arg:"group123"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Coquitlam Crunch and Shoreline Trail, April 7th, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230407Coq/20230407CoqTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list122),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group122",arg:"group122"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Indian Arm Parks, North Van., March 26, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230326IndArm/20230326indarmTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list121),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group121",arg:"group121"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Reifel Bird Sanctuary, Delta, and West Dyke Trail, Richmond, March 18, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230318Reifel/20230318ReifelTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list120),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group120",arg:"group120"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Burnaby Mountain area to Port Moody, March 12, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230312BbyMnt/20230312BbyMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list119),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group119",arg:"group119"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Black Mnt Snowshoe Hike, March 04, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230304Black/20230304BlackTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list118),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group118",arg:"group118"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Seymour River & Lynn Creek Hike, February 18, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230218Lynn/20230218LynnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list117),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group117",arg:"group117"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mt Seymour-Dinkey Peak an First Lake Snowshoe Hike, February 12, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230212Dinkey/20230212DinkeyTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list116),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group116",arg:"group116"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mosquito & Mahon Creeks, February 5, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230205Mosquito/20230205MosquitoTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list115),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group115",arg:"group115"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Vancouver’s Seawall & Seaside (English Bay, Science World), January 29, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230129Seawall/20230129SeawallTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list114),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group114",arg:"group114"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Campbell Valley Regional Park, January 22nd, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230122Campbell/20230122CampbellTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list113),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group113",arg:"group113"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen Lakeview Trail Hike, January 21st, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230121Buntzen/20230121BuntzenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list112),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group112",arg:"group112"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Bowen Lookout, January 15th, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230115Bowen/20230115BowenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list111),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group111",arg:"group111"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Poco Trail, January 7th, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230107Poco/20230107PocoTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list110),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group110",arg:"group110"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Barnet Marine Park, Polar Bear Walk & Swim, January 1st, 2023\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20230101Barnet/20230101BarnetTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list109),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group109",arg:"group109"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Burnaby Mountain Walk, December 26th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221226bbymnt/20221226bbymntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list108),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group108",arg:"group108"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Burnaby Lake Walk, December 3rd, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/202212033BbyLake/20221203BbyLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list107),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group107",arg:"group107"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Lynn Creek and Seymour River, November 27th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221127Lynn/20221127LynnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list106),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group106",arg:"group106"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Knoll, Nicomekl and Redwood Parks, November 20th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221120Knoll/20221120KnollTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list105),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group105",arg:"group105"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Woodhaven Swamp to Sasamat Lake, November 13th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221113Wood/20221113WoodTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list104),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group104",arg:"group104"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Burnaby Mountain Loop, Friday, November 11th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221111BbyMnt/20221111BbyMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list103),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group103",arg:"group103"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Norvan Falls, Lynn Headwaters & Cedars Mill, November 05, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221105Norvan/20221105NorvanTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list102),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group102",arg:"group102"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Killarney Lake and Dorman Point, Bowen Island, October 22, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221022Dorman/20221022DormanTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list101),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group101",arg:"group101"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Caulfeild Trail & Lighthouse Park, October 15, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221015Caul/20221015CaulTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list100),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group100",arg:"group100"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Belcarra Park - Jug Island, October 10, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221010Jug/20221010jugTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list99),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group99",arg:"group99"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hollyburn Peak Hike,October 1, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20221001Holly/20221001HollyTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list98),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group98",arg:"group98"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mount Seymour, Peaks 1 and 2, September 25, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220925Peaks/20220925PeaksTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list97),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group97",arg:"group97"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("BOC 30th Anniversary BBQ, Buntzen Lake, Sep 17, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220917BOC30thAnniversary/20220917BOC30thAnniversaryTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list96),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group96",arg:"group96"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mystery Falls and Historic Mushroom, Sep 04, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220904Mistery/20220904MisteryTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list95),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group95",arg:"group95"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("St. Mark's Summit hike, Aug 27, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220827StMark/20220827StMarkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list94),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group94",arg:"group94"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Dog Mountain & Suicide Bluffs hike, Aug 21, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220822Dog/20220821DogTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list93),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group93",arg:"group93"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Tynehead Regional Park, Surrey Lake & Fleetwood Park -- August 14, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220814Tynehead/20220814TyneheadTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list92),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group92",arg:"group92"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Elfin Lakes, August 9, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220809Elfin/20220809ElfinTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list91),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group91",arg:"group91"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mt Gardner Bowen Island - July 31, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220731MntGardner/20220731MntGardnerTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list90),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group90",arg:"group90"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Black Mountain & Eagle Bluffs, July 17, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220717EagleBluffs/20220717EagleTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list89),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group89",arg:"group89"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hollyburn Four Lakes Hike, July 10, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220710FourLakes/20220710FourLakesTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list88),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group88",arg:"group88"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Elk Mountain, July 01, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220701ElkMnt/2020701ElkMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list87),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group87",arg:"group87"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Brohm Lake Hike, June 26, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220626Brohm/20220626BrohmTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list86),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group86",arg:"group86"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Boundary Bay Regional Park & Dyke, June 19, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220619Dyke/20220619DykeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list85),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group85",arg:"group85"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Golden Ears, East and West Canyon Trails - loop hike, June 12, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220612GoldenEars/20220612GoldenEarsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list84),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group84",arg:"group84"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("The Seymour River Lynn Canyon Loop, June 04, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220604Lynn/20220604LynnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list83),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group83",arg:"group83"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Whistler Train Wreck and Cheakamus River hike, May 29, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220529Whistler/20220529WhistlerTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list82),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group82",arg:"group82"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Norvan Falls, May 22, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220522NorVan/20220522NorVanTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list81),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group81",arg:"group81"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Soames Hill and Gibsons, May 8, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220508Hill/20220508HillTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list80),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group80",arg:"group80"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Crescent Beach Walk, May 1, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220501CrescentBeach/20220501CrescentBeachTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list78),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group78",arg:"group78"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Cypress Falls and Whyte Lake, April 24, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220422CypressFallWhyteLake/20220424CypressFallWhyteLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list77),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group77",arg:"group77"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Butnzen and Sasamat Lake, April 15, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220415BuntzenSasamat/20220415BuntzenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list79),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group79",arg:"group79"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hayward Lake, April 10, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220410HywardLake/20220410HywardLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list76),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group76",arg:"group76"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Coquitlam Crunch, April 03, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20020403Coquitlam/CoquitlamCrunchTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list75),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group75",arg:"group75"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Woodhaven Swamp and Sasamat Lake, March 20, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220320Woodhaven/20220320WoodhavenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list74),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group74",arg:"group74"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Burnaby Mountain, March 13, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220313BbyMnt/20220313BbyMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list73),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group73",arg:"group73"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mount Seymour, Brockton Point, March 6, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220306MntSeymour/20220306MntSeymourTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list72),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group72",arg:"group72"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Indian Arm Parks, North Van, February 21, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220221IndianArm/20220222IndianArmTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list71),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group71",arg:"group71"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("New Westiminster Quay, Edmonds, February 12, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220212NewWest/20220212NewWestTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list70),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group70",arg:"group70"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Black Mountain, Cypress, February 06, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220206BlackMnt/20220206BlackMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list69),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group69",arg:"group69"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Polar Bear Lunar New Year Event, February 01, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220201PolarBearLunar/20220201PolarTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list68),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group68",arg:"group68"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Lynn Loop and Headwaters/Rice Lake, January 29th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220129LynnLoop/20220129LynnLoopTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list67),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group67",arg:"group67"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Bowen Lookout, January 16th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220116Bowen/20220116BowenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list66),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group66",arg:"group66"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Vancouver Downtown's Seawall Walk, II, January 9th, 2022\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20220109SeaWall/20220109SeaWallTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list65),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group65",arg:"group65"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Vancouver Downtown's Seawall Walk, December 19th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211219SeaWall/20211213SeaWallWalkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list64),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group64",arg:"group64"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Lynn Canyon and Seymour River Trails, December 05th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211205LynnSeymour/20211205LynnSeymourTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list63),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group63",arg:"group63"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Sasamat Lake to Diez Vistas, November 21st, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211121SasamtDiezVista/20211121SasamatDiezVistaTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list62),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group62",arg:"group62"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Killarney Lake and Dorman Point, Bowen Island, October 31st, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211031KLDPBowen/20211031KLDPBowenTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list61),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group61",arg:"group61"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Historic Mushroom Hike, October 26th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211026HistoricMushroom/20211026HistoricMushroomTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list60),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group60",arg:"group60"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Elgin Heritage Park and SunnySide Acres Urban Forest, October 11th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211011ElginHeritage/20211011ElginHeritageTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list59),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group59",arg:"group59"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hollyburn Peak, October 03rd, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20211003HollyburnPeak/20211003HollyburnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list58),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group58",arg:"group58"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen to Sasamat Lakes, September 12th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210912BuntzenToSasamat/20210912BuntzenToSasamatTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list57),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group57",arg:"group57"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Elfin Lakes, August 31st, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210831ElfinLakes/20210831ElfinLakesTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list56),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group56",arg:"group56"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Cypress Falls To Whyte Lake Trail, August 22nd, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210822CypressFallToWhyteLake/20210822CypressFallsToWhyteLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list55),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group55",arg:"group55"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("St Mark's Summit Hike, August 8th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210808StMarksSummit/20210808StMarksSummitTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list54),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group54",arg:"group54"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Seymour River and Lynn Canyon Loop, August 2th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210802SeymourRiverLynnCanyonLoop/20210802SeymourLynnTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list53),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group53",arg:"group53"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mamquam River and Smoke Bluffs Park, July 25th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210725MamquamRiver/20210725MamquamTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list52),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group52",arg:"group52"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Black Mountain - Yew Lake, July 11th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210711YewBlackMnt/20210711BlackMntTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list51),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group51",arg:"group51"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen Lake Hike, July 05th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210705BuntzenLake/20210705BuntzenLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list50),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group50",arg:"group50"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Crescent Beach and Park in Surrey, July 01st, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210701CrescentBeach/20210701CrescentTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list49),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group49",arg:"group49"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Poco Trail Bike Trip, June 06th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210606Poco/20210606PocoTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list48),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group48",arg:"group48"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Shoreline Trail and Coquitlam Crunch, May 30th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20213005Shoreline/20213005ShorelineTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list47),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group47",arg:"group47"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Whyte Lake, May 23rd, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210523WhiteLake/2021-05-23-White-Lake-TR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list46),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group46",arg:"group46"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Minnekhada Regional Park, May 8th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210508Minnekhada/20210508MinnekhadaRPTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list45),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group45",arg:"group45"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Chadsey Lake, April 18th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210418ChadseyLake/20210418ChadseyLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list44),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group44",arg:"group44"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Fisherman's Trail, April 11th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210411Fisherman/20210411FishermanTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list43),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group43",arg:"group43"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Great Trail - Trans Canada Trail, April 04th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210404TransCanadaTrail/20210404TCTTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list42),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group42",arg:"group42"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Brohm Lake, March 25th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210325BrohmLake/20210325BrohmLakeTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list41),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group41",arg:"group41"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen Lake, March 14th, 2021\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20210314Buntzen/20210314-Buntzen-Lake-Trail.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list40),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group40",arg:"group40"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hayward Lake Reservoir, November 8th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20201108HaywardLake/HaywardLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list39),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group39",arg:"group39"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Fisherman's Trail, November 1st, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20201101FishermansTrail/FishermansTrailTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list38),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group38",arg:"group38"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Gold Creek Canyon, October 25th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20201025GoldCreekCanyon/GoldCreekCanyonTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list37),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group37",arg:"group37"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Campbell Valley Regional Park, October 18th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20201018CampbellValley/20201018CampbellValleyTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list36),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group36",arg:"group36"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("UBC Research Forest, October 4th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20201004UBCRForest/20201004UBCRForestTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list35),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group35",arg:"group35"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen to Sasamat Lake, September 27th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200927BuntzenToSasamatLake/20200927BuntzenToSasamatTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list34),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group34",arg:"group34"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Sumas Bike Ride, September 20th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200920Sumas/0200920SumasBikeRideTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list33),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group33",arg:"group33"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Historic Mushroom, September 09th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200906HistoricMushroom/20200906HistoricMushroom.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list31),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group31",arg:"group31"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Greendrop and Lindeman Lakes, August 30th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200830Greendrop/20200830GreendropTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list32),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group32",arg:"group32"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Cheakmus Park, August 23rd, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200823CheakamusCanyon/20200823-CheakamusTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list30),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group30",arg:"group30"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Tynehead Regional Park, August 16th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200816TyneheadRP/20200816TyneheadTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list29),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group29",arg:"group29"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Minnekhada Regional Park, Bear!, August 09th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200809MinnekhadaRP/20200809MinnekhadaTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list28),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group28",arg:"group28"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Whyte Lake, August 02nd, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200802WhyteLake/2020-08-02-Whyte-Lake-TR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list27),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group27",arg:"group27"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Brothers Creek, July 12th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200712BrothersCreek/20200712BrothersCreekTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list26),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group26",arg:"group26"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Smoke Bluffs and Mamquam River, July 5th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200705SmokeBluffsNMamquamRiver/SmokeBluffsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list25),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group25",arg:"group25"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Norvan Falls, June 28th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200628NorvanFalls/NorvanFallsTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list24),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group24",arg:"group24"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Lynn Creek and Seymour River, June 21st, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200621-Lynn-Creek-n-Seymour-River/2020-06-21-Lynn-Valley-Loop.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list23),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group23",arg:"group23"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Petgill Lake, June 14th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200614-Petgill-Lake/Petgill-Lake-20200614-TR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list22),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group22",arg:"group22"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Brohm Lake, June 07th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200607BrohmLake/20200607BrohmLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list21_5),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group21_5",arg:"group21_5"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Black Mountain, March 8th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200308BlackMnt/20200607BrohmLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list21),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group21",arg:"group21"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Eagle Bluffs, February 22nd, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200222EagleBluffs/missing.pdf","title":"Trip Report"}})]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list20),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group20",arg:"group20"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Caulfeild Trail and Lighthouse Park, February 16th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200215CaulifieldLightHouse/20200216CaulfeildTrailnLighthouseParkTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list19),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group19",arg:"group19"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Bowen Lookout, February 9th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200209BowenLookout/202029BowenLookoutTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list18),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group18",arg:"group18"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Hollyburn Peak, February 2nd, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20200202HollyburnPeak/20200202HollyburnPeakTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list17),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group17",arg:"group17"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen Lake, January 26th, 2020\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/2020012BuntzenLake/20200128BuntzenLakeTR.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list16),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group16",arg:"group16"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Burnaby Mountain, December 26th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191226BbyMnt/20191226BbyMntTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list15),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group15",arg:"group15"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Cheakamus Canyon, December 08th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191208CheakamusCanyon/20191208CheakamusCanyonTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list14),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group14",arg:"group14"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Norvan Falls, December 01st, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191201NorvanFalls/20191201NorvanFallsTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list13),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group13",arg:"group13"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Slhaney Peak, November 24th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191124SlhaneyPeak/20191124-SlhaneyPeakTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list12),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group12",arg:"group12"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Two Canyon Loop, November 10th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191110TwoCanyonLoop/20191110TwoCanyonLoop.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list11),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group11",arg:"group11"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Baden Powell, Trail to Quarry Rock, November 3rd, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191103BadenPowell/2019-11-03-Baden-Powell-Trail-to-Quarry-Rock.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list10),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group10",arg:"group10"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Bowen Island, Dorman Point and Killarney Lake, October 27th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191027BowenIsland/20191027BowenTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list9),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group9",arg:"group9"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Brothers Creek, October 13th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191013BroCreek/2019-10-13-BroCreekTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list8),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group8",arg:"group8"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Mount Baker, Lake Ann, October 6th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20191006LakeAnn/20191006LakeAnnTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list3),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group3",arg:"group3"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("High Falls Creek, September 29th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20190929HighFallsCreek/20190929HighFallsTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list1),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group1",arg:"group1"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Gold Creek Canyon, September 1st, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20190901GoldCreekCanyon/2019-09-01-GoldCreekCanyonTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list2_5),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery",value:('group2_5'),expression:"'group2_5'"}],key:img.src + index,staticClass:"thumbnail",attrs:{"data-index":index,"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Galiano Island, August 25th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20190825Galiano/20190825GalianoTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list2),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery",value:('group2'),expression:"'group2'"}],key:img.src + index,staticClass:"thumbnail",attrs:{"data-index":index,"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Ptarmigan Ridge, Mount Baker, August 17th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20190817PtarmiganRidge/2019-08-17-PtarmiganRidgeMtBakerTripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list3_5),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery",value:('group3_5'),expression:"'group3_5'"}],key:img.src + index,staticClass:"thumbnail",attrs:{"data-index":index,"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Dog Mountain and Suicide Bluffs, July 28th, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/20190728DogMnt/2019-07-28-DogMnt-Suicide-Bluffs-TripReport.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list7),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery",value:('group7'),expression:"'group7'"}],key:img.src + index,staticClass:"thumbnail",attrs:{"data-index":index,"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Buntzen Lake Hike, March 31st, 2019\n      "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/31-03-2019-Buntzen-Lake-Report.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list5),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group5",arg:"group5"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Lynn Canyon Loop, March 24th, 2019\n     "),_c('a',{staticClass:"vue-green",attrs:{"href":"img/2019-03-24-Lynn-Canyon-Report.pdf","title":"Trip Report"}},[_vm._v("Trip Report")])]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list6),function(img){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group6",arg:"group6"}],key:img.src,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"}),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.listN),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery"}],key:img.src + index,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle",staticStyle:{"margin-top":"0.6rem"}}),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.listN),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery"}],key:img.src + index,staticClass:"thumbnail",attrs:{"src":img.src}})}),0),_vm._v(" "),_c('div',{staticClass:"subtitle"}),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden"}},_vm._l((_vm.list4),function(img,index){return _c('img',{directives:[{name:"gallery",rawName:"v-gallery:group4",arg:"group4"}],key:img.src + index,staticClass:"thumbnail",attrs:{"src":img.thumbnail,"data-large":img.src}})}),0),_vm._v(" "),_c('Snow',{attrs:{"amount":50,"size":5,"active":false,"zIndex":null,"image":null,"resize":true,"wind":0,"opacity":0.8,"swing":1,"speed":1.5,"color":"#ffff00"}}),_vm._v(" "),_c('footer',{on:{"click":_vm.toBocHome}},[_c('i',{staticClass:"iconfont icon-github"}),_vm._v("GoTo Burnabyoutdoor.com, 2019, 2020, 2021, 2022, 2023")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Vuer_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_finger_mk42__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_finger_mk42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_finger_mk42__);



// 有写大图属性就取大图
var getImgSrc = function getImgSrc(el) {
  return el.dataset.large || el.src;
};

var gallery = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Vue.use(__WEBPACK_IMPORTED_MODULE_1_v_finger_mk42___default.a);
    // 所有图片地址储存位置
    var imgList = {};
    var VuerE = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__Vuer_vue__["a" /* default */]);
    // 新建实例并挂载
    var vm = new VuerE().$mount();
    // 如果没有提供 $mount 的参数，模板将被渲染为文档之外的的元素，并且你必须使用原生 DOM API 把它插入文档中。
    document.querySelector('body').appendChild(vm.$el);

    vm.swipeThreshold = options.swipeThreshold || 100;

    vm.isIndexShow = options.isIndexShow === undefined ? true : options.isIndexShow;

    vm.useCloseButton = options.useCloseButton === undefined ? true : options.useCloseButton;

    vm.preload = options.preload === undefined ? true : options.preload;

    options.loadingStyle; // TODO
    var openVuer = function openVuer(el, group) {
      return function (e) {
        var imgSrc = getImgSrc(el);
        if (group || group === 0) {
          vm.isSingle = false;
          vm.imgList = imgList[group];
          vm.isShow = true;
          vm.currentIndex = Number(e.currentTarget.dataset.index) || vm.imgList.indexOf(imgSrc);
        } else {
          vm.isSingle = true;
          vm.imgList = [imgSrc];
          vm.isShow = true;
          vm.currentIndex = 0;
        }
      };
    };
    Vue.prototype.$imgVuer = {
      close: function close() {
        vm.closeGallery.call(vm);
      },
      onIndexChange: function onIndexChange(cb) {
        // 0.16.0
        vm.$watch('currentIndex', cb);
      },
      onToggle: function onToggle(cb) {
        // 0.16.0
        vm.$watch('isShow', cb);
      },
      changeBGColor: function changeBGColor(color) {
        // 0.16.1
        vm.backgroundColor = color;
      },
      next: function next() {
        // 0.16.2
        vm.next.call(vm);
      },
      prev: function prev() {
        // 0.16.2
        vm.prev.call(vm);
      },
      getCurrentIndex: function getCurrentIndex() {
        // 0.16.2
        return vm.currentIndex;
      }
    };
    Vue.directive('gallery', {
      bind: function bind(el) {
        if (!el.src) throw '<img /> missing src';
      },

      // add update
      inserted: function inserted(el, binding) {
        // 同时兼容arg和value传分组名称
        // 加 String() 防止 0 捣乱
        var group = binding.arg || binding.value;
        el.addEventListener('click', openVuer(el, group));
        var imgSrc = getImgSrc(el);
        if (group) {
          var imgGroup = imgList[group];
          // 有分组
          if (imgGroup) {
            // 分组已定义
            imgGroup.push(imgSrc);
          } else {
            imgList[group] = [imgSrc];
          }
        } else {
          // 无分组（单张）
          // 无需储存，直接用imgSrc打开
        }
      },
      unbind: function unbind(el, binding) {
        // 调查keep alive后跳转是否触发unbind
        vm.isShow = false;
        var imgSrc = getImgSrc(el);
        var group = binding.arg || binding.value;
        el.removeEventListener('click', openVuer(el, group));
        if (group || group === 0) {
          var imgGroup = imgList[group];
          var index = imgGroup.indexOf(imgSrc);
          imgGroup.splice(index, 1);
        }
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (gallery);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t["v-finger"]=e()}(this,function(){"use strict";function t(t){return Math.sqrt(t.x*t.x+t.y*t.y)}function e(e,i){var s=function(e,i){var s=t(e)*t(i);if(0===s)return 0;var n=function(t,e){return t.x*e.x+t.y*e.y}(e,i)/s;return n>1&&(n=1),Math.acos(n)}(e,i);return function(t,e){return t.x*e.y-e.x*t.y}(e,i)>0&&(s*=-1),180*s/Math.PI}var i=function(t){this.handlers=[],this.el=t};function s(t,e){var s=new i(t);return s.add(e),s}i.prototype.add=function(t){this.handlers.push(t)},i.prototype.del=function(t){t||(this.handlers=[]);for(var e=this.handlers.length;e>=0;e--)this.handlers[e]===t&&this.handlers.splice(e,1)},i.prototype.dispatch=function(){for(var t=0,e=this.handlers.length;t<e;t++){var i=this.handlers[t];"function"==typeof i&&i.apply(this.el,arguments)}};var n=function(t,e){if(this.element="string"==typeof t?document.querySelector(t):t,this.start=this.start.bind(this),this.move=this.move.bind(this),this.end=this.end.bind(this),this.cancel=this.cancel.bind(this),function(){for(var t=navigator.userAgent,e=["Android","iPhone","SymbianOS","Windows Phone","iPad","iPod"],i=!0,s=0;s<e.length;s++)if(t.indexOf(e[s])>0){i=!1;break}return i}()){var i=this,n=!1;this.element.addEventListener("mousedown",function(t){t.preventDefault(),n=!0,t.touches=[{pageX:t.pageX,pageY:t.pageY}],i.start(t)},!1),this.element.addEventListener("mousemove",function(t){t.preventDefault(),!0===n&&(t.touches=[{pageX:t.pageX,pageY:t.pageY}],i.move(t))},!1),this.element.addEventListener("mouseup",function(t){t.preventDefault(),n=!1,t.touches=[{pageX:t.pageX,pageY:t.pageY}],t.changedTouches=[{pageX:t.pageX,pageY:t.pageY}],i.end(t)},!1),this.element.addEventListener("mouseout",function(t){t.preventDefault(),t.touches=[{pageX:t.pageX,pageY:t.pageY}],i.cancel(t)},!1)}else this.element.addEventListener("touchstart",this.start,!1),this.element.addEventListener("touchmove",this.move,!1),this.element.addEventListener("touchend",this.end,!1),this.element.addEventListener("touchcancel",this.cancel,!1);this.preV={x:null,y:null},this.pinchStartLen=null,this.zoom=1,this.isDoubleTap=!1;var h=function(){};this.rotate=s(this.element,e.rotate||h),this.touchStart=s(this.element,e.touchStart||h),this.multipointStart=s(this.element,e.multipointStart||h),this.multipointEnd=s(this.element,e.multipointEnd||h),this.pinch=s(this.element,e.pinch||h),this.swipe=s(this.element,e.swipe||h),this.tap=s(this.element,e.tap||h),this.doubleTap=s(this.element,e.doubleTap||h),this.longTap=s(this.element,e.longTap||h),this.singleTap=s(this.element,e.singleTap||h),this.pressMove=s(this.element,e.pressMove||h),this.twoFingerPressMove=s(this.element,e.twoFingerPressMove||h),this.touchMove=s(this.element,e.touchMove||h),this.touchEnd=s(this.element,e.touchEnd||h),this.touchCancel=s(this.element,e.touchCancel||h),this._cancelAllHandler=this.cancelAll.bind(this),window.removeEventListener("scroll",this._cancelAllHandler),window.addEventListener("scroll",this._cancelAllHandler),this.delta=null,this.last=null,this.now=null,this.tapTimeout=null,this.singleTapTimeout=null,this.longTapTimeout=null,this.swipeTimeout=null,this.x1=this.x2=this.y1=this.y2=null,this.preTapPosition={x:null,y:null}};n.prototype={start:function(e){if(e.touches){this.now=Date.now(),this.x1=e.touches[0].pageX,this.y1=e.touches[0].pageY,this.delta=this.now-(this.last||this.now),this.touchStart.dispatch(e,this.element),null!==this.preTapPosition.x&&(this.isDoubleTap=this.delta>0&&this.delta<=250&&Math.abs(this.preTapPosition.x-this.x1)<30&&Math.abs(this.preTapPosition.y-this.y1)<30),this.preTapPosition.x=this.x1,this.preTapPosition.y=this.y1,this.last=this.now;var i=this.preV;if(e.touches.length>1){this._cancelLongTap(),this._cancelSingleTap();var s={x:e.touches[1].pageX-this.x1,y:e.touches[1].pageY-this.y1};i.x=s.x,i.y=s.y,this.pinchStartLen=t(i),this.multipointStart.dispatch(e,this.element)}this._preventTap=!1,this.longTapTimeout=setTimeout(function(){this.longTap.dispatch(e,this.element),this._preventTap=!0}.bind(this),750)}},move:function(i){if(i.touches){var s=this.preV,n=i.touches.length,h=i.touches[0].pageX,a=i.touches[0].pageY;if(this.isDoubleTap=!1,n>1){var o=i.touches[1].pageX,r=i.touches[1].pageY,l={x:i.touches[1].pageX-h,y:i.touches[1].pageY-a};null!==s.x&&(this.pinchStartLen>0&&(i.zoom=t(l)/this.pinchStartLen,this.pinch.dispatch(i,this.element)),i.angle=e(l,s),this.rotate.dispatch(i,this.element)),s.x=l.x,s.y=l.y,null!==this.x2&&null!==this.sx2?(i.deltaX=(h-this.x2+o-this.sx2)/2,i.deltaY=(a-this.y2+r-this.sy2)/2):(i.deltaX=0,i.deltaY=0),this.twoFingerPressMove.dispatch(i,this.element),this.sx2=o,this.sy2=r}else null!==this.x2?(i.deltaX=h-this.x2,i.deltaY=a-this.y2):(i.deltaX=0,i.deltaY=0),this.pressMove.dispatch(i,this.element);this.touchMove.dispatch(i,this.element),this._cancelLongTap(),this.x2=h,this.y2=a,n>1&&i.preventDefault()}},end:function(t){if(t.changedTouches){this._cancelLongTap();var e=this;t.touches.length<2&&(this.multipointEnd.dispatch(t,this.element),this.sx2=this.sy2=null),this.x2&&Math.abs(this.x1-this.x2)>30||this.y2&&Math.abs(this.y1-this.y2)>30?(t.direction=this._swipeDirection(this.x1,this.x2,this.y1,this.y2),this.swipeTimeout=setTimeout(function(){e.swipe.dispatch(t,e.element)},0)):(this.tapTimeout=setTimeout(function(){e._preventTap||e.tap.dispatch(t,e.element),e.isDoubleTap&&(e.doubleTap.dispatch(t,e.element),clearTimeout(e.singleTapTimeout),e.isDoubleTap=!1)},0),e.isDoubleTap||(e.singleTapTimeout=setTimeout(function(){e.singleTap.dispatch(t,e.element)},250))),this.touchEnd.dispatch(t,this.element),this.preV.x=0,this.preV.y=0,this.zoom=1,this.pinchStartLen=null,this.x1=this.x2=this.y1=this.y2=null}},cancelAll:function(){this._preventTap=!0,clearTimeout(this.singleTapTimeout),clearTimeout(this.tapTimeout),clearTimeout(this.longTapTimeout),clearTimeout(this.swipeTimeout)},cancel:function(t){this.cancelAll(),this.touchCancel.dispatch(t,this.element)},_cancelLongTap:function(){clearTimeout(this.longTapTimeout)},_cancelSingleTap:function(){clearTimeout(this.singleTapTimeout)},_swipeDirection:function(t,e,i,s){return Math.abs(t-e)>=Math.abs(i-s)?t-e>0?"Left":"Right":i-s>0?"Up":"Down"},on:function(t,e){this[t]&&this[t].add(e)},off:function(t,e){this[t]&&this[t].del(e)},destroy:function(){return this.singleTapTimeout&&clearTimeout(this.singleTapTimeout),this.tapTimeout&&clearTimeout(this.tapTimeout),this.longTapTimeout&&clearTimeout(this.longTapTimeout),this.swipeTimeout&&clearTimeout(this.swipeTimeout),this.element.removeEventListener("touchstart",this.start),this.element.removeEventListener("touchmove",this.move),this.element.removeEventListener("touchend",this.end),this.element.removeEventListener("touchcancel",this.cancel),this.rotate.del(),this.touchStart.del(),this.multipointStart.del(),this.multipointEnd.del(),this.pinch.del(),this.swipe.del(),this.tap.del(),this.doubleTap.del(),this.longTap.del(),this.singleTap.del(),this.pressMove.del(),this.twoFingerPressMove.del(),this.touchMove.del(),this.touchEnd.del(),this.touchCancel.del(),this.preV=this.pinchStartLen=this.zoom=this.isDoubleTap=this.delta=this.last=this.now=this.tapTimeout=this.singleTapTimeout=this.longTapTimeout=this.swipeTimeout=this.x1=this.x2=this.y1=this.y2=this.preTapPosition=this.rotate=this.touchStart=this.multipointStart=this.multipointEnd=this.pinch=this.swipe=this.tap=this.doubleTap=this.longTap=this.singleTap=this.pressMove=this.touchMove=this.touchEnd=this.touchCancel=this.twoFingerPressMove=null,null}};var h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=.017453292519943295,o=function(t,e,i,s,n,h,a,o,r,l,u,c,p,d,m,f){this.elements=window.Float32Array?new Float32Array(16):[];var T=this.elements;T[0]=void 0!==t?t:1,T[4]=e||0,T[8]=i||0,T[12]=s||0,T[1]=n||0,T[5]=void 0!==h?h:1,T[9]=a||0,T[13]=o||0,T[2]=r||0,T[6]=l||0,T[10]=void 0!==u?u:1,T[14]=c||0,T[3]=p||0,T[7]=d||0,T[11]=m||0,T[15]=void 0!==f?f:1};o.prototype={set:function(t,e,i,s,n,h,a,o,r,l,u,c,p,d,m,f){var T=this.elements;return T[0]=t,T[4]=e,T[8]=i,T[12]=s,T[1]=n,T[5]=h,T[9]=a,T[13]=o,T[2]=r,T[6]=l,T[10]=u,T[14]=c,T[3]=p,T[7]=d,T[11]=m,T[15]=f,this},identity:function(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this},multiplyMatrices:function(t,e){var i=t.elements,s=this.elements,n=i[0],h=i[4],a=i[8],o=i[12],r=i[1],l=i[5],u=i[9],c=i[13],p=i[2],d=i[6],m=i[10],f=i[14],T=i[3],g=i[7],y=i[11],v=i[15],w=e[0],x=e[1],M=e[2],X=e[3],Y=e[4],b=e[5],_=e[6],S=e[7],L=e[8],E=e[9],P=e[10],Z=e[11],D=e[12],k=e[13],A=e[14],F=e[15];return s[0]=n*w+h*Y+a*L+o*D,s[4]=n*x+h*b+a*E+o*k,s[8]=n*M+h*_+a*P+o*A,s[12]=n*X+h*S+a*Z+o*F,s[1]=r*w+l*Y+u*L+c*D,s[5]=r*x+l*b+u*E+c*k,s[9]=r*M+l*_+u*P+c*A,s[13]=r*X+l*S+u*Z+c*F,s[2]=p*w+d*Y+m*L+f*D,s[6]=p*x+d*b+m*E+f*k,s[10]=p*M+d*_+m*P+f*A,s[14]=p*X+d*S+m*Z+f*F,s[3]=T*w+g*Y+y*L+v*D,s[7]=T*x+g*b+y*E+v*k,s[11]=T*M+g*_+y*P+v*A,s[15]=T*X+g*S+y*Z+v*F,this},_rounded:function(t,e){return e=Math.pow(10,e||15),Math.round(t*e)/e},_arrayWrap:function(t){return window.Float32Array?new Float32Array(t):t},appendTransform:function(t,e,i,s,n,h,o,r,l,u,c,p,d,m){var f=o*a,T=this._rounded(Math.cos(f)),g=this._rounded(Math.sin(f)),y=r*a,v=this._rounded(Math.cos(y)),w=this._rounded(Math.sin(y)),x=l*a,M=this._rounded(Math.cos(-1*x)),X=this._rounded(Math.sin(-1*x));return this.multiplyMatrices(this,this._arrayWrap([1,0,0,t,0,T,g,e,0,-g,T,i,0,0,0,1])),this.multiplyMatrices(this,this._arrayWrap([v,0,w,0,0,1,0,0,-w,0,v,0,0,0,0,1])),this.multiplyMatrices(this,this._arrayWrap([M*s,X*n,0,0,-X*s,M*n,0,0,0,0,1*h,0,0,0,0,1])),(u||c)&&this.multiplyMatrices(this,this._arrayWrap([this._rounded(Math.cos(u*a)),this._rounded(Math.sin(u*a)),0,0,-1*this._rounded(Math.sin(c*a)),this._rounded(Math.cos(c*a)),0,0,0,0,1,0,0,0,0,1])),(p||d||m)&&(this.elements[12]-=p*this.elements[0]+d*this.elements[4]+m*this.elements[8],this.elements[13]-=p*this.elements[1]+d*this.elements[5]+m*this.elements[9],this.elements[14]-=p*this.elements[2]+d*this.elements[6]+m*this.elements[10]),this}};var r=function(t,e,i,s,n,h){return this.a=null==t?1:t,this.b=e||0,this.c=i||0,this.d=null==s?1:s,this.tx=n||0,this.ty=h||0,this};function l(t,e,i){Object.defineProperty(t,e,{get:function(){return this["_"+e]},set:function(t){this["_"+e]=t,i()}})}function u(t,e){if(!t.___mixCSS3Transform){var i,s=["translateX","translateY","translateZ","scaleX","scaleY","scaleZ","rotateX","rotateY","rotateZ","skewX","skewY","originX","originY","originZ"],n=(i=t,"object"===("undefined"==typeof HTMLElement?"undefined":h(HTMLElement))?i instanceof HTMLElement:i&&"object"===(void 0===i?"undefined":h(i))&&null!==i&&1===i.nodeType&&"string"==typeof i.nodeName);e||s.push("perspective"),t.___mixCSS3Transform=!0,function(t,e,i){for(var s=0,n=e.length;s<n;s++)l(t,e[s],i)}(t,s,function(){var i=t.matrix3d.identity().appendTransform(t.translateX,t.translateY,t.translateZ,t.scaleX,t.scaleY,t.scaleZ,t.rotateX,t.rotateY,t.rotateZ,t.skewX,t.skewY,t.originX,t.originY,t.originZ),s=(e?"":"perspective("+t.perspective+"px) ")+"matrix3d("+Array.prototype.slice.call(i.elements).join(",")+")";n?t.style.transform=t.style.msTransform=t.style.OTransform=t.style.MozTransform=t.style.webkitTransform=s:t.transform=s}),t.matrix3d=new o,e||(t.perspective=500),t.scaleX=t.scaleY=t.scaleZ=1,t.translateX=t.translateY=t.translateZ=t.rotateX=t.rotateY=t.rotateZ=t.skewX=t.skewY=t.originX=t.originY=t.originZ=0}}return r.prototype={identity:function(){return this.a=this.d=1,this.b=this.c=this.tx=this.ty=0,this},appendTransform:function(t,e,i,s,n,h,o,r,l){if(n%360)var u=n*a,c=Math.cos(u),p=Math.sin(u);else c=1,p=0;return h||o?(h*=a,o*=a,this.append(Math.cos(o),Math.sin(o),-Math.sin(h),Math.cos(h),t,e),this.append(c*i,p*i,-p*s,c*s,0,0)):this.append(c*i,p*i,-p*s,c*s,t,e),(r||l)&&(this.tx-=r*this.a+l*this.c,this.ty-=r*this.b+l*this.d),this},append:function(t,e,i,s,n,h){var a=this.a,o=this.b,r=this.c,l=this.d;return this.a=t*a+e*r,this.b=t*o+e*l,this.c=i*a+s*r,this.d=i*o+s*l,this.tx=n*a+h*r+this.tx,this.ty=n*o+h*l+this.ty,this},initialize:function(t,e,i,s,n,h){return this.a=t,this.b=e,this.c=i,this.d=s,this.tx=n,this.ty=h,this},setValues:function(t,e,i,s,n,h){return this.a=null==t?1:t,this.b=e||0,this.c=i||0,this.d=null==s?1:s,this.tx=n||0,this.ty=h||0,this},copy:function(t){return this.setValues(t.a,t.b,t.c,t.d,t.tx,t.ty)}},u.getMatrix3D=function(t){var e={translateX:0,translateY:0,translateZ:0,rotateX:0,rotateY:0,rotateZ:0,skewX:0,skewY:0,originX:0,originY:0,originZ:0,scaleX:1,scaleY:1,scaleZ:1};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);return(new o).identity().appendTransform(e.translateX,e.translateY,e.translateZ,e.scaleX,e.scaleY,e.scaleZ,e.rotateX,e.rotateY,e.rotateZ,e.skewX,e.skewY,e.originX,e.originY,e.originZ).elements},u.getMatrix2D=function(t){var e={translateX:0,translateY:0,rotation:0,skewX:0,skewY:0,originX:0,originY:0,scaleX:1,scaleY:1};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);return(new r).identity().appendTransform(e.translateX,e.translateY,e.scaleX,e.scaleY,e.rotation,e.skewX,e.skewY,e.originX,e.originY)},{install:function(t,e){t.prototype.toJSON=function(){},t.directive("finger-test",{inserted:function(t){console.log("vFingerMK42 added")}}),t.directive("transform",{inserted:function(t){u(t)}});var i=new Map;t.directive("finger",{inserted:function(t,e){var s,h,a,o=i.get(t);void 0===o?i.set(t,new n(t,(s={},h=e.arg,a=function(t,i){return e.value(t,i)},h in s?Object.defineProperty(s,h,{value:a,enumerable:!0,configurable:!0,writable:!0}):s[h]=a,s))):o.on(e.arg,function(t,i){return e.value(t,i)})}})}}});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vue Scroller 
 * version: 2.2.4 
 * repo: https://github.com/wangdahoo/vue-scroller 
 * build: 2017-09-21 16:25:35
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("VueScroller",[],e):"object"==typeof exports?exports.VueScroller=e():t.VueScroller=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var i=n[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=4)}([function(t,e){t.exports=function(t,e,n,o){var i,r=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(i=t,r=t.default);var l="function"==typeof r?r.options:r;if(e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns),n&&(l._scopeId=n),o){var s=Object.create(l.computed||null);Object.keys(o).forEach(function(t){var e=o[t];s[t]=function(){return e}}),l.computed=s}return{esModule:i,exports:r,options:l}}},function(t,e,n){n(14);var o=n(0)(n(3),n(13),"data-v-ecaca2b0",null);t.exports=o.exports},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{fillColor:{type:String,default:"#AAA"}}}},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(5),r=o(i),a=n(6),l=o(a),s=n(10),c=o(s),_=n(9),u=o(_),f=/^[\d]+(\%)?$/,p=function(t){return"%"!=t[t.length-1]?t+"px":t},h=function(t){return f.test(t)};e.default={components:{Spinner:c.default,Arrow:u.default},props:{onRefresh:Function,onInfinite:Function,refreshText:{type:String,default:"下拉刷新"},noDataText:{type:String,default:"没有更多数据"},width:{type:String,default:"100%",validator:h},height:{type:String,default:"100%",validator:h},snapping:{type:Boolean,default:!1},snapWidth:{type:Number,default:100},snapHeight:{type:Number,default:100},animating:{type:Boolean,default:!0},animationDuration:{type:Number,default:250},bouncing:{type:Boolean,default:!0},refreshLayerColor:{type:String,default:"#AAA"},loadingLayerColor:{type:String,default:"#AAA"},cssClass:String,minContentHeight:{type:Number,default:0}},computed:{w:function(){return p(this.width)},h:function(){return p(this.height)},showInfiniteLayer:function(){var t=0;return this.content&&(t=this.content.offsetHeight),!!this.onInfinite&&t>this.minContentHeight}},data:function(){return{containerId:"outer-"+Math.random().toString(36).substring(3,8),contentId:"inner-"+Math.random().toString(36).substring(3,8),state:0,loadingState:0,showLoading:!1,container:void 0,content:void 0,scroller:void 0,pullToRefreshLayer:void 0,mousedown:!1,infiniteTimer:void 0,resizeTimer:void 0}},mounted:function(){var t=this;this.container=document.getElementById(this.containerId),this.container.style.width=this.w,this.container.style.height=this.h,this.content=document.getElementById(this.contentId),this.cssClass&&this.content.classList.add(this.cssClass),this.pullToRefreshLayer=this.content.getElementsByTagName("div")[0];var e=(0,l.default)(this.content);this.scroller=new r.default(e,{scrollingX:!1,snapping:this.snapping,animating:this.animating,animationDuration:this.animationDuration,bouncing:this.bouncing}),this.onRefresh&&this.scroller.activatePullToRefresh(60,function(){t.state=1},function(){t.state=0},function(){t.state=2,t.$on("$finishPullToRefresh",function(){setTimeout(function(){t.state=0,t.finishPullToRefresh()})}),t.onRefresh(t.finishPullToRefresh)}),this.onInfinite&&(this.infiniteTimer=setInterval(function(){var e=t.scroller.getValues(),n=(e.left,e.top);e.zoom;if(t.content.offsetHeight>0&&n+60>t.content.offsetHeight-t.container.clientHeight){if(t.loadingState)return;t.loadingState=1,t.showLoading=!0,t.onInfinite(t.finishInfinite)}},10));var n=this.container.getBoundingClientRect();this.scroller.setPosition(n.left+this.container.clientLeft,n.top+this.container.clientTop),this.snapping&&this.scroller.setSnapSize(this.snapWidth,this.snapHeight);var o=function(){return{width:t.content.offsetWidth,height:t.content.offsetHeight}},i=o(),a=i.content_width,s=i.content_height;this.resizeTimer=setInterval(function(){var e=o(),n=e.width,i=e.height;n===a&&i===s||(a=n,s=i,t.resize())},10)},destroyed:function(){clearInterval(this.resizeTimer),this.infiniteTimer&&clearInterval(this.infiniteTimer)},methods:{resize:function(){var t=this.container,e=this.content;this.scroller.setDimensions(t.clientWidth,t.clientHeight,e.offsetWidth,e.offsetHeight)},finishPullToRefresh:function(){this.scroller.finishPullToRefresh()},finishInfinite:function(t){this.loadingState=t?2:0,this.showLoading=!1,2==this.loadingState&&this.resetLoadingState()},triggerPullToRefresh:function(){this.scroller.triggerPullToRefresh()},scrollTo:function(t,e,n){this.scroller.scrollTo(t,e,n)},scrollBy:function(t,e,n){this.scroller.scrollBy(t,e,n)},touchStart:function(t){t.target.tagName.match(/input|textarea|select/i)||this.scroller.doTouchStart(t.touches,t.timeStamp)},touchMove:function(t){t.preventDefault(),this.scroller.doTouchMove(t.touches,t.timeStamp)},touchEnd:function(t){this.scroller.doTouchEnd(t.timeStamp)},mouseDown:function(t){t.target.tagName.match(/input|textarea|select/i)||(this.scroller.doTouchStart([{pageX:t.pageX,pageY:t.pageY}],t.timeStamp),this.mousedown=!0)},mouseMove:function(t){this.mousedown&&(this.scroller.doTouchMove([{pageX:t.pageX,pageY:t.pageY}],t.timeStamp),this.mousedown=!0)},mouseUp:function(t){this.mousedown&&(this.scroller.doTouchEnd(t.timeStamp),this.mousedown=!1)},getPosition:function(){var t=this.scroller.getValues();return{left:parseInt(t.left),top:parseInt(t.top)}},resetLoadingState:function(){var t=this,e=this.scroller.getValues(),n=(e.left,e.top);e.zoom,this.container,this.content;n+60>this.content.offsetHeight-this.container.clientHeight?setTimeout(function(){t.resetLoadingState()},1e3):this.loadingState=0}}}},function(t,e,n){"use strict";function o(t){o.installed||(o.installed=!0,t.component("scroller",a.default))}Object.defineProperty(e,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r=n(1),a=function(t){return t&&t.__esModule?t:{default:t}}(r),l={install:o,Scroller:a.default};void 0!==("undefined"==typeof window?"undefined":i(window))&&window.Vue&&window.Vue.use(l),e.default=l},function(t,e,n){"use strict";var o;!function(i){var r=function(){},a=function(t){var e=Date.now||function(){return+new Date},n={},o=1,i={effect:{}};return i.effect.Animate={requestAnimationFrame:function(){var e=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame,n=!!e;if(e&&!/requestAnimationFrame\(\)\s*\{\s*\[native code\]\s*\}/i.test(e.toString())&&(n=!1),n)return function(t,n){e(t,n)};var o={},i=0,r=1,a=null,l=+new Date;return function(t,e){var n=r++;return o[n]=t,i++,null===a&&(a=setInterval(function(){var t=+new Date,e=o;o={},i=0;for(var n in e)e.hasOwnProperty(n)&&(e[n](t),l=t);t-l>2500&&(clearInterval(a),a=null)},1e3/60)),n}}(),stop:function(t){var e=null!=n[t];return e&&(n[t]=null),e},isRunning:function(t){return null!=n[t]},start:function(t,r,a,l,s,c){var _=e(),u=_,f=0,p=0,h=o++;if(c||(c=document.body),h%20==0){var d={};for(var m in n)d[m]=!0;n=d}var g=function o(d){var m=!0!==d,g=e();if(!n[h]||r&&!r(h))return n[h]=null,void(a&&a(60-p/((g-_)/1e3),h,!1));if(m)for(var v=Math.round((g-u)/(1e3/60))-1,y=0;y<Math.min(v,4);y++)o(!0),p++;l&&(f=(g-_)/l)>1&&(f=1);var T=s?s(f):f;!1!==t(T,g,m)&&1!==f||!m?m&&(u=g,i.effect.Animate.requestAnimationFrame(o,c)):(n[h]=null,a&&a(60-p/((g-_)/1e3),h,1===f||null==l))};return n[h]=!0,i.effect.Animate.requestAnimationFrame(g,c),h}},i}(i),l=function(t,e){this.__callback=t,this.options={scrollingX:!0,scrollingY:!0,animating:!0,animationDuration:250,bouncing:!0,locking:!0,paging:!1,snapping:!1,zooming:!1,minZoom:.5,maxZoom:3,speedMultiplier:1,scrollingComplete:r,penetrationDeceleration:.03,penetrationAcceleration:.08};for(var n in e)this.options[n]=e[n]},s=function(t){return Math.pow(t-1,3)+1},c=function(t){return(t/=.5)<1?.5*Math.pow(t,3):.5*(Math.pow(t-2,3)+2)},_={__isSingleTouch:!1,__isTracking:!1,__didDecelerationComplete:!1,__isGesturing:!1,__isDragging:!1,__isDecelerating:!1,__isAnimating:!1,__clientLeft:0,__clientTop:0,__clientWidth:0,__clientHeight:0,__contentWidth:0,__contentHeight:0,__snapWidth:100,__snapHeight:100,__refreshHeight:null,__refreshActive:!1,__refreshActivate:null,__refreshDeactivate:null,__refreshStart:null,__zoomLevel:1,__scrollLeft:0,__scrollTop:0,__maxScrollLeft:0,__maxScrollTop:0,__scheduledLeft:0,__scheduledTop:0,__scheduledZoom:0,__lastTouchLeft:null,__lastTouchTop:null,__lastTouchMove:null,__positions:null,__minDecelerationScrollLeft:null,__minDecelerationScrollTop:null,__maxDecelerationScrollLeft:null,__maxDecelerationScrollTop:null,__decelerationVelocityX:null,__decelerationVelocityY:null,setDimensions:function(t,e,n,o){var i=this;t===+t&&(i.__clientWidth=t),e===+e&&(i.__clientHeight=e),n===+n&&(i.__contentWidth=n),o===+o&&(i.__contentHeight=o),i.__computeScrollMax(),i.scrollTo(i.__scrollLeft,i.__scrollTop,!0)},setPosition:function(t,e){var n=this;n.__clientLeft=t||0,n.__clientTop=e||0},setSnapSize:function(t,e){var n=this;n.__snapWidth=t,n.__snapHeight=e},activatePullToRefresh:function(t,e,n,o){var i=this;i.__refreshHeight=t,i.__refreshActivate=e,i.__refreshDeactivate=n,i.__refreshStart=o},triggerPullToRefresh:function(){this.__publish(this.__scrollLeft,-this.__refreshHeight,this.__zoomLevel,!0),this.__refreshStart&&this.__refreshStart()},finishPullToRefresh:function(){var t=this;t.__refreshActive=!1,t.__refreshDeactivate&&t.__refreshDeactivate(),t.scrollTo(t.__scrollLeft,t.__scrollTop,!0)},getValues:function(){var t=this;return{left:t.__scrollLeft,top:t.__scrollTop,zoom:t.__zoomLevel}},getScrollMax:function(){var t=this;return{left:t.__maxScrollLeft,top:t.__maxScrollTop}},zoomTo:function(t,e,n,o,i){var r=this;if(!r.options.zooming)throw new Error("Zooming is not enabled!");i&&(r.__zoomComplete=i),r.__isDecelerating&&(a.effect.Animate.stop(r.__isDecelerating),r.__isDecelerating=!1);var l=r.__zoomLevel;null==n&&(n=r.__clientWidth/2),null==o&&(o=r.__clientHeight/2),t=Math.max(Math.min(t,r.options.maxZoom),r.options.minZoom),r.__computeScrollMax(t);var s=(n+r.__scrollLeft)*t/l-n,c=(o+r.__scrollTop)*t/l-o;s>r.__maxScrollLeft?s=r.__maxScrollLeft:s<0&&(s=0),c>r.__maxScrollTop?c=r.__maxScrollTop:c<0&&(c=0),r.__publish(s,c,t,e)},zoomBy:function(t,e,n,o,i){var r=this;r.zoomTo(r.__zoomLevel*t,e,n,o,i)},scrollTo:function(t,e,n,o){var i=this;if(i.__isDecelerating&&(a.effect.Animate.stop(i.__isDecelerating),i.__isDecelerating=!1),null!=o&&o!==i.__zoomLevel){if(!i.options.zooming)throw new Error("Zooming is not enabled!");t*=o,e*=o,i.__computeScrollMax(o)}else o=i.__zoomLevel;i.options.scrollingX?i.options.paging?t=Math.round(t/i.__clientWidth)*i.__clientWidth:i.options.snapping&&(t=Math.round(t/i.__snapWidth)*i.__snapWidth):t=i.__scrollLeft,i.options.scrollingY?i.options.paging?e=Math.round(e/i.__clientHeight)*i.__clientHeight:i.options.snapping&&(e=Math.round(e/i.__snapHeight)*i.__snapHeight):e=i.__scrollTop,t=Math.max(Math.min(i.__maxScrollLeft,t),0),e=Math.max(Math.min(i.__maxScrollTop,e),0),t===i.__scrollLeft&&e===i.__scrollTop&&(n=!1),i.__isTracking||i.__publish(t,e,o,n)},scrollBy:function(t,e,n){var o=this,i=o.__isAnimating?o.__scheduledLeft:o.__scrollLeft,r=o.__isAnimating?o.__scheduledTop:o.__scrollTop;o.scrollTo(i+(t||0),r+(e||0),n)},doMouseZoom:function(t,e,n,o){var i=this,r=t>0?.97:1.03;return i.zoomTo(i.__zoomLevel*r,!1,n-i.__clientLeft,o-i.__clientTop)},doTouchStart:function(t,e){if(null==t.length)throw new Error("Invalid touch list: "+t);if(e instanceof Date&&(e=e.valueOf()),"number"!=typeof e)throw new Error("Invalid timestamp value: "+e);var n=this;n.__interruptedAnimation=!0,n.__isDecelerating&&(a.effect.Animate.stop(n.__isDecelerating),n.__isDecelerating=!1,n.__interruptedAnimation=!0),n.__isAnimating&&(a.effect.Animate.stop(n.__isAnimating),n.__isAnimating=!1,n.__interruptedAnimation=!0);var o,i,r=1===t.length;r?(o=t[0].pageX,i=t[0].pageY):(o=Math.abs(t[0].pageX+t[1].pageX)/2,i=Math.abs(t[0].pageY+t[1].pageY)/2),n.__initialTouchLeft=o,n.__initialTouchTop=i,n.__zoomLevelStart=n.__zoomLevel,n.__lastTouchLeft=o,n.__lastTouchTop=i,n.__lastTouchMove=e,n.__lastScale=1,n.__enableScrollX=!r&&n.options.scrollingX,n.__enableScrollY=!r&&n.options.scrollingY,n.__isTracking=!0,n.__didDecelerationComplete=!1,n.__isDragging=!r,n.__isSingleTouch=r,n.__positions=[]},doTouchMove:function(t,e,n){if(null==t.length)throw new Error("Invalid touch list: "+t);if(e instanceof Date&&(e=e.valueOf()),"number"!=typeof e)throw new Error("Invalid timestamp value: "+e);var o=this;if(o.__isTracking){var i,r;2===t.length?(i=Math.abs(t[0].pageX+t[1].pageX)/2,r=Math.abs(t[0].pageY+t[1].pageY)/2):(i=t[0].pageX,r=t[0].pageY);var a=o.__positions;if(o.__isDragging){var l=i-o.__lastTouchLeft,s=r-o.__lastTouchTop,c=o.__scrollLeft,_=o.__scrollTop,u=o.__zoomLevel;if(null!=n&&o.options.zooming){var f=u;if(u=u/o.__lastScale*n,u=Math.max(Math.min(u,o.options.maxZoom),o.options.minZoom),f!==u){var p=i-o.__clientLeft,h=r-o.__clientTop;c=(p+c)*u/f-p,_=(h+_)*u/f-h,o.__computeScrollMax(u)}}if(o.__enableScrollX){c-=l*this.options.speedMultiplier;var d=o.__maxScrollLeft;(c>d||c<0)&&(o.options.bouncing?c+=l/2*this.options.speedMultiplier:c=c>d?d:0)}if(o.__enableScrollY){_-=s*this.options.speedMultiplier;var m=o.__maxScrollTop;(_>m||_<0)&&(o.options.bouncing?(_+=s/2*this.options.speedMultiplier,o.__enableScrollX||null==o.__refreshHeight||(!o.__refreshActive&&_<=-o.__refreshHeight?(o.__refreshActive=!0,o.__refreshActivate&&o.__refreshActivate()):o.__refreshActive&&_>-o.__refreshHeight&&(o.__refreshActive=!1,o.__refreshDeactivate&&o.__refreshDeactivate()))):_=_>m?m:0)}a.length>60&&a.splice(0,30),a.push(c,_,e),o.__publish(c,_,u)}else{var g=o.options.locking?3:0,v=Math.abs(i-o.__initialTouchLeft),y=Math.abs(r-o.__initialTouchTop);o.__enableScrollX=o.options.scrollingX&&v>=g,o.__enableScrollY=o.options.scrollingY&&y>=g,a.push(o.__scrollLeft,o.__scrollTop,e),o.__isDragging=(o.__enableScrollX||o.__enableScrollY)&&(v>=5||y>=5),o.__isDragging&&(o.__interruptedAnimation=!1)}o.__lastTouchLeft=i,o.__lastTouchTop=r,o.__lastTouchMove=e,o.__lastScale=n}},doTouchEnd:function(t){if(t instanceof Date&&(t=t.valueOf()),"number"!=typeof t)throw new Error("Invalid timestamp value: "+t);var e=this;if(e.__isTracking){if(e.__isTracking=!1,e.__isDragging)if(e.__isDragging=!1,e.__isSingleTouch&&e.options.animating&&t-e.__lastTouchMove<=100){for(var n=e.__positions,o=n.length-1,i=o,r=o;r>0&&n[r]>e.__lastTouchMove-100;r-=3)i=r;if(i!==o){var a=n[o]-n[i],l=e.__scrollLeft-n[i-2],s=e.__scrollTop-n[i-1];e.__decelerationVelocityX=l/a*(1e3/60),e.__decelerationVelocityY=s/a*(1e3/60);var c=e.options.paging||e.options.snapping?4:1;Math.abs(e.__decelerationVelocityX)>c||Math.abs(e.__decelerationVelocityY)>c?e.__refreshActive||e.__startDeceleration(t):e.options.scrollingComplete()}else e.options.scrollingComplete()}else t-e.__lastTouchMove>100&&e.options.scrollingComplete();e.__isDecelerating||(e.__refreshActive&&e.__refreshStart?(e.__publish(e.__scrollLeft,-e.__refreshHeight,e.__zoomLevel,!0),e.__refreshStart&&e.__refreshStart()):((e.__interruptedAnimation||e.__isDragging)&&e.options.scrollingComplete(),e.scrollTo(e.__scrollLeft,e.__scrollTop,!0,e.__zoomLevel),e.__refreshActive&&(e.__refreshActive=!1,e.__refreshDeactivate&&e.__refreshDeactivate()))),e.__positions.length=0}},__publish:function(t,e,n,o){var i=this,r=i.__isAnimating;if(r&&(a.effect.Animate.stop(r),i.__isAnimating=!1),o&&i.options.animating){i.__scheduledLeft=t,i.__scheduledTop=e,i.__scheduledZoom=n;var l=i.__scrollLeft,_=i.__scrollTop,u=i.__zoomLevel,f=t-l,p=e-_,h=n-u,d=function(t,e,n){n&&(i.__scrollLeft=l+f*t,i.__scrollTop=_+p*t,i.__zoomLevel=u+h*t,i.__callback&&i.__callback(i.__scrollLeft,i.__scrollTop,i.__zoomLevel))},m=function(t){return i.__isAnimating===t},g=function(t,e,n){e===i.__isAnimating&&(i.__isAnimating=!1),(i.__didDecelerationComplete||n)&&i.options.scrollingComplete(),i.options.zooming&&(i.__computeScrollMax(),i.__zoomComplete&&(i.__zoomComplete(),i.__zoomComplete=null))};i.__isAnimating=a.effect.Animate.start(d,m,g,i.options.animationDuration,r?s:c)}else i.__scheduledLeft=i.__scrollLeft=t,i.__scheduledTop=i.__scrollTop=e,i.__scheduledZoom=i.__zoomLevel=n,i.__callback&&i.__callback(t,e,n),i.options.zooming&&(i.__computeScrollMax(),i.__zoomComplete&&(i.__zoomComplete(),i.__zoomComplete=null))},__computeScrollMax:function(t){var e=this;null==t&&(t=e.__zoomLevel),e.__maxScrollLeft=Math.max(e.__contentWidth*t-e.__clientWidth,0),e.__maxScrollTop=Math.max(e.__contentHeight*t-e.__clientHeight,0)},__startDeceleration:function(t){var e=this;if(e.options.paging){var n=Math.max(Math.min(e.__scrollLeft,e.__maxScrollLeft),0),o=Math.max(Math.min(e.__scrollTop,e.__maxScrollTop),0),i=e.__clientWidth,r=e.__clientHeight;e.__minDecelerationScrollLeft=Math.floor(n/i)*i,e.__minDecelerationScrollTop=Math.floor(o/r)*r,e.__maxDecelerationScrollLeft=Math.ceil(n/i)*i,e.__maxDecelerationScrollTop=Math.ceil(o/r)*r}else e.__minDecelerationScrollLeft=0,e.__minDecelerationScrollTop=0,e.__maxDecelerationScrollLeft=e.__maxScrollLeft,e.__maxDecelerationScrollTop=e.__maxScrollTop;var l=function(t,n,o){e.__stepThroughDeceleration(o)},s=e.options.snapping?4:.001,c=function(){var t=Math.abs(e.__decelerationVelocityX)>=s||Math.abs(e.__decelerationVelocityY)>=s;return t||(e.__didDecelerationComplete=!0),t},_=function(t,n,o){e.__isDecelerating=!1,e.__didDecelerationComplete&&e.options.scrollingComplete(),e.scrollTo(e.__scrollLeft,e.__scrollTop,e.options.snapping)};e.__isDecelerating=a.effect.Animate.start(l,c,_)},__stepThroughDeceleration:function(t){var e=this,n=e.__scrollLeft+e.__decelerationVelocityX,o=e.__scrollTop+e.__decelerationVelocityY;if(!e.options.bouncing){var i=Math.max(Math.min(e.__maxDecelerationScrollLeft,n),e.__minDecelerationScrollLeft);i!==n&&(n=i,e.__decelerationVelocityX=0);var r=Math.max(Math.min(e.__maxDecelerationScrollTop,o),e.__minDecelerationScrollTop);r!==o&&(o=r,e.__decelerationVelocityY=0)}if(t?e.__publish(n,o,e.__zoomLevel):(e.__scrollLeft=n,e.__scrollTop=o),!e.options.paging){e.__decelerationVelocityX*=.95,e.__decelerationVelocityY*=.95}if(e.options.bouncing){var a=0,l=0,s=e.options.penetrationDeceleration,c=e.options.penetrationAcceleration;n<e.__minDecelerationScrollLeft?a=e.__minDecelerationScrollLeft-n:n>e.__maxDecelerationScrollLeft&&(a=e.__maxDecelerationScrollLeft-n),o<e.__minDecelerationScrollTop?l=e.__minDecelerationScrollTop-o:o>e.__maxDecelerationScrollTop&&(l=e.__maxDecelerationScrollTop-o),0!==a&&(a*e.__decelerationVelocityX<=0?e.__decelerationVelocityX+=a*s:e.__decelerationVelocityX=a*c),0!==l&&(l*e.__decelerationVelocityY<=0?e.__decelerationVelocityY+=l*s:e.__decelerationVelocityY=l*c)}}};for(var u in _)l.prototype[u]=_[u];void 0!==t&&t.exports?t.exports=l:void 0!==(o=function(){return l}.call(e,n,e,t))&&(t.exports=o)}(window)},function(t,e,n){"use strict";function o(t){var e,n=window,o=document.documentElement.style;n.opera&&"[object Opera]"===Object.prototype.toString.call(opera)?e="presto":"MozAppearance"in o?e="gecko":"WebkitAppearance"in o?e="webkit":"string"==typeof navigator.cpuClass&&(e="trident");var i={trident:"ms",gecko:"Moz",webkit:"Webkit",presto:"O"}[e],r=document.createElement("div"),a=i+"Perspective",l=i+"Transform";return void 0!==r.style[a]?function(e,n,o){t.style[l]="translate3d("+-e+"px,"+-n+"px,0) scale("+o+")"}:void 0!==r.style[l]?function(e,n,o){t.style[l]="translate("+-e+"px,"+-n+"px) scale("+o+")"}:function(e,n,o){t.style.marginLeft=e?-e/o+"px":"",t.style.marginTop=n?-n/o+"px":"",t.style.zoom=o||""}}t.exports=o},function(t,e,n){e=t.exports=n(8)(),e.push([t.i,"._v-container[data-v-ecaca2b0]{-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}._v-container>._v-content[data-v-ecaca2b0]{width:100%;-webkit-transform-origin:left top;-webkit-transform:translateZ(0);-moz-transform-origin:left top;-moz-transform:translateZ(0);-ms-transform-origin:left top;-ms-transform:translateZ(0);-o-transform-origin:left top;-o-transform:translateZ(0);transform-origin:left top;transform:translateZ(0)}._v-container>._v-content>.pull-to-refresh-layer[data-v-ecaca2b0]{width:100%;height:60px;margin-top:-60px;text-align:center;font-size:16px;color:#aaa}._v-container>._v-content>.loading-layer[data-v-ecaca2b0]{width:100%;height:60px;text-align:center;font-size:16px;line-height:60px;color:#aaa;position:relative}._v-container>._v-content>.loading-layer>.no-data-text[data-v-ecaca2b0]{position:absolute;left:0;top:0;width:100%;height:100%;z-index:1}._v-container>._v-content>.loading-layer>.no-data-text[data-v-ecaca2b0],._v-container>._v-content>.loading-layer>.spinner-holder[data-v-ecaca2b0]{opacity:0;transition:opacity .15s linear;-webkit-transition:opacity .15s linear}._v-container>._v-content>.loading-layer>.no-data-text.active[data-v-ecaca2b0],._v-container>._v-content>.loading-layer>.spinner-holder.active[data-v-ecaca2b0]{opacity:1}._v-container>._v-content>.loading-layer .spinner-holder[data-v-ecaca2b0],._v-container>._v-content>.pull-to-refresh-layer .spinner-holder[data-v-ecaca2b0]{text-align:center;-webkit-font-smoothing:antialiased}._v-container>._v-content>.loading-layer .spinner-holder .arrow[data-v-ecaca2b0],._v-container>._v-content>.pull-to-refresh-layer .spinner-holder .arrow[data-v-ecaca2b0]{width:20px;height:20px;margin:8px auto 0;-webkit-transform:translateZ(0) rotate(0deg);transform:translateZ(0) rotate(0deg);transition:transform .2s linear}._v-container>._v-content>.loading-layer .spinner-holder .text[data-v-ecaca2b0],._v-container>._v-content>.pull-to-refresh-layer .spinner-holder .text[data-v-ecaca2b0]{display:block;margin:0 auto;font-size:14px;line-height:20px;color:#aaa}._v-container>._v-content>.loading-layer .spinner-holder .spinner[data-v-ecaca2b0],._v-container>._v-content>.pull-to-refresh-layer .spinner-holder .spinner[data-v-ecaca2b0]{margin-top:14px;width:32px;height:32px;fill:#444;stroke:#69717d}._v-container>._v-content>.pull-to-refresh-layer.active .spinner-holder .arrow[data-v-ecaca2b0]{-webkit-transform:translateZ(0) rotate(180deg);transform:translateZ(0) rotate(180deg)}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var o={},i=0;i<this.length;i++){var r=this[i][0];"number"==typeof r&&(o[r]=!0)}for(i=0;i<e.length;i++){var a=e[i];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(t,e,n){var o=n(0)(n(2),n(11),null,null);t.exports=o.exports},function(t,e,n){var o=n(0)(null,n(12),null,null);t.exports=o.exports},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("svg",{staticStyle:{"enable-background":"new 0 0 63.657 63.657"},attrs:{viewBox:"0 0 63.657 63.657","xml:space":"preserve",width:"512px",height:"512px"}},[n("g",[n("g",[n("g",[n("g",[n("polygon",{attrs:{points:"31.891,63.657 0.012,35.835 2.642,32.821 31.886,58.343 61.009,32.824 63.645,35.832",fill:t.fillColor}})])]),t._v(" "),n("g",[n("g",[n("rect",{attrs:{x:"29.827",width:"4",height:"60",fill:t.fillColor}})])])]),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g")]),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g"),t._v(" "),n("g")])},staticRenderFns:[]}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("svg",{staticClass:"spinner",attrs:{viewBox:"0 0 64 64"}},[n("g",{attrs:{"stroke-width":"4","stroke-linecap":"round"}},[n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(180)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:"1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(210)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:"0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(240)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(270)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(300)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(330)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(0)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(30)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(60)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(90)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(120)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",repeatCount:"indefinite"}})]),n("line",{attrs:{y1:"17",y2:"29",transform:"translate(32,32) rotate(150)"}},[n("animate",{attrs:{attributeName:"stroke-opacity",dur:"750ms",values:"1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",repeatCount:"indefinite"}})])])])},staticRenderFns:[]}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"_v-container",attrs:{id:t.containerId},on:{touchstart:function(e){t.touchStart(e)},touchmove:function(e){t.touchMove(e)},touchend:function(e){t.touchEnd(e)},mousedown:function(e){t.mouseDown(e)},mousemove:function(e){t.mouseMove(e)},mouseup:function(e){t.mouseUp(e)}}},[n("div",{staticClass:"_v-content",attrs:{id:t.contentId}},[t.onRefresh?n("div",{staticClass:"pull-to-refresh-layer",class:{active:1==t.state,"active refreshing":2==t.state}},[n("span",{staticClass:"spinner-holder"},[2!=t.state?n("arrow",{staticClass:"arrow",attrs:{fillColor:t.refreshLayerColor}}):t._e(),t._v(" "),2!=t.state?n("span",{staticClass:"text",style:{color:t.refreshLayerColor},domProps:{textContent:t._s(t.refreshText)}}):t._e(),t._v(" "),2==t.state?n("span",[t._t("refresh-spinner",[n("spinner",{style:{fill:t.refreshLayerColor,stroke:t.refreshLayerColor}})])],2):t._e()],1)]):t._e(),t._v(" "),t._t("default"),t._v(" "),t.showInfiniteLayer?n("div",{staticClass:"loading-layer"},[n("span",{staticClass:"spinner-holder",class:{active:t.showLoading}},[t._t("infinite-spinner",[n("spinner",{style:{fill:t.loadingLayerColor,stroke:t.loadingLayerColor}})])],2),t._v(" "),n("div",{staticClass:"no-data-text",class:{active:!t.showLoading&&2==t.loadingState},style:{color:t.loadingLayerColor},domProps:{textContent:t._s(t.noDataText)}})]):t._e()],2)])},staticRenderFns:[]}},function(t,e,n){var o=n(7);"string"==typeof o&&(o=[[t.i,o,""]]),o.locals&&(t.exports=o.locals);n(15)("1ca3e1c8",o,!0)},function(t,e,n){function o(t){for(var e=0;e<t.length;e++){var n=t[e],o=_[n.id];if(o){o.refs++;for(var i=0;i<o.parts.length;i++)o.parts[i](n.parts[i]);for(;i<n.parts.length;i++)o.parts.push(r(n.parts[i]));o.parts.length>n.parts.length&&(o.parts.length=n.parts.length)}else{for(var a=[],i=0;i<n.parts.length;i++)a.push(r(n.parts[i]));_[n.id]={id:n.id,refs:1,parts:a}}}}function i(){var t=document.createElement("style");return t.type="text/css",u.appendChild(t),t}function r(t){var e,n,o=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(o){if(h)return d;o.parentNode.removeChild(o)}if(m){var r=p++;o=f||(f=i()),e=a.bind(null,o,r,!1),n=a.bind(null,o,r,!0)}else o=i(),e=l.bind(null,o),n=function(){o.parentNode.removeChild(o)};return e(t),function(o){if(o){if(o.css===t.css&&o.media===t.media&&o.sourceMap===t.sourceMap)return;e(t=o)}else n()}}function a(t,e,n,o){var i=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=g(e,i);else{var r=document.createTextNode(i),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(r,a[e]):t.appendChild(r)}}function l(t,e){var n=e.css,o=e.media,i=e.sourceMap;if(o&&t.setAttribute("media",o),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var s="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!s)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var c=n(16),_={},u=s&&(document.head||document.getElementsByTagName("head")[0]),f=null,p=0,h=!1,d=function(){},m="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n){h=n;var i=c(t,e);return o(i),function(e){for(var n=[],r=0;r<i.length;r++){var a=i[r],l=_[a.id];l.refs--,n.push(l)}e?(i=c(t,e),o(i)):i=[];for(var r=0;r<n.length;r++){var l=n[r];if(0===l.refs){for(var s=0;s<l.parts.length;s++)l.parts[s]();delete _[l.id]}}}};var g=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],o={},i=0;i<e.length;i++){var r=e[i],a=r[0],l=r[1],s=r[2],c=r[3],_={id:t+":"+i,css:l,media:s,sourceMap:c};o[a]?o[a].parts.push(_):n.push(o[a]={id:a,parts:[_]})}return n}}])});
//# sourceMappingURL=vue-scroller.min.js.map

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js